import React, { useState, useRef, useEffect, useMemo } from 'react';
import { MapContainer, TileLayer, Marker, Popup, ZoomControl } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import {
  Camera,
  FileText,
  Upload,
  Globe,
  User,
  Expand,
  Info,
  ChevronDown,
  LayoutGrid,
  Square,
  Menu,
  Check,
  Medal,
  Truck,
  Image, AlertCircle, CheckCircle,
  Users,
  MapPin,
  Phone,
  Clock,
  ExternalLink,
  X,
  Eye,
  ZoomIn,
  ZoomOut,
  Banknote, // Keep Banknote icon
  ArrowLeft,
  ArrowRight,
  ShoppingCart,
  Loader2,
  Store,
  Zap,
  Facebook,
  Trash2,
  ChevronLeft,
  ChevronRight,
  File,
  Mail,
  FileText as FileTextIcon
} from 'lucide-react';
import Blog from './Blog';
import BlogPost from './BlogPost'; // Add this import
import { toPng, toJpeg } from 'html-to-image';

import { Link } from 'react-router-dom';

import * as pdfjsLib from 'pdfjs-dist';
import mammoth from 'mammoth';
import LandingPage from './LandingPage'; // Import the new LandingPage component
import { HelcimPayButton } from './HelcimPayButton';
import axios from 'axios'; // Import axios for HTTP requests
import { renderAsync } from 'docx-preview';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom';

// Import the new StudioLocationHeader component
import StudioLocationHeader from './studiolocationheader';
// Import the HubMap component
import HubMap from './HubMap';
// Import the PricingTable component
import PricingTable from './PricingTable'; // <--- ADD THIS LINE
import './ConversionProgress.css'; // On va créer ce fichier
import SEOLandingPage from './SEOLandingPage';


const CART_STORAGE_KEY = 'printshop_cart';

pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js';

// Fix pour les icônes par défaut de Leaflet - TRÈS IMPORTANT
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
});

// Define the Google Maps API Key
const GOOGLE_MAPS_API_KEY = 'AIzaSyA2BKGYCF1TOIYSZsa2pMo1LSFa3j2OeVk'; // Replace with your actual API key

// --- TRANSLATIONS OBJECT ---
const appTranslations = {
  en: {
    quickPrintHub: 'QuickPrintHub',
    onlinePrintingServices: 'Online Printing Services',
    "heroHeadline": "Print in Minutes. Pick Up Anywhere.",
    "heroSubheadline": "Send your documents by email. Get a unique code. Print at any QPH participant location.",
    "emailYourDocumentNow": "Email Your Documents Now",
    "printEmail": "Print@QuickPrintHub.com",
    "printMyDocuments": "Print my documents",
    blog: 'Blog',
    partnersignin: 'Partner Sign in',
    serviceFee: 'Service and Handling Fee',
    handling: 'Service and Handling Fee',
    new: 'NEW',
    papersize: 'Paper Size',
    partnersignin: 'Printing Partner Sign in',
    helcim: 'Pay with Card ',
    remainingBalance: "Remaining Balance", // This was already there, but its usage was for "subtotal after discount"
    prepaidCard: "Prepaid Card",
    subtotalAfterDiscount: "Subtotal After Discount",
    remainingCouponBalance: "Remaining balance of your card",
    selectcity: 'Select City',
    selectpostalcode: 'Select Postal Code',
    highQualityPrintingHeadline: 'Online Printing <span class="text-yellow-400">High Quality</span>',
    heroSubtitle: 'Market Leader in Printing. Fast home delivery and professional quality guaranteed.',
    printDocumentsButton: 'Print documents',
    printPhotosButton: 'Print my photos',
    ourServices: 'Our Services',
    documentPrinting: 'Document Printing',
    pdfDocxSupported: 'PDF supported',
    pageSelection: 'Choose pages to print',
    simplexDuplex: 'Simplex/Duplex or Simplex only',
    blackWhite: 'Black & White',
    pickupDelivery: 'Library pickup or delivery',
    startDocumentPrinting: 'Start document printing',
    photoPrinting: 'Photo Printing',
    formats: '10x15 and 15x23 cm formats',
    homeDelivery: 'Home delivery',
    tieredPricing: 'Tiered pricing based on quantity',
    professionalQuality: 'Professional quality',
    premiumPhotoPaper: 'Premium photo paper',
    startPhotoPrinting: 'Start photo printing',
    competitivePricing: 'Competitive <span class="text-red-600">Pricing</span>',
    photos10x15: 'Photos 10x15',
    standardFormat: 'Popular standard format',
    photos15x23: 'Photos 15x23',
    premiumFormat: 'Premium format',
    documents: 'Documents',
    professionalPrinting: 'Professional printing',
    marketLeaderTunisia: 'Leader in the <span class="text-red-600">Tunisian Market</span>',
    sinceCreation: 'Since our creation, Freezepix has established itself as the undisputed leader in the Tunisian printing market. We combine cutting-edge technology and exceptional customer service.',
    tunisianMarketLeader: 'Tunisian market leader',
    fastDeliveryTunisia: 'Fast delivery throughout Tunisia',
    guaranteedQuality: 'Guaranteed professional quality',
    satisfiedCustomers: 'Thousands of satisfied customers',
    proudlyTunisian: 'Proudly Tunisian',
    tunisianCompany: 'A Tunisian company revolutionizing printing with passion and innovation.',
    contactUs: 'Contact <span class="text-yellow-400">us</span>',
    contactInformation: 'Contact Information',
    selecthub: 'Select Pickup Hub',
    address: 'Address',
    phone: 'Phone',
    hours: 'Hours',
    facebook: 'Facebook',
    sendMessage: 'Send us a message',
    fullName: 'Full Name',
    email: 'Email',
    message: 'Message',
    sendMessageButton: 'Send Message',
    myCart: 'My Cart',
    discountApplied: "Discount \"{code}\" applied!",
    discount: "Discount",
    documentModalTitle: 'Document Printing',
    uploadDocuments: 'Upload your documents',
    clickOrDrag: 'Click or drag and drop your files',
    formatsAccepted: 'Formats: PDF, DOC, DOCX (max 50MB)',
    uploadErrorNoFile: 'Please upload at least one file',
    uploadErrorFileSize: 'The file exceeds the maximum size ({maxSize} MB)',
    uploadErrorFileType: 'Accepted formats: PDF',
    uploadErrorFileExists: 'This file has already been uploaded',
    uploadedFiles: 'Uploaded Files',
    processing: 'Processing...',
    printOptions: 'Print Options',
    pagesToPrint: 'Pages to print',
    allPages: 'All pages',
    specificPages: 'Specific pages',
    numberOfCopies: 'Number of copies',
    pageRange: 'Ex: 1-5, 8, 10-12',
    examplePageRange: 'Ex: 1-5, 8, 10-12',
    printType: 'Print Type',
    simplexOnly: 'Front only',
    duplex: 'Front and back',
    color: 'Color',
    blackAndWhite: 'Black and White',
    summary: 'Summary',
    documentsToPrint: 'Documents to print',
    total: 'Total',
    addToCart: 'Add to Cart',
    continue: 'Continue',
    back: 'Back',
    photoModalTitle: 'Photo Printing',
    uploadPhotos: 'Upload your photos',
    photoTooLarge: 'The photo is too large. Maximum size: {maxSize}MB',
    acceptedPhotoFormats: 'Accepted formats: JPG, PNG only',
    photoAlreadyUploaded: 'This photo has already been uploaded',
    choosePhotos: 'Choose photos',
    format: 'Format',
    quantity: 'Quantity',
    price: 'Price',
    orderSummary: 'Order Summary',
    deliveryAndInformation: 'Delivery and Information',
    deliveryMethod: 'Delivery Method',
    standardDelivery: 'Free next day delivery',
    studioPickup: 'Pickup (Free)',
    customerInformation: 'Customer Information',
    fullNameRequired: 'Full Name *',
    phoneNumberRequired: 'Phone Number *',
    emailOptional: 'Email *',
    orderNoteOptional: 'Order Note (optional)',
    shippingAddress: 'Shipping Address',
    addressRequired: 'Address *',
    cityRequired: 'City *',
    postalCodeRequired: 'Postal Code *',
    provinceGovernorateRequired: 'Province/Governorate *',
    countryRequired: 'Country *',
    payment: 'Payment',
    cashOnDelivery: 'Cash on Delivery (COD)',
    yourCartIsEmpty: 'Your cart is empty. Please add items to continue.',
    fillAllRequiredFields: 'Please fill all required fields (Full Name, Phone Number).',
    provideFullShippingAddress: 'Please provide a complete shipping address.',
    itemsOrdered: 'Items ordered',
    itemsSubtotal: 'Items Subtotal',
    delivery: 'Delivery',
    placeOrder: 'Place Order',
    sending: 'Sending...',
    viewPreview: 'View Preview',
    remove: 'Remove',
    document: 'Document',
    photo: 'Photo',
    pages: 'Pages',
    copies: 'Copies',
    type: 'Type',
    colorPrint: 'Color',
    blackAndWhitePrint: 'Black and white',
    yes: 'Yes',
    no: 'No',
    size: 'Size',
    paper: 'Paper',
    previewNotAvailable: 'Preview not available',
    step: 'Step',
    of: 'of',
    next: 'Next',
    addPhotosToCart: 'Add to Cart',
    totalPhotos: 'Total Photos',
    totalDocuments: 'Total Documents',
    totalCost: 'Total Cost',
    orderPlacedSuccessfully: 'Order placed successfully!',
    errorPlacingOrder: 'Error placing order:',
    orderConfirmation: 'Order Confirmation',
    thankYou: 'Thank you for your order!',
    orderNumber: 'Order Number:',
    weWillContactYou: 'We will contact you shortly to confirm your order and delivery details.',
    backToHome: 'Back to Home',
    close: 'Close',
    page: 'Page',
    on: 'on',
    zoom: 'Zoom',
    prevPage: 'Previous Page',
    nextPage: 'Next Page',
    delete: 'Delete',
    discountcode: 'Discount Code',
    apply: 'Apply',
    errors: { // Add error messages for discount codes
      invalid_discount: 'Invalid discount code.',
      discount_expired: 'Discount code has expired.',
      validation_failed: 'Failed to validate discount code. Please try again.',
    },
    // Add studio-related translations
    studio: {
      loading: 'Loading...',
      select_location: 'Select Location',
      pickup_locations: 'Pickup Locations',
      unnamed: 'Unnamed Hub',
      no_address: 'No address available',
      nearest_location: 'Nearest Location',
      all_locations: 'All Locations',
      no_studios: 'No hubs found for this country.',
      refresh: 'Refresh',
      failed_to_load: 'Failed to load hubs.',
      failed_to_refresh: 'Failed to refresh hubs.',
    },
    // Pricing Table Translations
    sku: 'SKU / Quantity',
    quantities: 'Quantities',
    'A4 Black and white': 'A4 Black and white',
    'A4 color': 'A4 color',
    a3: 'Legal format',
    currency: '$', // Default currency for EN
    pricingTitle: 'Pricing Table',
    printDocumentsButton: 'Print documents', // Add these for the buttons in the modal
    printPhotosButton: 'Print my photos',
    enterPrepaidCard: 'Enter Prepaid Card Code', // New translation
    prepaidCardApplied: 'Prepaid Card "{code}" applied!', // New translation
    a4: 'Letter format',
    hero: {
      step1: { title: 'Send', button: 'Email Files' },
      step2: { title: 'Receive', button: 'Qr code' },
      step3: { title: 'Print', button: 'Print' },
    },
    map: {
      legend: { title: 'Map Legend', user: 'Your position', hub: 'Closest Hub', photoHub: 'Photo Printing Hub', others: 'Other Hubs' },
      loading: 'Loading locations...',
      open: 'Open',
      closed: 'Closed',
      directions: 'Directions',
      website: 'Site',
      locations: 'Locations',
      location: 'Location',
      closeList: 'Close list',
      availableHubs: 'Available Hubs',
      onVacation: 'On vacation',
    }
  },
  es: {
    quickPrintHub: 'QuickPrintHub',
    onlinePrintingServices: 'Servicios de impresión en línea',
    "heroHeadline": "Imprima en minutos. Recoja en cualquier lugar.",
    "heroSubheadline": "Envíe sus documentos por correo electrónico. Obtenga un código único. Imprima en cualquier ubicación participante de QPH.",
    "emailYourDocumentNow": "Envíe sus documentos por correo ahora",
    "printEmail": "Print@QuickPrintHub.com",
    "printMyDocuments": "Imprimir mis documentos",
    new: 'NUEVO',
    helcim: 'Pagar con tarjeta (Helcim)',
    serviceFee: 'Tarifa de servicio y gestión',
    handling: 'Tarifa de servicio y gestión',
    papersize: 'Tamaño del papel',
    remainingBalance: "Saldo restante",
    blog: 'Blog',
    partnersignin: 'Iniciar sesión como socio de impresión',
    prepaidCard: "Tarjeta prepagada",
    subtotalAfterDiscount: "Subtotal después del descuento",
    remainingCouponBalance: "Saldo restante de su tarjeta",
    selectcity: 'Seleccionar Ciudad',
    selectpostalcode: 'Seleccionar Código Postal',
    discountcode: 'Código de descuento',
    apply: 'Aplicar',
    highQualityPrintingHeadline: 'Impresión en línea <span class="text-yellow-400">Alta Calidad</span>',
    heroSubtitle: 'Líder del mercado de impresión. Entrega rápida a domicilio y calidad profesional garantizada.',
    printDocumentsButton: 'Imprimir documentos',
    printPhotosButton: 'Imprimir mis fotos',
    ourServices: 'Nuestros Servicios',
    documentPrinting: 'Impresión de Documentos',
    pdfDocxSupported: 'PDF compatible',
    pageSelection: 'Elija las páginas para imprimir',
    simplexDuplex: 'Una cara / Dos caras',
    blackWhite: 'Blanco y Negro',
    pickupDelivery: 'Recogida en biblioteca o entrega',
    startDocumentPrinting: 'Iniciar impresión de documentos',
    photoPrinting: 'Impresión de Fotos',
    formats: 'Formatos 10x15 y 15x23 cm',
    homeDelivery: 'Entrega a domicilio',
    tieredPricing: 'Precios escalonados según la cantidad',
    professionalQuality: 'Calidad profesional',
    premiumPhotoPaper: 'Papel fotográfico premium',
    startPhotoPrinting: 'Iniciar impresión de fotos',
    competitivePricing: 'Precios <span class="text-red-600">Competitivos</span>',
    photos10x15: 'Fotos 10x15',
    standardFormat: 'Formato estándar popular',
    photos15x23: 'Formato premium',
    documents: 'Documentos',
    professionalPrinting: 'Impresión profesional',
    marketLeaderTunisia: 'Líder del mercado',
    sinceCreation: 'Desde nuestra creación, nos hemos consolidado como el líder indiscutible del mercado de impresión. Combinamos tecnología de vanguardia y un servicio al cliente excepcional.',
    tunisianMarketLeader: 'Líder del mercado',
    fastDeliveryTunisia: 'Entrega rápida a domicilio',
    guaranteedQuality: 'Calidad profesional garantizada',
    satisfiedCustomers: 'Miles de clientes satisfechos',
    proudlyTunisian: 'Orgullosamente dedicados',
    tunisianCompany: 'Una empresa que revoluciona la impresión con pasión e innovación.',
    contactUs: 'Contáctenos',
    contactInformation: 'Información de contacto',
    selecthub: 'Seleccionar centro de recogida',
    address: 'Dirección',
    phone: 'Teléfono',
    hours: 'Horarios',
    facebook: 'Facebook',
    sendMessage: 'Envíenos un mensaje',
    fullName: 'Nombre completo',
    email: 'Correo electrónico',
    message: 'Mensaje',
    sendMessageButton: 'Enviar mensaje',
    myCart: 'Mi Carrito',
    documentModalTitle: 'Impresión de Documentos',
    uploadDocuments: 'Cargue sus documentos',
    clickOrDrag: 'Haga clic o arrastre y suelte sus archivos',
    formatsAccepted: 'Formatos: PDF, DOC, DOCX (máx. 50 MB)',
    uploadErrorNoFile: 'Por favor cargue al menos un archivo',
    uploadErrorFileSize: 'El archivo excede el tamaño máximo ({maxSize} MB)',
    uploadErrorFileType: 'Formatos aceptados: PDF únicamente',
    uploadErrorFileExists: 'Este archivo ya ha sido cargado',
    uploadedFiles: 'Archivos cargados',
    processing: 'Procesando...',
    printOptions: 'Opciones de impresión',
    pagesToPrint: 'Páginas a imprimir',
    allPages: 'Todas las páginas',
    specificPages: 'Páginas específicas',
    numberOfCopies: 'Número de copias',
    pageRange: 'Ej: 1-5, 8, 10-12',
    examplePageRange: 'Ej: 1-5, 8, 10-12',
    printType: 'Tipo de impresión',
    simplexOnly: 'Solo una cara',
    duplex: 'Ambas caras',
    color: 'Color',
    blackAndWhite: 'Blanco y negro',
    summary: 'Resumen',
    discountApplied: '¡Descuento "{code}" aplicado!',
    discount: 'Descuento',
    documentsToPrint: 'Documentos a imprimir',
    total: 'Total',
    addToCart: 'Añadir al Carrito',
    continue: 'Continuar',
    back: 'Atrás',
    photoModalTitle: 'Impresión de Fotos',
    uploadPhotos: 'Cargue sus fotos',
    photoTooLarge: 'La foto es demasiado grande. Tamaño máximo: {maxSize}MB',
    acceptedPhotoFormats: 'Formatos aceptados: JPG, PNG únicamente',
    photoAlreadyUploaded: 'Esta foto ya ha sido cargada',
    choosePhotos: 'Elegir fotos',
    format: 'Formato',
    quantity: 'Cantidad',
    price: 'Precio',
    orderSummary: 'Resumen del pedido',
    deliveryAndInformation: 'Entrega e Información',
    deliveryMethod: 'Método de entrega',
    standardDelivery: 'Entrega gratuita al día siguiente',
    studioPickup: 'Recogida (Gratis)',
    customerInformation: 'Información del cliente',
    fullNameRequired: 'Nombre completo *',
    phoneNumberRequired: 'Número de teléfono *',
    emailOptional: 'Correo electrónico *',
    orderNoteOptional: 'Nota del pedido (opcional)',
    shippingAddress: 'Dirección de envío',
    addressRequired: 'Dirección *',
    cityRequired: 'Ciudad *',
    postalCodeRequired: 'Código postal *',
    provinceGovernorateRequired: 'Provincia/Estado *',
    countryRequired: 'País *',
    payment: 'Pago',
    cashOnDelivery: 'Pago contra entrega (COD)',
    yourCartIsEmpty: 'Su carrito está vacío. Por favor añada artículos para continuar.',
    fillAllRequiredFields: 'Por favor complete todos los campos obligatorios (Nombre completo, Número de teléfono).',
    provideFullShippingAddress: 'Por favor proporcione una dirección de envío completa.',
    itemsOrdered: 'Artículos pedidos',
    itemsSubtotal: 'Subtotal de artículos',
    delivery: 'Entrega',
    placeOrder: 'Realizar pedido',
    sending: 'Enviando...',
    viewPreview: 'Ver vista previa',
    remove: 'Eliminar',
    document: 'Documento',
    photo: 'Foto',
    pages: 'Páginas',
    copies: 'Copias',
    type: 'Tipo',
    colorPrint: 'Color',
    blackAndWhitePrint: 'Blanco y negro',
    yes: 'Sí',
    no: 'No',
    size: 'Tamaño',
    paper: 'Papel',
    previewNotAvailable: 'Vista previa no disponible',
    step: 'Paso',
    of: 'de',
    next: 'Siguiente',
    addPhotosToCart: 'Añadir al Carrito',
    totalPhotos: 'Total Fotos',
    totalDocuments: 'Total Documentos',
    totalCost: 'Costo Total',
    orderPlacedSuccessfully: '¡Pedido realizado con éxito!',
    errorPlacingOrder: 'Error al realizar el pedido:',
    orderConfirmation: 'Confirmación del pedido',
    thankYou: '¡Gracias por su pedido!',
    orderNumber: 'Número de pedido:',
    weWillContactYou: 'Nos pondremos en contacto con usted en breve para confirmar su pedido y los detalles de entrega.',
    backToHome: 'Volver al Inicio',
    close: 'Cerrar',
    page: 'Página',
    on: 'en',
    zoom: 'Zoom',
    prevPage: 'Página anterior',
    nextPage: 'Página siguiente',
    delete: 'Eliminar',
    errors: {
      invalid_discount: 'Código de descuento no válido.',
      discount_expired: 'El código de descuento ha expirado.',
      validation_failed: 'Error al validar el código de descuento. Por favor intente de nuevo.',
    },
    studio: {
      loading: 'Cargando...',
      select_location: 'Seleccionar ubicación',
      pickup_locations: 'Lugares de recogida',
      unnamed: 'Hub sin nombre',
      no_address: 'No hay dirección disponible',
      nearest_location: 'Ubicación más cercana',
      all_locations: 'Todas las ubicaciones',
      no_studios: 'No se encontraron hubs para este país.',
      refresh: 'Actualizar',
      failed_to_load: 'Error al cargar los hubs.',
      failed_to_refresh: 'Error al actualizar los hubs.',
    },
    // Pricing Table Translations
    sku: 'SKU / Cantidad',
    quantities: 'Cantidades',
    'A4 Black and white': 'A4 Blanco y negro',
    'A4 color': 'A4 Color',
    currency: '$',
    pricingTitle: 'Tabla de Precios',
    printDocumentsButton: 'Imprimir documentos',
    printPhotosButton: 'Imprimir mis fotos',
    enterPrepaidCard: 'Ingrese el código de la tarjeta prepagada',
    prepaidCardApplied: '¡Tarjeta prepagada "{code}" aplicada!',
    a4: 'Formato Carta',
    premiumFormat: 'Formato Premium',
    hero: {
      step1: { title: 'Enviar', button: 'Enviar archivos' },
      step2: { title: 'Recibir', button: 'Código QR' },
      step3: { title: 'Imprimir', button: 'Imprimir' },
    },
    map: {
      legend: { title: 'Leyenda del mapa', user: 'Su posición', hub: 'Hub más cercano', photoHub: 'Centro de impresión fotográfica', others: 'Otros Hubs' },
      loading: 'Cargando ubicaciones...',
      open: 'Abierto',
      closed: 'Cerrado',
      directions: 'Indicaciones',
      website: 'Sitio',
      locations: 'Ubicaciones',
      location: 'Ubicación',
      closeList: 'Cerrar lista',
      availableHubs: 'Hubs disponibles',
      onVacation: 'De vacaciones',
    }
  },
  fr: {
    quickPrintHub: 'QuickPrintHub',
    onlinePrintingServices: 'Services d\'impression en ligne',
    new: 'NOUVEAU',
    "heroHeadline": "Imprimez en quelques minutes. Récupérez partout.",
    "heroSubheadline": "Envoyez vos documents par email. Obtenez un code unique. Imprimez dans n'importe quel magasin QPH.",
    "emailYourDocumentNow": "Envoyez Votre Document par Email",
    "printEmail": "Print@QuickPrintHub.com",
    "printMyDocuments": "Imprimer mes documents",
    blog: 'Blog',
    partnersignin: 'Connexion partenaire ',
    papersize: 'Taille du papier',
    handling: 'Frais de service et de manutention',
    serviceFee: 'Frais de service et de manutention',

    a4: 'Format lettre',
    a3: 'Format Legal',
    partnersignin: 'Connexion partenaire d\'impression',
    remainingBalance: "Solde restant", // This was already there
    prepaidCard: "Carte Prépayée",
    subtotalAfterDiscount: "Sous-total Après Remise",
    remainingCouponBalance: "Solde restant de votre carte",
    selectcity: 'Sélectionner la Ville',
    selectpostalcode: 'Sélectionner le Code Postal',
    helcim: 'Payer par carte ',
    discountcode: 'Code de réduction',
    apply: 'Appliquer',
    highQualityPrintingHeadline: 'Impression En Ligne <span class="text-yellow-400">Haute Qualité</span>',
    heroSubtitle: 'Leader du marché de l\'impression. Livraison à domicile rapide et qualité professionnelle garantie.',
    printDocumentsButton: 'Imprimer documents',
    printPhotosButton: 'Imprimer mes photos',
    ourServices: 'Nos Services',
    documentPrinting: 'Impression Documents',
    pdfDocxSupported: 'PDF supporté',
    pageSelection: 'Choix des pages à imprimer',
    simplexDuplex: 'Recto/Verso ou Recto seul',
    blackWhite: 'Noir & Blanc',
    pickupDelivery: 'Retrait en bibliothèque ou livraison',
    startDocumentPrinting: 'Commencer l\'impression documents',
    photoPrinting: 'Impression Photos',
    formats: 'Formats 10x15 et 15x23 cm',
    homeDelivery: 'Livraison à domicile',
    tieredPricing: 'Tarifs dégressifs selon quantité',
    professionalQuality: 'Qualité professionnelle',
    premiumPhotoPaper: 'Papier photo premium',
    startPhotoPrinting: 'Commencer l\'impression photos',
    competitivePricing: 'Tarifs <span class="text-red-600">Compétitifs</span>',
    photos10x15: 'Photos 10x15',
    standardFormat: 'Format standard populaire',
    photos15x23: 'Format premium',
    documents: 'Documents',
    professionalPrinting: 'Impression professionnelle',
    marketLeaderTunisia: 'Leader du <span class="text-red-600">Marché Tunisien</span>',
    sinceCreation: 'Depuis notre création, Freezepix s\'est imposé comme le leader incontesté du marché de l\'impression en Tunisie. Nous combinons technologie de pointe et service client exceptionnel.',
    tunisianMarketLeader: 'Leader du marché tunisien',
    fastDeliveryTunisia: 'Livraison rapide dans toute la Tunisie',
    guaranteedQuality: 'Qualité professionnelle garantie',
    satisfiedCustomers: 'Milliers de clients satisfaits',
    proudlyTunisian: 'Fièrement Tunisien',
    tunisianCompany: 'Une entreprise tunisienne qui révolutionne l\'impression avec passion et innovation.',
    contactUs: 'Contactez-<span class="text-yellow-400">nous</span>',
    contactInformation: 'Informations de contact',
    selecthub: 'Sélectionner un centre de collecte',
    address: 'Adresse',
    phone: 'Téléphone',
    hours: 'Horaires',
    facebook: 'Facebook',
    sendMessage: 'Envoyez-nous un message',
    fullName: 'Nom complet',
    email: 'Email',
    message: 'Message',
    sendMessageButton: 'Envoyer le message',
    myCart: 'Mon Panier',
    discountApplied: "Réduction \"{code}\" appliquée !",
    discount: "Réduction",

    documentModalTitle: 'Impression de documents',
    uploadDocuments: 'Téléchargez vos documents',
    clickOrDrag: 'Cliquez ou glissez-déposez vos fichiers',
    formatsAccepted: 'Formats : PDF, DOC, DOCX (max 50MB)',
    uploadErrorNoFile: 'Veuillez télécharger au moins un fichier',
    uploadErrorFileSize: 'Le fichier dépasse la taille maximale ({maxSize} Mo)',
    uploadErrorFileType: 'Formats acceptés : PDF uniquement',
    uploadErrorFileExists: 'Ce fichier a déjà été téléchargé',
    uploadedFiles: 'Fichiers téléchargés',
    processing: 'Traitement...',
    printOptions: 'Options d\'impression',
    pagesToPrint: 'Pages à imprimer',
    allPages: 'Toutes les pages',
    specificPages: 'Pages spécifiques',
    numberOfCopies: 'Nombre de copies',
    pageRange: 'Plage de pages',
    examplePageRange: 'Ex: 1-5, 8, 10-12',
    printType: 'Type d\'impression',
    simplexOnly: 'Recto seul',
    duplex: 'Recto-verso',
    color: 'Couleur',
    blackAndWhite: 'Noir et blanc',
    summary: 'Récapitulatif',
    documentsToPrint: 'Documents à imprimer',
    total: 'Total',
    addToCart: 'Ajouter au panier',
    continue: 'Continuer',
    back: 'Retour',
    photoModalTitle: 'Impression Photos',
    uploadPhotos: 'Télécharger vos photos',
    photoTooLarge: 'La photo est trop volumineuse. Taille maximum: {maxSize}Mo',
    acceptedPhotoFormats: 'Formats acceptés: JPG, PNG uniquement',
    photoAlreadyUploaded: 'Cette photo est déjà uploadée',
    choosePhotos: 'Choisir les photos',
    format: 'Format',
    quantity: 'Quantité',
    price: 'Prix',
    orderSummary: 'Récapitulatif',
    deliveryAndInformation: 'Livraison et informations',
    deliveryMethod: 'Méthode de livraison',
    standardDelivery: 'Livraison gratuite le lendemain',
    studioPickup: 'Ramassage (Gratuit)',
    customerInformation: 'Informations client',
    fullNameRequired: 'Nom complet *',
    phoneNumberRequired: 'Numéro de téléphone *',
    emailOptional: 'Email *',
    orderNoteOptional: 'Note de commande (optionnel)',
    shippingAddress: 'Adresse de livraison',
    addressRequired: 'Adresse *',
    cityRequired: 'Ville *',
    postalCodeRequired: 'Code postal *',
    provinceGovernorateRequired: 'Province/Gouvernorat *',
    countryRequired: 'Pays *',
    payment: 'Paiement',
    cashOnDelivery: 'Paiement à la livraison (COD)',
    yourCartIsEmpty: 'Votre panier est vide. Veuillez ajouter des articles pour continuer.',
    fillAllRequiredFields: 'Veuillez remplir tous les champs obligatoires (Nom complet, Numéro de téléphone).',
    provideFullShippingAddress: 'Veuillez fournir une adresse de livraison complète.',
    itemsOrdered: 'Articles commandés',
    itemsSubtotal: 'Sous-total articles',
    delivery: 'Livraison',
    placeOrder: 'Passer la commande',
    sending: 'Envoi...',
    viewPreview: 'Voir l\'aperçu',
    remove: 'Supprimer',
    document: 'Document',
    photo: 'Photo',
    pages: 'Pages',
    copies: 'Copies',
    type: 'Type',
    colorPrint: 'Couleur',
    blackAndWhitePrint: 'Noir et blanc',
    yes: 'Oui',
    no: 'Non',
    size: 'Taille',
    paper: 'Papier',
    previewNotAvailable: 'Aperçu non disponible',
    step: 'Étape',
    of: 'sur',
    next: 'Suivant',
    addPhotosToCart: 'Ajouter au Panier',
    totalPhotos: 'Total Photos',
    totalDocuments: 'Total Documents',
    totalCost: 'Coût Total',
    orderPlacedSuccessfully: 'Commande passée avec succès !',
    errorPlacingOrder: 'Erreur lors de la commande :',
    orderConfirmation: 'Confirmation de commande',
    thankYou: 'Merci pour votre commande !',
    orderNumber: 'Numéro de commande :',
    weWillContactYou: 'Nous vous contacterons sous peu pour confirmer votre commande et les détails de livraison.',
    backToHome: 'Retour à l\'accueil',
    close: 'Fermer',
    page: 'Page',
    on: 'sur',
    zoom: 'Zoom',
    prevPage: 'Page précédente',
    nextPage: 'Page suivante',
    delete: 'Supprimer',
    errors: { // Add error messages for discount codes
      invalid_discount: 'Code de réduction invalide.',
      discount_expired: 'Le code de réduction a expiré.',
      validation_failed: 'Échec de la validation du code de réduction. Veuillez réessayer.',
    },
    // Add studio-related translations
    studio: {
      loading: 'Chargement...',
      select_location: 'Sélectionner un lieu',
      pickup_locations: 'Lieux de retrait',
      unnamed: 'hub sans nom',
      no_address: 'Aucune adresse disponible',
      nearest_location: 'Lieu le plus proche',
      all_locations: 'Tous les lieux',
      no_studios: 'Aucun hub trouvé pour ce pays.',
      refresh: 'Actualiser',
      failed_to_load: 'Échec du chargement des hubs.',
      failed_to_refresh: 'Échec de l\'actualisation des hubs.',
    },
    // Pricing Table Translations
    sku: 'Référence / Quantité',
    quantities: 'Quantités',
    'A4 Black and white': 'A4 Noir et blanc',
    'A4 color': 'A4 Couleur',
    currency: 'TND',
    pricingTitle: 'Tableau des Prix',
    printDocumentsButton: 'Imprimer documents',
    printPhotosButton: 'Imprimer mes photos',
    enterPrepaidCard: 'Entrez le code de la carte prépayée',
    prepaidCardApplied: 'Carte prépayée "{code}" appliquée !',
    premiumFormat: 'Format premium',
    hero: {
      step1: { title: 'Envoyer', button: 'Envoyer Documents' },
      step2: { title: 'Recevoir', button: 'Code QR' },
      step3: { title: 'Imprimer', button: 'Imprimer' },
    },
    map: {
      legend: { title: 'Légende', user: 'Votre position', hub: 'Centre le plus proche', photoHub: 'Centre d\'impression photo', others: 'Autres centres' },
      loading: 'Chargement des lieux...',
      open: 'Ouvert',
      closed: 'Fermé',
      directions: 'Itinéraire',
      website: 'Site',
      locations: 'Lieux',
      location: 'Lieu',
      closeList: 'Fermer la liste',
      availableHubs: 'Centres disponibles',
      onVacation: 'En vacances',
    }
  },
};

// Inside App.jsx, near your pricing object
// Complete Canadian tax rates in App.jsx
const canadianTaxRates = {
  // HST Provinces (Harmonized Sales Tax)
  'Ontario': { gst: 0.13, pst: 0, type: 'hst' }, // 13% HST
  'Nova Scotia': { gst: 0.15, pst: 0, type: 'hst' }, // 15% HST
  'New Brunswick': { gst: 0.15, pst: 0, type: 'hst' }, // 15% HST
  'Newfoundland and Labrador': { gst: 0.15, pst: 0, type: 'hst' }, // 15% HST
  'Prince Edward Island': { gst: 0.15, pst: 0, type: 'hst' }, // 15% HST

  // GST + PST/QST Provinces
  'Quebec': { gst: 0.05, pst: 0.09975, type: 'gst_pst' }, // 5% GST + 9.975% QST
  'British Columbia': { gst: 0.05, pst: 0.07, type: 'gst_pst' }, // 5% GST + 7% PST
  'Manitoba': { gst: 0.05, pst: 0.07, type: 'gst_pst' }, // 5% GST + 7% PST
  'Saskatchewan': { gst: 0.05, pst: 0.06, type: 'gst_pst' }, // 5% GST + 6% PST

  // GST Only
  'Alberta': { gst: 0.05, pst: 0, type: 'gst_only' }, // 5% GST only

  // Territories (GST only)
  'Northwest Territories': { gst: 0.05, pst: 0, type: 'gst_only' }, // 5% GST only
  'Nunavut': { gst: 0.05, pst: 0, type: 'gst_only' }, // 5% GST only
  'Yukon': { gst: 0.05, pst: 0, type: 'gst_only' }, // 5% GST only
};


const App = () => {
  const [showLandingPage, setShowLandingPage] = useState(false); // Changed to false by default
  const [paymentMethod, setPaymentMethod] = useState('cash_on_delivery');
  const [isLanguageDropdownOpen, setIsLanguageDropdownOpen] = useState(false);
  const [isDocumentModalOpen, setIsDocumentModalOpen] = useState(false); // Changed to false by default
  const [isPhotoModalOpen, setIsPhotoModalOpen] = useState(false);
  const [isCartModalOpen, setIsCartModalOpen] = useState(false);
  const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);
  const [previewItem, setPreviewItem] = useState(null);
  const [previewPages, setPreviewPages] = useState([]);
  const [currentPreviewPage, setCurrentPreviewPage] = useState(0);
  const [previewZoom, setPreviewZoom] = useState(1);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [activeModal, setActiveModal] = useState(null);
  const [cart, setCart] = useState([]);
  const [currency, setCurrency] = useState('$');
  const [cartItems, setCartItems] = useState([]);
  const [documentInfo, setDocumentInfo] = useState({
    totalPages: 0,
    fileName: '',
    fileSize: 0,
    fileType: ''
  });
  const [uploadProgress, setUploadProgress] = useState(0);
  const [isUploading, setIsUploading] = useState(false);
  const [uploadError, setUploadError] = useState('');
  const [isDragOver, setIsDragOver] = useState(false);
  const [isProcessingOrder, setIsProcessingOrder] = useState(false); // Keep this for overall app state if needed
  const [orderError, setOrderError] = useState(null);
  const [orderSuccess, setOrderSuccess] = useState(false);
  const [orderNumber, setOrderNumber] = useState(null); // To store the order number after successful submission
  const [isLoading, setIsLoading] = useState(false);
  const [selectedCountryFromLanding, setSelectedCountryFromLanding] = useState('canada'); // Default to Canada
  const [selectedRegion, setSelectedRegion] = useState('Ontario'); // Default to Ontario for Canada

  // --- NEW STATE FOR STUDIO PICKUP ---
  const [selectedStudio, setSelectedStudio] = useState(null);
  // --- END NEW STATE ---

  // --- DISCOUNT CODE STATES ---
  const [discountCode, setDiscountCode] = useState('');
  const [discountError, setDiscountError] = useState('');
  const [appliedDiscount, setAppliedDiscount] = useState(null); // Stores the validated discount object
  // --- END DISCOUNT CODE STATES ---

  // --- PRICING MODAL STATE ---
  const [isPricingModalOpen, setIsPricingModalOpen] = useState(false); // <--- ADD THIS LINE
  // --- END PRICING MODAL STATE ---
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  // city data
  // City and postal code data
  const LOCATION_DATA = {
    tunisia: {
      sousse: { // This can represent the Governorate/Province
        cities: { // This object will map city/locality names to their postal codes
          'Akouda': '4042',
          'Chatt Meriem': '4042',
          'Cité du Dispensaire': '4042',
          'Cité Ecole Superieure': '4042',
          'Cité Ejjamaa': '4042',
          'Halg El Menjel': '4042',
          'Tantana': '4042',
          'Bou Ficha': '4010',
          'Cité 20 Mars': '4010',
          'Cité Erriadh (Bouficha)': '4010', // Clarify if names are duplicated
          'Cité Ettahrir (Bouficha)': '4010',
          'Cité Ezzouhour (Bouficha)': '4010',
          'Cité Hached (Bouficha)': '4010',
          'Cité Militaire (Bouficha)': '4010',
          'Cité Snit': '4010',
          'Essalloum': '4010',
          'Lenderia': '4010',
          'Oued El Kharroub': '4010',
          'Sidi Khelifa': '4082',
          'Sidi Mtir': '4010',
          'Sidi Said': '4010',
          'Ain Medheker': '4095',
          'Chegarnia': '4034',
          'Cité 7 Novembre (Enfidha)': '4030',
          'Cité Cimenterie': '4030',
          'Cité de l\'action': '4030',
          'Cité El Bidhane': '4030',
          'Cité El Yasmine': '4030',
          'Cité Environnement': '4030',
          'Cité Erriadh (Enfidha)': '4030',
          'Cité Essalem': '4030',
          'Cité Ettahrir (Enfidha)': '4030',
          'Cité Ezzayatine': '4030',
          'Cité Hached (Enfidha)': '4030',
          'Cité Mohamed Ali': '4030',
          'Dhehaibia': '4030',
          'El Frada (Enfidha)': '4030',
          'El Ghoualif': '4030',
          'El Ghouilet': '4030',
          'Enfidha': '4030',
          'Essafha': '4030',
          'Essmaidia': '4030',
          'Grimit Est': '4030',
          'Grimit Ouest': '4030',
          'Hicher': '4030',
          'Menzel Bel Ouaer': '4032',
          'Menzel Fateh': '4030',
          'Methalithe': '4030',
          'Mrabet Hached': '4030',
          'Ouled Abdallah': '4030',
          'Ouled Bellil': '4030',
          'Ouled Mohamed': '4030',
          'Sidi Saidane': '4030',
          'Takrouna': '4030',
          'Cité de la Plage 2': '4017',
          'Cité Ennarjes 1': '4017',
          'Cité Ennarjes 2': '4017',
          'Cité Ezzitouna 1': '4089',
          'Cité Ezzitouna 2': '4089',
          'Cité Jaouhara (Hammam Sousse)': '4017',
          'Cité Presidentielle': '4089',
          'El Kantaoui': '4089',
          'Hammam Sousse': '4011',
          'Hammam Sousse Gharbi': '4017',
          'Hergla': '4012',
          'Souayeh': '4012',
          'Belaoum': '4060',
          'Chiab': '4063',
          'Cité Bir Chemsi': '4060',
          'Cité Bir Hlaoua': '4060',
          'Cité Chargui (Kalaa Kebira)': '4060',
          'Cité Commerciale': '4060',
          'Cité El Bassatine': '4060',
          'Cité El Intilaka': '4060',
          'Cité El Jebs': '4060',
          'Cité El Mansoura': '4060',
          'Cité Ennouzha 1': '4060',
          'Cité Ennouzha 2': '4060',
          'Cité Fadden Aoun': '4060',
          'Cité Nouvelle': '4060',
          'Cité Sidi Zaied': '4060',
          'Cité Zone des Metiers': '4060',
          'El Kraria': '4060',
          'Kalaa El Kebira': '4060',
          'Kalaa El Kebira Ksar': '4062',
          'Ouled Lesseoud': '4060',
          'Cité Chragui (Kalaa Seghira)': '4021',
          'Cité El Manezeh': '4021',
          'Cité Khazzen El Ma': '4021',
          'Ennagr': '4021',
          'Kalaa Essghira': '4021',
          'Oued Laya': '4021',
          'Blelma': '4020',
          'El Bechachma': '4020',
          'Kondar': '4020',
          'Ouled Ameur': '4020',
          'Ouled El Abed': '4020',
          'Tarhouna': '4020',
          'Beni Rabia': '4015',
          'Chihia': '4014',
          'Cité Cimetiere': '4015',
          'Cité Dar Esseghair': '4015',
          'Cité Ecole Primaire': '4015',
          'Cité El Mansour': '4015',
          'Cité Hedi Gachacha': '4015',
          'Cité Rached El Ouertani': '4015',
          'Cité Slama': '4015',
          'El Borjine': '4015',
          'El Frada (Msaken)': '4015',
          'El Knaies': '4014',
          'Messadine': '4013',
          'Moureddine': '4033',
          'Msaken': '4070',
          'Msaken El Gueblia': '4099',
          'Msaken Hai Jedid': '4024',
          'Cité Ibn Khaldoun (Sidi Bou Ali)': '4040',
          'El Aitha': '4040',
          'El Alouj': '4040',
          'El Araydhia': '4040',
          'El Mhedhba': '4040',
          'Essad Nord': '4045',
          'Essad Sud': '4040',
          'Kenana': '4040',
          'Menzel Gare': '4043',
          'Ouriemma': '4040',
          'Sidi Bou Ali': '4040',
          'El Mouissette': '4025',
          'Ghabghoub': '4025',
          'Kroussia': '4026',
          'Ouled Ali B Hani': '4025',
          'Ouled Alouene': '4025',
          'Ouled Amor': '4025',
          'Ouled Boubaker': '4025',
          'Ouled El Kbaier': '4025',
          'Ouled El Khechine': '4025',
          'Sidi El Heni': '4025',
          'Zerdoub': '4025',
          'Cité Batiments': '4061',
          'Cité Ben Aleya': '4061',
          'Cité de la Steg': '4051',
          'Cité El Ghoudrane': '4061',
          'Cité Sahloul': '4054',
          'Cité Sidi Abdelhamid': '4061',
          'Cité Sidi Daher': '4051',
          'Khezama Ouest': '4071',
          'Sahloul': '4054',
          'Sousse Ibn Khaldoun': '4061',
          'Sousse Khezama': '4051',
          'Cité Cheminots': '4000',
          'Cité Cnrps': '4000',
          'Cité Garde Nationale': '4000',
          'Cité Hached (Sousse Medina)': '4000',
          'Cité Hadrumette': '4000',
          'Cité Jaouhara (Sousse Medina)': '4000',
          'Cité Khedher': '4000',
          'Cité Militaire (Sousse Medina)': '4000',
          'Cité Rizzi': '4000',
          'Cité Sprols': '4000',
          'Sousse': '4000',
          'Sousse Corniche': '4059',
          'Cité 7 Novembre 3': '4041',
          'Cité Sinan Pacha': '4041',
          'Ksibet Sousse': '4041',
          'Sousse Ezzouhour': '4031',
          'Sousse Riadh': '4023',
          'Thrayette': '4041',
          'Zaouiet Sousse': '4081',
        },
        // No need for a separate postalCodes array if they are linked to cities
        postalCodes: [] // Keep empty or remove if not used elsewhere
      }
    },
    canada: {
      quebec: {
        cities: [
          'Montreal',
          'Quebec City',
          'Laval',
          'Gatineau',
          'Longueuil',
          'Sherbrooke',
          'Saguenay',
          'Trois-Rivières',
          'Terrebonne',
          'Saint-Jean-sur-Richelieu'
        ],
        postalCodes: [
          'H1A', 'H1B', 'H1C', 'H1E', 'H1G', 'H1H', 'H1J', 'H1K', 'H1L', 'H1M',
          'H1N', 'H1P', 'H1R', 'H1S', 'H1T', 'H1V', 'H1W', 'H1X', 'H1Y', 'H1Z',
          'H2A', 'H2B', 'H2C', 'H2E', 'H2G', 'H2H', 'H2J', 'H2K', 'H2L', 'H2M',
          'H2N', 'H2P', 'H2R', 'H2S', 'H2T', 'H2V', 'H2W', 'H2X', 'H2Y', 'H2Z',
          'H3A', 'H3B', 'H3C', 'H3E', 'H3G', 'H3H', 'H3J', 'H3K', 'H3L', 'H3M',
          'H3N', 'H3P', 'H3R', 'H3S', 'H3T', 'H3V', 'H3W', 'H3X', 'H3Y', 'H3Z',
          'H4A', 'H4B', 'H4C', 'H4E', 'H4G', 'H4H', 'H4J', 'H4K', 'H4L', 'H4M',
          'H4N', 'H4P', 'H4R', 'H4S', 'H4T', 'H4V', 'H4W', 'H4X', 'H4Y', 'H4Z'
        ]
      },
      ontario: { // Added Ontario with Toronto as a city
        cities: [
          'Toronto',
          'Ottawa',
          'Mississauga',
          'Brampton',
          'Hamilton',
          'London',
          'Markham',
          'Vaughan',
          'Kitchener',
          'Windsor'
        ],
        postalCodes: [
          'M1B', 'M1C', 'M1E', 'M1G', 'M1H', 'M1J', 'M1K', 'M1L', 'M1M', 'M1N',
          'M1P', 'M1R', 'M1S', 'M1T', 'M1V', 'M1W', 'M1X', 'M2J', 'M2K', 'M2L',
          'M2M', 'M2N', 'M2P', 'M2R', 'M3A', 'M3B', 'M3C', 'M3H', 'M3J', 'M3K',
          'M3L', 'M3M', 'M3N', 'M4A', 'M4B', 'M4C', 'M4E', 'M4G', 'M4H', 'M4J',
          'M4K', 'M4L', 'M4M', 'M4N', 'M4P', 'M4R', 'M4S', 'M4T', 'M4V', 'M4W',
          'M4X', 'M4Y', 'M5A', 'M5B', 'M5C', 'M5E', 'M5G', 'M5H', 'M5J', 'M5K',
          'M5L', 'M5M', 'M5N', 'M5P', 'M5R', 'M5S', 'M5T', 'M5V', 'M5W', 'M5X',
          'M6A', 'M6B', 'M6C', 'M6E', 'M6G', 'M6H', 'M6J', 'M6K', 'M6L', 'M6M',
          'M6N', 'M6P', 'M6R', 'M6S', 'M7A', 'M7R', 'M7Y', 'M8V', 'M8W', 'M8X',
          'M8Y', 'M8Z', 'M9A', 'M9B', 'M9C', 'M9L', 'M9M', 'M9N', 'M9P', 'M9R',
          'M9V', 'M9W'
        ]
      }
    }
  };

  // memory files

  const fileDataMap = useRef(new Map()); // This Map will store the actual File objects or base64 strings

  // --- LANGUAGE STATE AND HELPER ---
  const [currentLanguage, setCurrentLanguage] = useState('en'); // Default to English
  const languageDropdownRef = useRef(null);

  const handleLanguageChange = (lang) => {
    setCurrentLanguage(lang);
    sessionStorage.setItem('selectedLanguage', lang);
  };

  const mobileMenuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      // Pour le dropdown de langue
      if (languageDropdownRef.current &&
        !languageDropdownRef.current.contains(event.target)) {
        setIsLanguageDropdownOpen(false);
      }

      // Pour le menu mobile
      if (mobileMenuRef.current &&
        !mobileMenuRef.current.contains(event.target)) {
        // Vérifier si le clic n'est pas sur le bouton hamburger
        const hamburgerButton = document.querySelector('[aria-label="Menu mobile"], button svg[w-6][h-6]');
        if (!hamburgerButton?.contains(event.target)) {
          setIsMobileMenuOpen(false);
        }
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // In App.jsx
  useEffect(() => {
    // This effect runs when showLandingPage changes, or on initial mount
    if (!showLandingPage) { // Only try to set language if landing page is no longer shown
      const savedLanguage = sessionStorage.getItem('selectedLanguage');
      if (savedLanguage) {
        setCurrentLanguage(savedLanguage);
      }
    }
  }, [showLandingPage]); // Dependency on showLandingPage

  const getTranslatedText = (key, replacements = {}) => {
    const getNestedValue = (obj, path) => {
      return path.split('.').reduce((acc, part) => acc && acc[part], obj);
    };

    let text = getNestedValue(appTranslations[currentLanguage], key) ||
      getNestedValue(appTranslations['en'], key) ||
      key;

    for (const placeholder in replacements) {
      if (typeof text === 'string') {
        text = text.replace(`{${placeholder}}`, replacements[placeholder]);
      }
    }
    return text;
  };
  // --- END LANGUAGE STATE AND HELPER ---


  const captureSourceUrl = () => {
    const sourceUrl = document.referrer || window.location.href;
    if (!sessionStorage.getItem('sourceVisitUrl')) {
      sessionStorage.setItem('sourceVisitUrl', sourceUrl);
    }
    return sessionStorage.getItem('sourceVisitUrl');
  };

  useEffect(() => {
    // Set default country and currency for Canada
    setSelectedCountryFromLanding('canada');
    setCurrency('$');
    // Set default region for Canada (e.g., Ontario)
    setSelectedRegion('Ontario');
    sessionStorage.setItem('selectedCountry', 'canada');
    sessionStorage.setItem('selectedRegion', 'Ontario'); // Store default region
    sessionStorage.setItem('selectedLanguage', 'en'); // Store default language
    setCurrentLanguage('en'); // Ensure language is set to English

  }, []); // Run only once on component mount

  useEffect(() => {
    captureSourceUrl();
  }, []);

  const [pricing, setPricing] = useState(null);

  // 2. Update the useEffect that fetches pricing
  useEffect(() => {
    const fetchPricing = async () => {
      try {
        const selectedCountry = sessionStorage.getItem('selectedCountry') || 'canada';
        const countryCode = selectedCountry === 'tunisia' ? 'TN' : 'CA';

        const response = await fetch(`https://freezepix-database-server-c95d4dd2046d.herokuapp.com/api/pricing/current/${countryCode}`);
        if (response.ok) {
          const pricingData = await response.json();
          setPricing(pricingData);
        } else {
          // Fallback to default pricing structure
          setPricing(getDefaultPricing());
        }
      } catch (error) {
        console.error('Error fetching pricing:', error);
        setPricing(getDefaultPricing());
      }
    };

    fetchPricing();
  }, []);

  // 3. Add this helper function for default pricing
  const getDefaultPricing = () => ({
    documents: {
      a4: {
        black_white: {
          price_per_page: 0.50,
          tiers: { '1-24': 0.50, '25-74': 0.50, '75+': 0.50 }
        },
        color: {
          price_per_page: 1.00,
          tiers: { '1-24': 1.00, '25-74': 1.00, '75+': 1.00 }
        }
      },
      a3: {
        black_white: {
          price_per_page: 1.50,
          tiers: { '1-24': 1.50, '25-74': 1.50, '75+': 1.50 }
        },
        color: {
          price_per_page: 3.00,
          tiers: { '1-24': 3.00, '25-74': 3.00, '75+': 3.00 }
        }
      }
    },
    photos: {
      '10x15': {
        price_per_photo: 2.50,
        tiers: { '1-24': 2.50, '25-74': 2.00, '75+': 1.50 }
      },
      '15x23': {
        price_per_photo: 3.50,
        tiers: { '1-24': 3.50, '25-74': 3.00, '75+': 2.50 }
      }
    },
    services: {
      spiral_binding: 5.00,
      lamination: 2.00,
      urgent_processing: 10.00
    }
  });

  // --- DISCOUNT CODE LOGIC ---
  const fetchShopifyPriceRules = async () => {
    console.log('Fetching price rules...');
    try {
      const response = await axios.get('https://freezepix-database-server-c95d4dd2046d.herokuapp.com/api/price-rules');
      console.log('Price rules response:', response);

      if (response.data.price_rules && response.data.price_rules.length > 0) {
        console.log('Found price rules:', response.data.price_rules.length);
        console.log('First rule example:', response.data.price_rules[0]);
        return response.data.price_rules;
      } else {
        console.log('No price rules found.');
        return [];
      }
    } catch (error) {
      console.error('Error fetching price rules:', error);
      if (error.response) {
        console.error('Response status:', error.response.status);
        console.error('Response data:', error.response.data);
      }
      return [];
    }
  };

  const handleDiscountCode = async (value) => {
    const upperValue = value.toUpperCase();
    setDiscountCode(upperValue);
    setDiscountError(''); // Clear previous errors
    setAppliedDiscount(null); // Clear previously applied discount

    // Clear if empty
    if (!upperValue) {
      return;
    }

    // Don't validate until code is at least 3 characters (or whatever minimum length you prefer)
    if (upperValue.length < 3) {
      setDiscountError('Discount code too short.'); // Add a specific message
      return;
    }

    setIsLoading(true); // Use a local loading state for discount validation if preferred, or the global one

    try {
      // Simulate network delay for better UX feedback
      await new Promise(resolve => setTimeout(resolve, 500));

      // Get the selected country from sessionStorage
      const selectedCountry = sessionStorage.getItem('selectedCountry');
      let countryCode = '';
      if (selectedCountry === 'canada') {
        countryCode = 'CA';
      } else if (selectedCountry === 'tunisia') {
        countryCode = 'TN';
      }
      // Add more country mappings if needed (e.g., 'united states' -> 'US')

      const response = await axios.post('https://freezepix-database-server-c95d4dd2046d.herokuapp.com/api/discount-codes/validate', {
        code: upperValue,
        country: countryCode // Pass the country for restriction check
      });

      if (response.data.isValid) {
        const discountData = response.data;
        // Store the validated discount object
        setAppliedDiscount({
          title: discountData.code, // Using 'code' as 'title' for consistency with Shopify structure if needed
          value: discountData.value,
          valueType: discountData.valueType,
          description: discountData.description,
        });
        setDiscountError('');
      } else {
        // This block might not be reached if the server sends 4xx status for invalid codes
        setDiscountError(getTranslatedText('errors.invalid_discount'));
        setDiscountCode(''); // Clear the input if invalid
      }

    } catch (error) {
      console.error('Error validating discount code:', error);
      if (error.response && error.response.data && error.response.data.error) {
        setDiscountError(error.response.data.error); // Display specific error from backend
      } else {
        setDiscountError(getTranslatedText('errors.validation_failed'));
      }
      setDiscountCode(''); // Clear the input on validation failure
    } finally {
      setIsLoading(false);
    }
  };

  const readFileAsBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  };

  const addToCart = async (order) => {
    if (order.type === "document") {
      for (const docItem of order.items) {
        const newCartItemId = Date.now() + Math.random();

        // Use processed file if conversion happened
        const fileToUse = docItem.processedFile || docItem.originalFile;
        let base64Data = docItem.base64;

        if (!base64Data && fileToUse) {
          base64Data = await readFileAsBase64(fileToUse);
        }

        fileDataMap.current.set(newCartItemId, {
          base64: base64Data,
          originalFile: fileToUse,
          wasConverted: docItem.wasConverted || false
        });

        setCartItems(prevItems => [
          ...prevItems,
          {
            cartItemId: newCartItemId,
            type: "document",
            file: {
              name: docItem.name,
              totalPages: docItem.pages,
              pagesSelected: docItem.pages,
              previewUrl: docItem.previewUrl,
              previewPages: docItem.previewPages,
              fileType: docItem.wasConverted ? 'application/pdf' : docItem.fileType
            },
            options: docItem.options,
            wasConverted: docItem.wasConverted || false
          }
        ]);
      }
    } else if (order.type === "photo") {
      for (const photoItem of order.items) {
        const newCartItemId = Date.now() + Math.random();

        // Ensure we have base64 data for photos too
        let base64Data = photoItem.base64;
        if (!base64Data && photoItem.originalFile) {
          base64Data = await readFileAsBase64(photoItem.originalFile);
        }

        fileDataMap.current.set(newCartItemId, {
          base64: base64Data,
          originalFile: photoItem.originalFile
        });

        setCartItems(prevItems => [
          ...prevItems,
          {
            cartItemId: newCartItemId,
            type: "photo",
            photo: {
              name: photoItem.name,
              url: photoItem.url,
              size: photoItem.options.size
            },
            options: photoItem.options,
          }
        ]);
      }
    }
  };





  const removeFromCart = (cartItemId) => {
    setCartItems(prevItems => prevItems.filter(item => item.cartItemId !== cartItemId));
  };

  const clearCart = () => {
    setCartItems([]);
    localStorage.removeItem(CART_STORAGE_KEY);
    fileDataMap.current.clear(); // Clear the in-memory map

  };



  const [printOptions, setPrintOptions] = useState({
    pageSelection: 'all',
    pageRange: '',
    sides: 'duplex',
    color: 'bw',
    copies: 1
  });

  const [deliveryMethod, setDeliveryMethod] = useState('express'); // Default to 'express' (pickup)
  const [customerInfo, setCustomerInfo] = useState({
    name: '',
    phone: '',
    email: '',
    notes: '',
    shippingAddress: {
      firstName: '',
      lastName: '',
      address: '',
      city: '',
      postalCode: '',
      country: 'Canada', // Default to Canada
      province: 'Ontario', // Default to Ontario
      state: '',
      governorate: ''
    },
    billingAddress: {
      firstName: '',
      lastName: '',
      address: '',
      city: '',
      postalCode: '',
      country: 'Canada', // Default to Canada
      province: 'Ontario', // Default to Ontario
      state: '',
      governorate: ''
    },
    paymentMethod: 'cash_on_delivery' // Default to prepaid_card (Helcim)
  });

  const removeFile = () => {
    setUploadedFile(null);
    setDocumentInfo({
      totalPages: 0,
      fileName: '',
      fileSize: 0,
      fileType: ''
    });
    setUploadProgress(0);
    setUploadError('');
  };


  const Header = () => {
    const mobileMenuRef = useRef(null);
    const languageDropdownRef = useRef(null);

    const languageLabels = { en: 'EN', fr: 'FR', es: 'ES' };
    const languageNames = { en: 'English', fr: 'Français', es: 'Español' };

    const handleLanguageChange = (lang) => {
      setCurrentLanguage(lang);
      sessionStorage.setItem('selectedLanguage', lang);
      setIsLanguageDropdownOpen(false);
      setIsMobileMenuOpen(false);
    };

    return (
      <header className="bg-white shadow-md fixed w-full top-0 z-[9999] left-0 right-0">
        {/* Top Info Bar */}
        <div className="border-b border-gray-200 bg-gray-50">
          <div className="container mx-auto px-2 md:px-4 py-1.15  flex items-center justify-center">
            <div className="flex items-center justify-between">
              {/* Left side - Location Selector */}
              <div className="flex-1 max-w-md">

              </div>
            </div>
          </div>
        </div>



        {/* Main Header Section */}
        <div className="bg-white">
          <div className="container mx-auto px-4 py-2 sm:py-4">
            <div className="flex items-center justify-between">
              {/* MOBILE LAYOUT */}
              <div className="flex md:hidden items-center justify-between w-full">
                {/* Mobile: Hamburger Menu (Left) */}
                <button
                  aria-label="Menu mobile"
                  className="p-2 rounded-lg text-gray-600 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                >
                  {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
                </button>

                {/* Mobile: Logo (Centered) */}
                <div className="absolute left-1/2 transform -translate-x-1/2">
                  <a href="/">
                    <img
                      src="/qph.jpg"
                      alt="QuickPrintHub Logo"
                      className="h-10 w-auto object-contain"
                    />
                  </a>
                </div>

                {/* Mobile: Language Switcher (Right - always visible) */}
                <div className="relative" ref={languageDropdownRef}>
                  <button
                    onClick={() => setIsLanguageDropdownOpen(!isLanguageDropdownOpen)}
                    className="flex items-center gap-1 p-2 rounded-lg text-gray-600 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all duration-200"
                    aria-label="Language"
                  >
                    <Globe className="w-5 h-5" />
                    <span className="text-xs font-semibold">{languageLabels[currentLanguage]}</span>
                    <ChevronDown className={`w-3 h-3 transition-transform duration-200 ${isLanguageDropdownOpen ? 'rotate-180' : ''}`} />
                  </button>
                  <div
                    className={`absolute right-0 mt-2 w-36 bg-white rounded-xl shadow-xl border border-gray-200 z-50 overflow-hidden transition-all duration-200 origin-top-right ${isLanguageDropdownOpen
                      ? 'opacity-100 scale-100 pointer-events-auto'
                      : 'opacity-0 scale-95 pointer-events-none'
                      }`}
                  >
                    {['en', 'fr', 'es'].map((lang) => (
                      <button
                        key={lang}
                        onClick={() => handleLanguageChange(lang)}
                        className={`block w-full text-left px-4 py-2.5 text-sm transition-colors duration-150 ${currentLanguage === lang
                          ? 'bg-blue-50 text-blue-600 font-medium'
                          : 'text-gray-700 hover:bg-gray-50 hover:text-blue-600'
                          }`}
                      >
                        {languageNames[lang]}
                      </button>
                    ))}
                  </div>
                </div>
              </div>

              {/* DESKTOP LAYOUT */}
              <div className="hidden md:flex items-center justify-between w-full relative">
                {/* Desktop Left: Menu Items */}
                <div className="flex items-center space-x-4">
                  {/* Blog Link */}
                  <a
                    href="/blog"
                    className="flex items-center px-3 py-2 rounded-lg text-gray-700 hover:bg-gray-100 hover:text-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors font-medium"
                  >
                    <FileText className="w-5 h-5 mr-2" />
                    {getTranslatedText('blog')}
                  </a>

                  {/* Partner Sign In */}
                  <a
                    href="https://admin.quickprinthub.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center px-3 py-2 rounded-lg text-gray-700 hover:bg-gray-100 hover:text-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors font-medium"
                  >
                    <User className="w-5 h-5 mr-2" />
                    {getTranslatedText('partnersignin')}
                  </a>
                </div>

                {/* Desktop Center: Logo */}
                <div className="absolute left-1/2 transform -translate-x-1/2">
                  <a href="/" className="flex-shrink-0">
                    <img
                      src="/qph.jpg"
                      alt="QuickPrintHub Logo"
                      className="h-12 w-auto object-contain"
                    />
                  </a>
                </div>

                {/* Desktop Right: Language + Email (SANS panier) */}
                <div className="flex items-center space-x-3">
                  {/* Language Selector */}
                  <div className="relative" ref={languageDropdownRef}>
                    <button
                      onClick={() => setIsLanguageDropdownOpen(!isLanguageDropdownOpen)}
                      className="flex items-center px-3 py-2 rounded-lg text-gray-600 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all duration-200"
                    >
                      <Globe className="w-5 h-5 mr-2" />
                      {languageLabels[currentLanguage]}
                      <ChevronDown className={`w-4 h-4 ml-1 transition-transform duration-200 ${isLanguageDropdownOpen ? 'rotate-180' : ''}`} />
                    </button>
                    <div
                      className={`absolute right-0 mt-2 w-40 bg-white rounded-xl shadow-xl border border-gray-200 z-50 overflow-hidden transition-all duration-200 origin-top-right ${isLanguageDropdownOpen
                        ? 'opacity-100 scale-100 pointer-events-auto'
                        : 'opacity-0 scale-95 pointer-events-none'
                        }`}
                    >
                      {['en', 'fr', 'es'].map((lang) => (
                        <button
                          key={lang}
                          onClick={() => handleLanguageChange(lang)}
                          className={`block w-full text-left px-4 py-2.5 text-sm transition-colors duration-150 ${currentLanguage === lang
                            ? 'bg-blue-50 text-blue-600 font-medium'
                            : 'text-gray-700 hover:bg-gray-50 hover:text-blue-600'
                            }`}
                        >
                          {languageNames[lang]}
                        </button>
                      ))}
                    </div>
                  </div>


                </div>
              </div>
            </div>

            {/* Mobile Menu */}
            {isMobileMenuOpen && (
              <div
                ref={mobileMenuRef}
                className="md:hidden mt-6 pb-4 border-t border-gray-200"
              >
                <div className="pt-6 space-y-4">
                  {/* Mobile Store Status */}
                  {selectedStudio && (
                    <div className="text-sm text-gray-600 px-4 py-3 bg-blue-50 rounded-lg border border-blue-200">
                      {selectedStudio.vacationStatus?.onVacation ? (
                        <span className="text-red-600 font-medium flex items-center">
                          <div className="w-2 h-2 bg-red-500 rounded-full mr-2"></div>
                          On Vacation: {selectedStudio.vacationStatus.startDate} - {selectedStudio.vacationStatus.endDate}
                        </span>
                      ) : selectedStudio.openStatus?.isOpen ? (
                        <span className="text-green-600 font-medium flex items-center">
                          <div className="w-2 h-2 bg-green-500 rounded-full mr-2"></div>
                          {getTranslatedText('open')} • {selectedStudio.openStatus.operatingHours}
                        </span>
                      ) : selectedStudio.openStatus ? (
                        <span className="text-red-600 font-medium flex items-center">
                          <div className="w-2 h-2 bg-red-500 rounded-full mr-2"></div>
                          {getTranslatedText('closed')} • {selectedStudio.openStatus.operatingHours}
                        </span>
                      ) : null}
                    </div>
                  )}




                  {/* Partner Sign In - Mobile */}
                  <a
                    href="https://admin.quickprinthub.com/hub-login"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center px-4 py-2 rounded-lg text-gray-700 border border-gray-200 hover:bg-gray-50 hover:border-blue-300 hover:text-blue-600 transition-colors"
                  >
                    <User className="w-5 h-5 mr-3 text-blue-600" />
                    <span>{getTranslatedText('partnersignin')}</span>
                  </a>

                  {/* Blog Link - Mobile */}
                  <a
                    href="/blog"
                    className="flex items-center px-4 py-3 rounded-lg text-gray-700 border border-gray-200 hover:bg-gray-50 hover:border-blue-300 hover:text-blue-600 transition-colors"
                  >
                    <FileText className="w-5 h-5 mr-3 text-blue-600" />
                    <span>{getTranslatedText('blog')}</span>
                  </a>
                </div>
              </div>
            )}
          </div>
        </div>
      </header>
    );
  };

  // Custom marker icon
  const customIcon = new L.Icon({
    iconUrl: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23EA4335' width='36' height='36'%3E%3Cpath d='M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z'/%3E%3C/svg%3E",
    iconSize: [32, 32],
    iconAnchor: [16, 32],
    popupAnchor: [0, -32]
  });

  const HeroSection = ({
    selectedCountryFromLanding,
    selectedRegion,
    currency,
    selectedStudio,
    onStudioSelect,
  }) => {
    const handleEmailDocument = () => {
      const emailAddress = 'print@quickprinthub.com';
      const randomNumber = Math.floor(10000 + Math.random() * 90000);
      const subject = `Document for Printing - ${randomNumber}`;
      const body = 'Please find my document attached for printing.';
      const mailtoLink = `mailto:${emailAddress}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
      window.location.href = mailtoLink;
    };

    return (
      <section id="home" className="relative py-0 flex flex-col">
        {/* SEO-only content: visually hidden but readable by search engines */}
        <div style={{ position: 'absolute', width: '1px', height: '1px', padding: 0, margin: '-1px', overflow: 'hidden', clip: 'rect(0, 0, 0, 0)', whiteSpace: 'nowrap', borderWidth: 0 }}>
          <h1>Print Near Me — Email to Print, Pick Up Anywhere | QuickPrintHub</h1>
          <h2>Fast Document Printing Services Across Canada and North America</h2>
          <p>
            QuickPrintHub offers a seamless email-to-print service across Canada and North America.
            Simply email your document to print@quickprinthub.com, receive a unique secure code,
            and print at any QuickPrintHub partner convenience store location near you.
            Available in Toronto, Montreal, Pickering, Scarborough, and growing across the GTA.
            Professional quality printing for documents, PDFs, photos, and more.
            No USB drives, no printer drivers — just fast, affordable printing near you.
          </p>
          <nav aria-label="Blog articles">
            <h3>Printing Guides and Resources</h3>
            <ul>
              <li><a href="/blog">QuickPrintHub Blog — Printing Insights and Guides</a></li>
              <li><a href="/blog/global-print-near-me-north-america-2026">Print Near Me: How QuickPrintHub is Reshaping North America</a></li>
              <li><a href="/blog/celebrating-new-locations-pickering-scarborough-2026">New Locations in Pickering and Scarborough</a></li>
              <li><a href="/blog/email-to-print-revolution-quickprinthub-2026">Email to Print Revolution in Canada</a></li>
              <li><a href="/blog/printing-history-from-clay-to-email-2026">The History of Document Printing</a></li>
              <li><a href="/blog/winter-weather-printing-emergencies-2026">Winter Weather Printing Emergencies Guide</a></li>
              <li><a href="/blog/print-in-minutes-pick-up-anywhere-new-feature">Print in Minutes, Pick Up Anywhere</a></li>
              <li><a href="/blog/document-printing-survival-guide-2025">Document Printing Survival Guide</a></li>
              <li><a href="/blog/ultimate-guide-printing-canada">Ultimate Guide to Printing in Canada</a></li>
            </ul>
          </nav>
        </div>
        {/* Hero content */}
        <div
          className="relative flex flex-col justify-center items-center bg-white overflow-hidden md:h-[150px] lg:h-[160px]"
          style={{ height: 'min(20vh, 180px)', minHeight: '120px' }}
        >
          <div className="container mx-auto px-4 flex flex-col justify-center items-center h-full">
            {/* Support Email Above Steps */}
            <div className="mb-2 text-center animate-fade-in">
              <a
                href="mailto:Print@quickprinthub.com"
                className="text-blue-600 font-black text-xs sm:text-sm hover:text-blue-700 transition-colors tracking-widest uppercase flex items-center gap-2"
              >
                <div className="w-1.5 h-1.5 bg-blue-600 rounded-full animate-pulse"></div>
                Print@quickprinthub.com
              </a>
            </div>

            {/* Steps Container */}
            <div className="flex flex-row justify-center items-center w-full max-w-2xl md:max-w-xl lg:max-w-2xl mx-auto pt-1 pb-2 relative gap-0">

              {/* Connected Line Background */}
              <div className="absolute top-9 md:top-8 lg:top-8 left-[15%] right-[15%] h-[1px] bg-gradient-to-r from-transparent via-blue-200 to-transparent hidden sm:block"></div>

              {/* Step 1: SEND */}
              <div className="flex flex-col items-center flex-1 relative z-10">
                <div className="w-10 h-10 sm:w-12 sm:h-12 md:w-10 md:h-10 lg:w-10 lg:h-10 rounded-full bg-blue-50 border border-blue-100 flex items-center justify-center mb-1 md:mb-1 shadow-sm transition-transform hover:scale-105 duration-300 backdrop-blur-sm">
                  <span className="text-blue-600 font-black text-sm sm:text-lg md:text-base lg:text-base">1</span>
                </div>
                <span className="text-[8px] sm:text-[10px] md:text-[9px] lg:text-[9px] text-blue-600 font-black uppercase tracking-[0.2em] mb-0.5 md:mb-0.5 text-center">
                  {getTranslatedText('hero.step1.title')}
                </span>
                <button
                  onClick={handleEmailDocument}
                  className="group relative flex items-center justify-center gap-1 bg-blue-600 hover:bg-blue-700 text-white px-2 py-0.5 sm:px-4 sm:py-1.5 md:px-3 md:py-1 lg:px-3 lg:py-1 rounded-full transition-all duration-300 shadow-sm hover:shadow-md min-h-[1.5rem] sm:min-h-[2.25rem] md:min-h-[1.75rem] lg:min-h-[1.75rem] min-w-[4.5rem] sm:min-w-[6rem] md:min-w-[5.5rem] lg:min-w-[5.5rem]"
                >
                  <Mail size={8} className="sm:w-3.5 sm:h-3.5 md:w-3 md:h-3 flex-shrink-0" />
                  <span className="text-[8px] sm:text-[11px] md:text-[9px] lg:text-[9px] font-bold">
                    {getTranslatedText('hero.step1.button')}
                  </span>
                </button>
              </div>

              {/* Step 2: RECEIVE */}
              <div className="flex flex-col items-center flex-1 relative z-10">
                <div className="w-10 h-10 sm:w-12 sm:h-12 md:w-10 md:h-10 lg:w-10 lg:h-10 rounded-full bg-blue-50 border border-blue-100 flex items-center justify-center mb-1 md:mb-1 shadow-sm transition-transform hover:scale-105 duration-300 backdrop-blur-sm">
                  <span className="text-blue-600 font-black text-sm sm:text-lg md:text-base lg:text-base">2</span>
                </div>
                <span className="text-[8px] sm:text-[10px] md:text-[9px] lg:text-[9px] text-blue-600 font-black uppercase tracking-[0.2em] mb-0.5 md:mb-0.5 text-center">
                  {getTranslatedText('hero.step2.title')}
                </span>
                <div className="bg-blue-600 text-white px-2 py-0.5 sm:px-4 sm:py-1.5 md:px-3 md:py-1 lg:px-3 lg:py-1 rounded-full shadow-sm flex items-center justify-center min-h-[1.5rem] sm:min-h-[2.25rem] md:min-h-[1.75rem] lg:min-h-[1.75rem] min-w-[4.5rem] sm:min-w-[6rem] md:min-w-[5.5rem] lg:min-w-[5.5rem]">
                  <span className="text-[8px] sm:text-[11px] md:text-[9px] lg:text-[9px] font-bold">
                    {getTranslatedText('hero.step2.button')}
                  </span>
                </div>
              </div>

              {/* Step 3: PRINT */}
              <div className="flex flex-col items-center flex-1 relative z-10">
                <div className="w-10 h-10 sm:w-12 sm:h-12 md:w-10 md:h-10 lg:w-10 lg:h-10 rounded-full bg-blue-50 border border-blue-100 flex items-center justify-center mb-1 md:mb-1 shadow-sm transition-transform hover:scale-105 duration-300 backdrop-blur-sm">
                  <span className="text-blue-600 font-black text-sm sm:text-lg md:text-base lg:text-base">3</span>
                </div>
                <span className="text-[8px] sm:text-[10px] md:text-[9px] lg:text-[9px] text-blue-600 font-black uppercase tracking-[0.2em] mb-0.5 md:mb-0.5 text-center">
                  {getTranslatedText('hero.step3.title')}
                </span>
                <div className="bg-blue-600 text-white px-2 py-0.5 sm:px-4 sm:py-1.5 md:px-3 md:py-1 lg:px-3 lg:py-1 rounded-full shadow-sm flex items-center justify-center min-h-[1.5rem] sm:min-h-[2.25rem] md:min-h-[1.75rem] lg:min-h-[1.75rem] min-w-[4.5rem] sm:min-w-[6rem] md:min-w-[5.5rem] lg:min-w-[5.5rem]">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" className="w-3.5 h-3.5 sm:w-6 sm:h-6 md:w-5 md:h-5 lg:w-5 lg:h-5">
                    <path d="M16 30 L16 14" stroke="#ffffff" strokeWidth="2" />
                    <circle cx="16" cy="10" r="7" fill="#000000" stroke="white" strokeWidth="1" />
                    <circle cx="14" cy="8" r="2" fill="white" opacity="0.4" />
                  </svg>
                </div>
              </div>

            </div>
          </div>
        </div>

        {/* Hub Map */}
        <div
          className="relative border-t border-gray-200 h-[calc((100vh-97px-min(20vh,180px))*0.85)] md:h-[calc(100vh-97px-min(20vh,180px))]"
          style={{ minHeight: '240px' }}
        >
          <HubMap
            selectedStudio={selectedStudio}
            onStudioSelect={onStudioSelect}
            selectedCountry={selectedCountryFromLanding}
            nearestOnly={true}
            t={getTranslatedText}
          />

          {/* Map Legend */}
          <div className="absolute top-2 right-2 z-[1000] bg-white/90 backdrop-blur-sm p-2 rounded shadow border border-gray-200">
            <div className="text-[10px] font-bold text-gray-800 mb-1 uppercase tracking-wider">
              {getTranslatedText('map.legend.title')}
            </div>
            <div className="flex flex-col gap-1.5">
              <div className="flex items-center gap-1.5">
                <div className="w-2.5 h-2.5 rounded-full bg-[#2563eb] shadow-sm border border-black/10"></div>
                <span className="text-[10px] text-gray-700 font-medium">
                  {getTranslatedText('map.legend.user')}
                </span>
              </div>
              <div className="flex items-center gap-1.5">
                <div className="w-2.5 h-2.5 rounded-full bg-[#000000] shadow-sm border border-black/10"></div>
                <span className="text-[10px] text-gray-700 font-medium">
                  {getTranslatedText('map.legend.hub')}
                </span>
              </div>
              <div className="flex items-center gap-1.5">
                <div className="w-2.5 h-2.5 rounded-full bg-[#9333ea] shadow-sm border border-black/10"></div>
                <span className="text-[10px] text-gray-700 font-medium">
                  {getTranslatedText('map.legend.photoHub')}
                </span>
              </div>
              <div className="flex items-center gap-1.5">
                <div className="flex flex-col items-center">
                  <div className="w-2.5 h-2.5 rounded-full bg-[#6b7280] shadow-sm border border-white/50"></div>
                  <div className="w-0.5 h-1.5 bg-[#9ca3af]"></div>
                </div>
                <span className="text-[10px] text-gray-700 font-medium">
                  {getTranslatedText('map.legend.others')}
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  };





  // Inside App.jsx, after ContactSection (if it exists, but before App component's return)
  // or just before the App component's return statement.

  const Footer = () => (
    <footer className="bg-gray-900 text-gray-300 py-8 mt-12"> {/* Added mt-12 for some spacing */}
      <div className="container mx-auto px-4 text-center">
        <p className="mb-4">
          {getTranslatedText('onlinePrintingServices')}
        </p>

        <div className="flex justify-center space-x-4 mt-6">
          {/* Optional: Add social media links if desired */}
          <a href="https://www.facebook.com/p/Freezepix-Tunisia-61550091151861/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white">
            <Facebook className="w-6 h-6" />
          </a>
          {/* Add other social icons if needed */}
        </div>
        <p className="mt-8 text-sm text-gray-500">
          &copy; {new Date().getFullYear()} QuickPrintHub. All rights reserved.
        </p>
      </div>
    </footer>
  );

  const ServicesSection = () => (
    <section id="services" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <h2 className="text-4xl font-bold text-center mb-16">
          {getTranslatedText('ourServices')}
        </h2>

        <div className="grid md:grid-cols-2 gap-12 mb-16">
          <div className="bg-gradient-to-br from-blue-50 to-green-50 p-8 rounded-2xl transform hover:-translate-y-2 transition-all duration-300 hover:shadow-xl">
            <div className="flex items-center mb-6">
              <div className="bg-blue-600 p-4 rounded-full mr-4">
                <FileText className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-2xl font-bold">{getTranslatedText('documentPrinting')}</h3>
            </div>
            <ul className="space-y-3 text-gray-700">
              <li className="flex items-center">
                <Check className="w-5 h-5 text-blue-600 mr-2" />
                {getTranslatedText('pdfDocxSupported')}
              </li>
              <li className="flex items-center">
                <Check className="w-5 h-5 text-blue-600 mr-2" />
                {getTranslatedText('pageSelection')}
              </li>
              <li className="flex items-center">
                <Check className="w-5 h-5 text-blue-600 mr-2" />
                {getTranslatedText('simplexDuplex')}
              </li>
              <li className="flex items-center">
                <Check className="w-5 h-5 text-blue-600 mr-2" />
                {getTranslatedText('blackWhite')}
              </li>
              <li className="flex items-center">
                <Check className="w-5 h-5 text-blue-600 mr-2" />
                {getTranslatedText('pickupDelivery')}
              </li>
            </ul>
            <div className="mt-6">
              <button
                onClick={() => setIsDocumentModalOpen(true)}
                className="w-full bg-blue-600 text-white py-3 px-6 rounded-lg font-semibold hover:bg-blue-700 transition-colors flex items-center justify-center"
              >
                <Upload className="w-5 h-5 mr-2" />
                {getTranslatedText('startDocumentPrinting')}
              </button>
            </div>
          </div>

          <div className="bg-gradient-to-br from-red-50 to-yellow-50 p-8 rounded-2xl transform hover:-translate-y-2 transition-all duration-300 hover:shadow-xl">
            <div className="flex items-center mb-6">
              <div className="bg-yellow-400 p-4 rounded-full mr-4">
                <Camera className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-2xl font-bold">{getTranslatedText('photoPrinting')}</h3>
            </div>
            <ul className="space-y-3 text-gray-700">
              <li className="flex items-center">
                <Check className="w-5 h-5 text-black-600 mr-2" />
                {getTranslatedText('formats')}
              </li>
              <li className="flex items-center">
                <Check className="w-5 h-5 text-black-600 mr-2" />
                {getTranslatedText('homeDelivery')}
              </li>
              <li className="flex items-center">
                <Check className="w-5 h-5 text-black-600 mr-2" />
                {getTranslatedText('tieredPricing')}
              </li>
              <li className="flex items-center">
                <Check className="w-5 h-5 text-black-600 mr-2" />
                {getTranslatedText('professionalQuality')}
              </li>
              <li className="flex items-center">
                <Check className="w-5 h-5 text-black-600 mr-2" />
                {getTranslatedText('premiumPhotoPaper')}
              </li>
            </ul>
            <div className="mt-6">
              <button
                onClick={() => setIsPhotoModalOpen(true)}
                className="w-full bg-yellow-400 text-white py-3 px-6 rounded-lg font-semibold hover:bg-black-700 transition-colors flex items-center justify-center"
              >
                <Upload className="w-5 h-5 mr-2" />
                {getTranslatedText('startPhotoPrinting')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );

  const PricingSection = () => (
    <section id="tarifs" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <h2 className="text-4xl font-bold text-center mb-16" dangerouslySetInnerHTML={{ __html: getTranslatedText('competitivePricing') }}>
        </h2>

        <div className="grid md:grid-cols-3 gap-8">
          <div className="bg-white p-8 rounded-2xl shadow-lg">
            <div className="text-center">
              <div className="bg-red-100 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-4">
                <Image className="w-10 h-10 text-red-600" />
              </div>
              <h3 className="text-2xl font-bold mb-2">{getTranslatedText('photos10x15')}</h3>
              <p className="text-gray-600 mb-6">{getTranslatedText('standardFormat')}</p>
              <div className="space-y-4">
                <div className="flex justify-between items-center">
                  <span>1-24 {getTranslatedText('photos')}</span>
                  <span className="font-bold">2.5 {currency}</span>
                </div>
                <div className="flex justify-between items-center">
                  <span>25-74 {getTranslatedText('photos')}</span>
                  <span className="font-bold">2.0 {currency}</span>
                </div>
                <div className="flex justify-between items-center">
                  <span>75+ {getTranslatedText('photos')}</span>
                  <span className="font-bold">1.5 {currency}</span>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-white p-8 rounded-2xl shadow-lg border-2 border-red-200">
            <div className="text-center">
              <div className="bg-red-600 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-4">
                <Image className="w-10 h-10 text-white" />
              </div>
              <h3 className="text-2xl font-bold mb-2">{getTranslatedText('photos15x23')}</h3>
              <p className="text-gray-600 mb-6">{getTranslatedText('premiumFormat')}</p>
              <div className="space-y-4">
                <div className="flex justify-between items-center">
                  <span>1-24 {getTranslatedText('photos')}</span>
                  <span className="font-bold">3.5 {currency}</span>
                </div>
                <div className="flex justify-between items-center">
                  <span>25-74 {getTranslatedText('photos')}</span>
                  <span className="font-bold">3.0 {currency}</span>
                </div>
                <div className="flex justify-between items-center">
                  <span>75+ {getTranslatedText('photos')}</span>
                  <span className="font-bold">2.5 {currency}</span>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-white p-8 rounded-2xl shadow-lg">
            <div className="text-center">
              <div className="bg-blue-100 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-4">
                <FileTextIcon className="w-10 h-10 text-blue-600" />
              </div>
              <h3 className="text-2xl font-bold mb-2">{getTranslatedText('documents')}</h3>
              <p className="text-gray-600 mb-6">{getTranslatedText('professionalPrinting')}</p>
              <div className="space-y-4">
                <div className="flex justify-between items-center">
                  <span>1-24 {getTranslatedText('pages')}</span>
                  <span className="font-bold">0.30 {currency}</span>
                </div>
                <div className="flex justify-between items-center">
                  <span>25-74 {getTranslatedText('pages')}</span>
                  <span className="font-bold">0.25 {currency}</span>
                </div>
                <div className="flex justify-between items-center">
                  <span>75+ {getTranslatedText('pages')}</span>
                  <span className="font-bold">0.20 {currency}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );

  const AboutSection = () => (
    <section id="about" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-4xl font-bold mb-6" dangerouslySetInnerHTML={{ __html: getTranslatedText('marketLeaderTunisia') }}>
            </h2>
            <p className="text-lg text-gray-700 mb-6">
              {getTranslatedText('sinceCreation')}
            </p>
            <ul className="space-y-4 text-gray-700">
              <li className="flex items-center">
                <Medal className="w-5 h-5 text-yellow-500 mr-3" />
                <span>{getTranslatedText('tunisianMarketLeader')}</span>
              </li>
              <li className="flex items-center">
                <Truck className="w-5 h-5 text-green-500 mr-3" />
                <span>{getTranslatedText('fastDeliveryTunisia')}</span>
              </li>
              <li className="flex items-center">
                <Medal className="w-5 h-5 text-blue-500 mr-3" />
                <span>{getTranslatedText('guaranteedQuality')}</span>
              </li>
              <li className="flex items-center">
                <Users className="w-5 h-5 text-purple-500 mr-3" />
                <span>{getTranslatedText('satisfiedCustomers')}</span>
              </li>
            </ul>
          </div>
          <div className="text-center">
            <div className="bg-gradient-to-br from-red-100 to-yellow-100 p-12 rounded-2xl">
              <div className="text-6xl mb-4">🇹🇳</div>
              <h3 className="text-2xl font-bold mb-4">{getTranslatedText('proudlyTunisian')}</h3>
              <p className="text-gray-700">
                {getTranslatedText('tunisianCompany')}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );

  const ContactSection = () => (
    <section id="contact" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <h2 className="text-4xl font-bold text-center mb-16" dangerouslySetInnerHTML={{ __html: getTranslatedText('contactUs') }}>
        </h2>
        <div className="grid md:grid-cols-2 gap-12">
          <div>
            <h3 className="text-2xl font-bold mb-6">{getTranslatedText('contactInformation')}</h3>
            <div className="space-y-6">
              <div className="flex items-center">
                <div className="bg-yellow-400 p-3 rounded-full mr-4">
                  <MapPin className="text-white" />
                </div>
                <div>
                  <p className="font-semibold">{getTranslatedText('address')}</p>
                  <p className="text-gray-600">1 Rue Alibey, Sousse 4000</p>
                </div>
              </div>
              <div className="flex items-center">
                <div className="bg-green-600 p-3 rounded-full mr-4">
                  <Phone className="text-white" />
                </div>
                <div>
                  <p className="font-semibold">{getTranslatedText('phone')}</p>
                  <p className="text-gray-600">95 612 003</p>
                </div>
              </div>
              <div className="flex items-center">
                <div className="bg-blue-600 p-3 rounded-full mr-4">
                  <Clock className="text-white" />
                </div>
                <div>
                  <p className="font-semibold">{getTranslatedText('hours')}</p>
                  <p className="text-gray-600">Lundi - Samedi • 09h00 à 17h00</p>
                </div>
              </div>
              <div className="flex items-center">
                <div className="bg-purple-600 p-3 rounded-full mr-4">
                  <Facebook className="text-white" />
                </div>
                <div>
                  <p className="font-semibold">{getTranslatedText('facebook')}</p>
                  <a href="https://www.facebook.com/p/Freezepix-Tunisia-61550091151861/"
                    target="_blank"
                    className="text-blue-600 hover:text-blue-800" rel="noopener noreferrer">
                    Freezepix Tunisia
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div>
            <h3 className="text-2xl font-bold mb-6">{getTranslatedText('sendMessage')}</h3>
            <form className="space-y-6">
              <div>
                <label className="block text-sm font-medium mb-2">{getTranslatedText('fullName')}</label>
                <input type="text"
                  className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent"
                  required />
              </div>
              <div>
                <label className="block text-sm font-medium mb-2">{getTranslatedText('email')}</label>
                <input type="email"
                  className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent"
                  required />
              </div>
              <div>
                <label className="block text-sm font-medium mb-2">{getTranslatedText('message')}</label>
                <textarea rows="4"
                  className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent"
                  required></textarea>
              </div>
              <button type="submit"
                className="w-full bg-yellow-400 text-white py-3 rounded-lg font-semibold hover:bg-black-700 transition-colors">
                {getTranslatedText('sendMessageButton')}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );


  const parsePageRange = (range, totalPages) => {
    console.log('parsePageRange: Range:', range, 'Total Pages:', totalPages);

    if (!range || range.trim() === '') {
      return [];
    }

    const pages = [];
    const parts = range.split(',');

    for (const part of parts) {
      const trimmedPart = part.trim();
      if (trimmedPart.includes('-')) {
        // Handle range like "2-5"
        const [start, end] = trimmedPart.split('-').map(num => parseInt(num.trim()));
        if (!isNaN(start) && !isNaN(end) && start <= end) {
          for (let i = Math.max(1, start); i <= Math.min(totalPages, end); i++) {
            if (!pages.includes(i)) {
              pages.push(i);
            }
          }
        }
      } else {
        // Handle single page like "3"
        const pageNum = parseInt(trimmedPart);
        if (!isNaN(pageNum) && pageNum >= 1 && pageNum >= 1 && pageNum <= totalPages && !pages.includes(pageNum)) {
          pages.push(pageNum);
        }
      }
    }

    pages.sort((a, b) => a - b);
    console.log('parsePageRange: Parsed pages:', pages);
    return pages;
  };


  const openPreview = async (item) => {
    setPreviewItem(item);
    setCurrentPreviewPage(0);
    setPreviewZoom(0.6);

    if (item.type === 'document') {
      let pagesToDisplay = []; // Clear the array at the start
      if (item.file.originalFile && item.file.originalFile.type === 'application/pdf') {
        setIsLoading(true);
        try {
          const arrayBuffer = await item.file.originalFile.arrayBuffer();
          const pdf = await pdfjsLib.getDocument(arrayBuffer).promise;
          const totalPagesInPdf = pdf.numPages;

          let selectedPageNumbers = [];

          if (item.options.pageSelection === 'all') {
            for (let i = 1; i <= Math.min(totalPagesInPdf, 5); i++) {
              selectedPageNumbers.push(i);
            }
          } else if (item.options.pageSelection === 'range') {
            selectedPageNumbers = parsePageRange(item.options.pageRange, totalPagesInPdf);
          }

          console.log('openPreview: Selected page numbers for preview:', selectedPageNumbers);

          for (const pageNum of selectedPageNumbers) {
            if (pageNum >= 1 && pageNum <= totalPagesInPdf) {
              const page = await pdf.getPage(pageNum);
              const viewport = page.getViewport({ scale: 1.25 });
              const canvas = document.createElement('canvas');
              const context = canvas.getContext('2d');
              canvas.height = viewport.height;
              canvas.width = viewport.width;
              await page.render({ canvasContext: context, viewport: viewport }).promise;
              const dataUrl = canvas.toDataURL('image/png');
              pagesToDisplay.push(dataUrl);
            }
          }

          console.log('openPreview: Generated preview pages:', pagesToDisplay.length);

        } catch (error) {
          console.error("Error generating specific PDF preview:", error);
          pagesToDisplay = []; // Fallback to empty if error
        } finally {
          setIsLoading(false);
        }
        setPreviewPages(pagesToDisplay);
      } else if (item.file.fileType === 'image/jpeg' || item.file.fileType === 'image/png') {
        setPreviewPages(item.file.previewPages);
      } else {
        setPreviewPages(item.file.previewPages || []);
      }
    } else if (item.type === 'photo') {
      setPreviewPages([item.photo.url]);
    }

    setIsPreviewModalOpen(true);
  };







  const closePreview = () => {
    setIsPreviewModalOpen(false);
    setPreviewItem(null);
    setPreviewPages([]);
    setCurrentPreviewPage(0);
    setPreviewZoom(0.6);
  };

  const PreviewModal = () => {
    const [viewMode, setViewMode] = useState('single'); // Default to 'single' for better navigation
    const [isLoading, setIsLoading] = useState(false); // Safeguard for loading
    const [touchStartX, setTouchStartX] = useState(null);

    useEffect(() => {
      const handleKeyDown = (e) => {
        if (e.key === 'ArrowLeft') goToPreviousPage();
        if (e.key === 'ArrowRight') goToNextPage();
        if (e.key === 'Escape') closePreview();
      };

      window.addEventListener('keydown', handleKeyDown);
      return () => window.removeEventListener('keydown', handleKeyDown);
    }, []); // Keyboard navigation

    if (!isPreviewModalOpen || !previewItem) return null;

    const handleZoomIn = () => setPreviewZoom(prev => Math.min(prev + 0.2, 3));
    const handleZoomOut = () => setPreviewZoom(prev => Math.max(prev - 0.2, 0.5));

    // Navigation functions
    const goToPreviousPage = () => {
      console.log('Previous clicked, current page:', currentPreviewPage);
      setCurrentPreviewPage(prev => {
        const newPage = Math.max(prev - 1, 0);
        console.log('Going to page:', newPage);
        return newPage;
      });
    };

    const goToNextPage = () => {
      console.log('Next clicked, current page:', currentPreviewPage);
      setCurrentPreviewPage(prev => {
        const newPage = Math.min(prev + 1, previewPages.length - 1);
        console.log('Going to page:', newPage);
        return newPage;
      });
    };

    // Swipe detection for mobile
    const handleTouchStart = (e) => {
      setTouchStartX(e.touches[0].clientX);
    };

    const handleTouchEnd = (e) => {
      if (!touchStartX) return;
      const touchEndX = e.changedTouches[0].clientX;
      const diff = touchStartX - touchEndX;
      if (Math.abs(diff) > 50) { // Swipe threshold
        if (diff > 0) goToNextPage(); // Swipe left -> next
        else goToPreviousPage(); // Swipe right -> previous
      }
      setTouchStartX(null);
    };

    return (
      <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4">
        <div className="bg-white rounded-lg w-full max-w-4xl h-full max-h-[90vh] flex flex-col transition-all duration-300 ease-in-out">
          {/* Header */}
          <div className="sticky top-0 flex flex-wrap items-center justify-between p-2 sm:p-4 border-b gap-2">
            {/* Title Section */}
            <div className="min-w-0 flex-shrink">
              <h3 className="text-sm sm:text-lg font-semibold truncate max-w-[180px] sm:max-w-none">
                {previewItem.type === 'document' ? previewItem.file.name : previewItem.photo.name}
              </h3>
              {previewItem.type === 'document' && previewPages.length > 1 && (
                <p className="text-xs text-gray-600 truncate">
                  {viewMode === 'single'
                    ? `${getTranslatedText('page')} ${currentPreviewPage + 1} ${getTranslatedText('on')} ${previewPages.length}`
                    : `${previewPages.length} ${getTranslatedText('pages')} - ${getTranslatedText('scrollToView')}`
                  }
                </p>
              )}
            </div>

            {/* Controls Section - Scrollable on mobile */}
            <div className="flex items-center gap-1 sm:gap-2 overflow-x-auto py-1 flex-grow justify-end">
              {/* View Mode Toggle */}
              {previewPages.length > 1 && (
                <>
                  <button
                    onClick={() => {
                      setViewMode(viewMode === 'single' ? 'scroll' : 'single');
                      if (viewMode === 'scroll') setCurrentPreviewPage(0);
                    }}
                    className="p-1.5 sm:p-2 hover:bg-gray-100 rounded text-xs sm:text-sm bg-gray-50 font-medium flex-shrink-0"
                  >
                    <LayoutGrid className="w-4 h-4" />
                  </button>
                  <div className="w-px h-4 bg-gray-300 mx-1"></div>
                </>
              )}

              {/* Page Navigation */}
              {previewPages.length > 1 && viewMode === 'single' && (
                <>
                  <button
                    onClick={goToPreviousPage}
                    className="p-1.5 sm:p-2 hover:bg-gray-100 rounded border disabled:opacity-50 disabled:cursor-not-allowed flex-shrink-0"
                    disabled={currentPreviewPage === 0}
                  >
                    <ChevronLeft className="w-4 h-4" />
                  </button>

                  <div className="px-2 py-1 bg-gray-100 rounded text-xs font-medium min-w-[44px] text-center flex-shrink-0">
                    {currentPreviewPage + 1}/{previewPages.length}
                  </div>

                  <button
                    onClick={goToNextPage}
                    className="p-1.5 sm:p-2 hover:bg-gray-100 rounded border disabled:opacity-50 disabled:cursor-not-allowed flex-shrink-0"
                    disabled={currentPreviewPage === previewPages.length - 1}
                  >
                    <ChevronRight className="w-4 h-4" />
                  </button>

                  <div className="w-px h-4 bg-gray-300 mx-1"></div>
                </>
              )}

              {/* Zoom Controls */}
              <button
                onClick={handleZoomOut}
                className="p-1.5 sm:p-2 hover:bg-gray-100 rounded disabled:opacity-50 flex-shrink-0"
                disabled={previewZoom <= 0.5}
              >
                <ZoomOut className="w-4 h-4" />
              </button>

              <span className="text-xs px-1 whitespace-nowrap bg-gray-100 rounded flex-shrink-0">
                {Math.round(previewZoom * 100)}%
              </span>

              <button
                onClick={handleZoomIn}
                className="p-1.5 sm:p-2 hover:bg-gray-100 rounded disabled:opacity-50 flex-shrink-0"
                disabled={previewZoom >= 3}
              >
                <ZoomIn className="w-4 h-4" />
              </button>

              <div className="w-px h-4 bg-gray-300 mx-1"></div>

              {/* Close button */}
              <button
                onClick={closePreview}
                className="p-1.5 sm:p-2 hover:bg-gray-100 rounded flex-shrink-0"
              >
                <X className="w-4 h-4" />
              </button>
            </div>
          </div>

          {/* Content */}
          <div
            className="flex-1 overflow-auto p-4 bg-gray-100 relative"
            onTouchStart={handleTouchStart}
            onTouchEnd={handleTouchEnd}
          >
            {isLoading ? (
              <div className="flex flex-col items-center justify-center h-full">
                <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-blue-500 mb-4"></div>
                <p className="text-gray-500">Generating Preview...</p>
              </div>
            ) : (
              <>
                {viewMode === 'single' ? (
                  <div className="flex justify-center items-center h-full relative">
                    {/* Side Navigation Arrows */}
                    {previewPages.length > 1 && (
                      <>
                        <button
                          onClick={goToPreviousPage}
                          className={`absolute left-0 top-1/2 transform -translate-y-1/2 p-4 opacity-70 hover:opacity-100 z-10 transition-opacity duration-200 ${currentPreviewPage === 0 ? 'hidden' : ''}`}
                          style={{ backgroundColor: 'rgba(255, 255, 255, 0.3)' }}
                        >
                          <ChevronLeft className="w-8 h-8 text-white" />
                        </button>
                        <button
                          onClick={goToNextPage}
                          className={`absolute right-0 top-1/2 transform -translate-y-1/2 p-4 opacity-70 hover:opacity-100 z-10 transition-opacity duration-200 ${currentPreviewPage === previewPages.length - 1 ? 'hidden' : ''}`}
                          style={{ backgroundColor: 'rgba(255, 255, 255, 0.3)' }}
                        >
                          <ChevronRight className="w-8 h-8 text-white" />
                        </button>
                      </>
                    )}
                    {/* Preview Image */}
                    <div
                      className="border-2 border-gray-300 shadow-lg rounded-lg overflow-hidden bg-white p-2 transition-transform duration-200"
                      style={{ transform: `scale(${previewZoom})`, transformOrigin: 'center' }}
                    >
                      <img
                        src={previewPages[currentPreviewPage] || (previewItem.type === 'photo' ? previewItem.photo.url : '')}
                        alt={`${getTranslatedText('page')} ${currentPreviewPage + 1}`}
                        className="max-w-full h-auto block"
                      />
                    </div>
                  </div>
                ) : (
                  <div className="space-y-6 max-w-full overflow-y-auto" style={{ scrollbarWidth: 'thin' }}>
                    {previewPages.map((pageUrl, index) => (
                      <div key={index} className="flex flex-col items-center">
                        <div className="text-sm font-medium text-gray-700 mb-2 bg-white px-3 py-1 rounded-full shadow-sm border">
                          {getTranslatedText('page')} {index + 1} / {previewPages.length}
                        </div>
                        <div
                          className="border-2 border-gray-300 shadow-lg rounded-lg overflow-hidden bg-white p-2 transition-transform duration-200"
                          style={{ transform: `scale(${previewZoom})`, transformOrigin: 'center top' }}
                        >
                          <img
                            src={pageUrl}
                            alt={`${getTranslatedText('page')} ${index + 1}`}
                            className="max-w-full h-auto block"
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </>
            )}
          </div>

          {/* Footer with item details */}
          <div className="border-t p-4 bg-gray-50">
            {previewItem.type === 'document' && (
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">

                <div>
                  <span className="font-medium">{getTranslatedText('copies')}:</span>
                  <p>{previewItem.options.copies}</p>
                </div>
                <div>
                  <span className="font-medium">{getTranslatedText('type')}:</span>
                  <p>{previewItem.options.color === 'couleur' ? getTranslatedText('colorPrint') : getTranslatedText('blackAndWhitePrint')}</p>
                </div>
              </div>
            )}

            {previewItem.type === 'photo' && (
              <div className="grid grid-cols-2 md:grid-cols-3 gap-4 text-sm">
                <div>
                  <span className="font-medium">{getTranslatedText('size')}:</span>
                  <p>{previewItem.photo.size}</p>
                </div>
                <div>
                  <span className="font-medium">{getTranslatedText('quantity')}:</span>
                  <p>{previewItem.options.quantity}</p>
                </div>
                {previewItem.options.paperType && (
                  <div>
                    <span className="font-medium">{getTranslatedText('paper')}:</span>
                    <p>{previewItem.options.paperType}</p>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };




  const DocumentModal = ({ isDocumentModalOpen, setIsDocumentModalOpen, onAddToCart, pricing, isLoading, onDocumentAddToCartSuccess }) => {
    const [currentStep, setCurrentStep] = useState(1);
    const [isDragOver, setIsDragOver] = useState(false);
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [fileOptions, setFileOptions] = useState({});
    const [uploadError, setUploadError] = useState('');
    const [isFetchingPageCount, setIsFetchingPageCount] = useState(false);
    const [isGeneratingPreview, setIsGeneratingPreview] = useState({});
    const [isMobilePreviewOpen, setIsMobilePreviewOpen] = useState(false);
    const [documentPreviewZoom, setDocumentPreviewZoom] = useState(1);
    const [currentPreviewPageForFile, setCurrentPreviewPageForFile] = useState({});
    const [isAnyFileProcessing, setIsAnyFileProcessing] = useState(false);

    useEffect(() => {
      const anyFileProcessing = uploadedFiles.some(file =>
        file.isGettingPageCount || file.isGeneratingPreview || isGeneratingPreview[file.id]
      );
      setIsAnyFileProcessing(anyFileProcessing);
    }, [uploadedFiles, isGeneratingPreview]);

    const calculateRangePages = (range, totalPages) => {
      if (!range || !range.trim()) return 0;
      const parts = range.split(',').map(s => s.trim());
      let calculatedPages = 0;
      parts.forEach(part => {
        if (part.includes('-')) {
          const [start, end] = part.split('-').map(n => parseInt(n.trim()));
          if (start && end && start <= end && start <= totalPages && end <= totalPages) {
            calculatedPages += (end - start + 1);
          }
        } else {
          const pageNum = parseInt(part);
          if (pageNum && pageNum <= totalPages && pageNum >= 1) {
            calculatedPages += 1;
          }
        }
      });
      return Math.min(calculatedPages, totalPages);
    };

    const parsePageRange = (rangeString, totalPages) => {
      const pages = new Set();
      if (!rangeString) return [];
      rangeString.split(',').forEach(part => {
        part = part.trim();
        if (part.includes('-')) {
          let [start, end] = part.split('-').map(Number);
          start = Math.max(1, start);
          end = Math.min(totalPages, end);
          for (let i = start; i <= end; i++) {
            pages.add(i);
          }
        } else {
          const pageNum = Number(part);
          if (pageNum >= 1 && pageNum <= totalPages) {
            pages.add(pageNum);
          }
        }
      });
      return Array.from(pages).sort((a, b) => a - b);
    };

    const regenerateSpecificPreviews = async (fileId, originalFile, pageNumbersToPreview, totalPages) => {
      setIsGeneratingPreview(prev => ({ ...prev, [fileId]: true }));
      let newPreviewPages = [];

      try {
        if (originalFile.type === 'application/pdf') {
          const arrayBuffer = await originalFile.arrayBuffer();
          const pdf = await pdfjsLib.getDocument(arrayBuffer).promise;

          for (const pageNum of pageNumbersToPreview) {
            if (pageNum >= 1 && pageNum <= pdf.numPages) {
              const page = await pdf.getPage(pageNum);
              const viewport = page.getViewport({ scale: 1.1 });
              const canvas = document.createElement('canvas');
              const context = canvas.getContext('2d');
              canvas.height = viewport.height;
              canvas.width = viewport.width;
              await page.render({ canvasContext: context, viewport: viewport }).promise;
              newPreviewPages.push(canvas.toDataURL('image/png'));
            }
          }
        } else if (originalFile.type === 'image/jpeg' || originalFile.type === 'image/png') {
          if (pageNumbersToPreview.includes(1)) {
            newPreviewPages.push(await readFileAsDataURL(originalFile));
          }
        }
      } catch (error) {
        console.error(`Error regenerating preview for file ${originalFile.name}:`, error);
      } finally {
        setIsGeneratingPreview(prev => ({ ...prev, [fileId]: false }));
        setUploadedFiles(prev => prev.map(f =>
          f.id === fileId ? { ...f, previewPages: newPreviewPages } : f
        ));
        setCurrentPreviewPageForFile(prev => ({ ...prev, [fileId]: 0 }));
      }
    };

    const getQuantityTier = (copies) => {
      if (copies >= 1 && copies <= 24) return '1-24';
      if (copies >= 25 && copies <= 74) return '25-74';
      if (copies >= 75) return '75+';
      return '1-24';
    };

    const calculateTotalCost = () => {
      return uploadedFiles.reduce((total, file) => total + calculateFileCost(file), 0);
    };

    const formatFileSize = (bytes) => {
      if (bytes === 0) return '0 Bytes';
      const k = 1024;
      const sizes = ['Bytes', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    };

    const calculateSubtotal = () => {
      return uploadedFiles.reduce((total, file) => total + calculateFileCost(file), 0);
    };

    const getPageCountFromPDF = async (file) => {
      setIsFetchingPageCount(true);
      try {
        const arrayBuffer = await file.arrayBuffer();
        const pdf = await pdfjsLib.getDocument(arrayBuffer).promise;
        return pdf.numPages;
      } catch (error) {
        throw new Error(getTranslatedText('errorReadingPDF'));
      } finally {
        setIsFetchingPageCount(false);
      }
    };

    const getPageCountFromImage = async (file) => {
      return 1;
    };

    // Main function to get exact page count from Word documents
    const getExactWordPageCount = async (file) => {
      try {
        if (file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
          return await convertDocxToPdfAndCountPages(file);
        } else if (file.type === 'application/msword') {
          return await convertDocToPdfAndCountPages(file);
        }
      } catch (error) {
        console.error('Exact page count failed:', error);
        // Fallback to estimation
        return await analyzeWordDocument(file);
      }
    };

    // Convert DOCX to HTML then to PDF pages
    const convertDocxToPdfAndCountPages = async (file) => {
      try {
        const arrayBuffer = await file.arrayBuffer();
        const JSZip = await import('jszip');
        const zip = await JSZip.loadAsync(arrayBuffer);

        // Extract document content
        const documentXml = await zip.file('word/document.xml').async('text');
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(documentXml, 'text/xml');

        // Convert Word XML to HTML
        const htmlContent = await convertWordXmlToHtml(xmlDoc);

        // Render HTML and measure pages
        const pageCount = await measureHtmlPages(htmlContent);

        console.log(`DOCX exact page count: ${pageCount} pages`);
        return pageCount;

      } catch (error) {
        console.error('DOCX to PDF conversion failed:', error);
        throw error;
      }
    };

    // Convert DOC to HTML using Mammoth then to PDF pages
    const convertDocToPdfAndCountPages = async (file) => {
      try {
        const arrayBuffer = await file.arrayBuffer();

        // Convert DOC to HTML using Mammoth
        const result = await mammoth.convertToHtml({ arrayBuffer });
        const htmlContent = result.value;

        // Render HTML and measure pages
        const pageCount = await measureHtmlPages(htmlContent);

        console.log(`DOC exact page count: ${pageCount} pages`);
        return pageCount;

      } catch (error) {
        console.error('DOC to PDF conversion failed:', error);
        throw error;
      }
    };

    // Convert Word XML to HTML
    const convertWordXmlToHtml = async (xmlDoc) => {
      let html = '<div style="font-family: Arial, sans-serif; font-size: 12px; line-height: 1.4; padding: 72px;">';

      const paragraphs = xmlDoc.getElementsByTagName('w:p');

      for (let i = 0; i < paragraphs.length; i++) {
        const paragraph = paragraphs[i];
        let paragraphHtml = '<div style="margin-bottom: 12px;">';

        // Extract text runs
        const textRuns = paragraph.getElementsByTagName('w:r');
        for (let j = 0; j < textRuns.length; j++) {
          const textRun = textRuns[j];
          const textElement = textRun.getElementsByTagName('w:t')[0];

          if (textElement) {
            let text = textElement.textContent || '';

            // Basic formatting
            const isBold = textRun.getElementsByTagName('w:b').length > 0;
            const isItalic = textRun.getElementsByTagName('w:i').length > 0;

            if (isBold && isItalic) {
              text = `<strong><em>${text}</em></strong>`;
            } else if (isBold) {
              text = `<strong>${text}</strong>`;
            } else if (isItalic) {
              text = `<em>${text}</em>`;
            }

            paragraphHtml += text;
          }
        }

        paragraphHtml += '</div>';
        html += paragraphHtml;
      }

      html += '</div>';
      return html;
    };

    // Measure HTML content to determine page count
    const measureHtmlPages = async (htmlContent) => {
      return new Promise((resolve, reject) => {
        // Create a temporary container
        const container = document.createElement('div');
        container.style.cssText = `
      position: fixed;
      left: -10000px;
      top: -10000px;
      width: 8.5in;
      min-height: 11in;
      background: white;
      box-sizing: border-box;
    `;

        // Create page container
        const pageContainer = document.createElement('div');
        pageContainer.style.cssText = `
      width: 100%;
      height: 100%;
      overflow: hidden;
      position: relative;
    `;

        container.appendChild(pageContainer);
        document.body.appendChild(container);

        try {
          // Split content into pages
          const pages = splitContentIntoPages(htmlContent, pageContainer);
          resolve(pages.length);
        } catch (error) {
          reject(error);
        } finally {
          // Clean up
          document.body.removeChild(container);
        }
      });
    };

    // Split HTML content into pages based on A4 size
    const splitContentIntoPages = (htmlContent, container) => {
      const pages = [];
      const A4_HEIGHT = 1122; // 11in in pixels at 96 DPI
      const MARGIN = 72; // 1in margin

      container.innerHTML = htmlContent;

      let currentPageContent = '';
      let currentHeight = 0;
      let pageNumber = 1;

      // Simple page splitting algorithm
      const elements = container.children[0].children; // Get all paragraphs

      for (let i = 0; i < elements.length; i++) {
        const element = elements[i];
        const elementHeight = getElementHeight(element);

        // If adding this element would exceed page height, start new page
        if (currentHeight + elementHeight > A4_HEIGHT - (MARGIN * 2)) {
          if (currentPageContent) {
            pages.push(currentPageContent);
            pageNumber++;
          }
          currentPageContent = element.outerHTML;
          currentHeight = elementHeight;
        } else {
          currentPageContent += element.outerHTML;
          currentHeight += elementHeight;
        }
      }

      // Add the last page
      if (currentPageContent) {
        pages.push(currentPageContent);
      }

      return pages;
    };

    // Get element height including margins
    const getElementHeight = (element) => {
      const clone = element.cloneNode(true);
      clone.style.visibility = 'hidden';
      clone.style.position = 'absolute';
      document.body.appendChild(clone);
      const height = clone.offsetHeight;
      document.body.removeChild(clone);
      return height;
    };

    // Generate preview for DOC files
    const generateDocPagePreview = async (file, pageIndex) => {
      try {
        const arrayBuffer = await file.arrayBuffer();
        const result = await mammoth.convertToHtml({ arrayBuffer });
        const htmlContent = result.value;

        // Create a canvas with page content
        const canvas = document.createElement('canvas');
        canvas.width = 595; // A4 width at 72 DPI
        canvas.height = 842; // A4 height at 72 DPI
        const ctx = canvas.getContext('2d');

        // Page background
        ctx.fillStyle = 'white';
        ctx.fillRect(0, 0, canvas.width, canvas.height);

        // Page border
        ctx.strokeStyle = '#e5e7eb';
        ctx.lineWidth = 1;
        ctx.strokeRect(10, 10, canvas.width - 20, canvas.height - 20);

        // Document icon
        ctx.fillStyle = '#3b82f6';
        ctx.font = 'bold 32px Arial';
        ctx.textAlign = 'center';
        ctx.fillText('📄', canvas.width / 2, canvas.height / 2 - 40);

        // File type
        ctx.fillStyle = '#dc2626'; // Red for DOC
        ctx.font = 'bold 14px Arial';
        ctx.fillText('DOC', canvas.width / 2, canvas.height / 2 - 10);

        // Page info
        ctx.fillStyle = '#6b7280';
        ctx.font = '12px Arial';
        ctx.fillText(`Page ${pageIndex + 1}`, canvas.width / 2, canvas.height / 2 + 20);

        // Extract first few words for preview
        const textPreview = extractTextPreview(htmlContent, 5);
        if (textPreview) {
          ctx.fillStyle = '#374151';
          ctx.font = '10px Arial';
          ctx.textAlign = 'center';

          // Wrap text
          const lines = wrapText(ctx, textPreview, canvas.width - 40);
          lines.forEach((line, index) => {
            ctx.fillText(line, canvas.width / 2, canvas.height / 2 + 50 + (index * 12));
          });
        }

        // Exact page count badge
        ctx.fillStyle = '#10b981';
        ctx.font = 'bold 10px Arial';
        ctx.fillText('EXACT COUNT', canvas.width / 2, canvas.height / 2 + 90);

        return canvas.toDataURL('image/png');

      } catch (error) {
        console.error('DOC page preview generation failed:', error);
        return null;
      }
    };

    // Extract text preview from HTML
    const extractTextPreview = (htmlContent, wordCount = 10) => {
      try {
        // Remove HTML tags and get plain text
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = htmlContent;
        const text = tempDiv.textContent || tempDiv.innerText || '';

        // Get first few words
        const words = text.trim().split(/\s+/).slice(0, wordCount);
        return words.join(' ') + (words.length === wordCount ? '...' : '');
      } catch (error) {
        return null;
      }
    };

    // Wrap text for canvas
    const wrapText = (ctx, text, maxWidth) => {
      const words = text.split(' ');
      const lines = [];
      let currentLine = words[0];

      for (let i = 1; i < words.length; i++) {
        const word = words[i];
        const width = ctx.measureText(currentLine + ' ' + word).width;
        if (width < maxWidth) {
          currentLine += ' ' + word;
        } else {
          lines.push(currentLine);
          currentLine = word;
        }
      }
      lines.push(currentLine);
      return lines;
    };



    // Generate preview from actual pages
    const generateWordDocumentPreview = async (file) => {
      try {
        let pageCount = 1;
        let previewImage = null;

        // Get exact page count first
        if (file.type.includes('word') || file.type.includes('document')) {
          pageCount = await getExactWordPageCount(file);

          // Generate preview from first page
          if (file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
            previewImage = await generatePagePreview(file, 0);
          } else {
            previewImage = await generateDocPagePreview(file, 0);
          }
        }

        return previewImage || await createPlaceholderPreview(file.name, pageCount);

      } catch (error) {
        console.error('Preview generation failed:', error);
        return await createPlaceholderPreview(file.name, 1);
      }
    };

    // Generate preview for a specific page
    const generatePagePreview = async (file, pageIndex) => {
      try {
        // Create a canvas with page content
        const canvas = document.createElement('canvas');
        canvas.width = 595; // A4 width at 72 DPI
        canvas.height = 842; // A4 height at 72 DPI
        const ctx = canvas.getContext('2d');

        // Page background
        ctx.fillStyle = 'white';
        ctx.fillRect(0, 0, canvas.width, canvas.height);

        // Page border
        ctx.strokeStyle = '#e5e7eb';
        ctx.lineWidth = 1;
        ctx.strokeRect(10, 10, canvas.width - 20, canvas.height - 20);

        // Document icon
        ctx.fillStyle = '#3b82f6';
        ctx.font = 'bold 32px Arial';
        ctx.textAlign = 'center';
        ctx.fillText('📄', canvas.width / 2, canvas.height / 2 - 40);

        // File type
        const fileType = file.type.includes('openxml') ? 'DOCX' : 'DOC';
        ctx.fillStyle = fileType === 'DOCX' ? '#059669' : '#dc2626';
        ctx.font = 'bold 14px Arial';
        ctx.fillText(fileType, canvas.width / 2, canvas.height / 2 - 10);

        // Page info
        ctx.fillStyle = '#6b7280';
        ctx.font = '12px Arial';
        ctx.fillText(`Page ${pageIndex + 1}`, canvas.width / 2, canvas.height / 2 + 20);

        // Exact page count badge
        ctx.fillStyle = '#10b981';
        ctx.font = 'bold 10px Arial';
        ctx.fillText('EXACT COUNT', canvas.width / 2, canvas.height / 2 + 40);

        return canvas.toDataURL('image/png');

      } catch (error) {
        console.error('Page preview generation failed:', error);
        return null;
      }
    };

    const readFileAsDataURL = (file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
    };

    const readFileAsBase64 = (file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
    };

    const generateFilePreviews = async (file) => {
      const fileType = file.type;

      if (fileType === 'application/pdf') {
        try {
          const arrayBuffer = await file.arrayBuffer();
          const pdf = await pdfjsLib.getDocument(arrayBuffer).promise;
          const numPages = pdf.numPages;
          const previewPagesArray = [];
          const maxPreviews = Math.min(numPages, 5);

          for (let i = 1; i <= maxPreviews; i++) {
            const page = await pdf.getPage(i);
            const viewport = page.getViewport({ scale: 0.8 });
            const canvas = document.createElement('canvas');
            const context = canvas.getContext('2d');
            canvas.height = viewport.height;
            canvas.width = viewport.width;
            await page.render({ canvasContext: context, viewport: viewport }).promise;
            const dataUrl = canvas.toDataURL('image/png');
            previewPagesArray.push(dataUrl);
          }
          return previewPagesArray;
        } catch (error) {
          return [];
        }
      } else if (fileType === 'image/jpeg' || fileType === 'image/png') {
        try {
          const dataUrl = await readFileAsDataURL(file);
          return [dataUrl];
        } catch (error) {
          return [];
        }
      } else {
        return [];
      }
    };

    // Add this function outside the WordToPDFConverter component, but inside the DocumentModal
    const convertWordToPDF = async (wordFile) => {
      const formData = new FormData();
      formData.append('file', wordFile);

      try {
        const response = await axios.post(
          'https://freezepix-database-server-c95d4dd2046d.herokuapp.com/convert-to-pdf',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            },
            responseType: 'blob',
            timeout: 180000,
          }
        );

        const pdfBlob = response.data;

        // Get filename
        const contentDisposition = response.headers['content-disposition'];
        let fileName = wordFile.name.replace(/\.(doc|docx)$/i, '.pdf');

        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename\*?=['"]?(?:UTF-\d['"]*)?([^;\r\n"']*)['"]?;?/);
          if (fileNameMatch && fileNameMatch[1]) {
            fileName = decodeURIComponent(fileNameMatch[1]);
          }
        }

        return new File([pdfBlob], fileName, { type: 'application/pdf' });

      } catch (error) {
        console.error('❌ Conversion error:', error);

        let errorMessage = '';

        if (error.code === 'ECONNABORTED') {
          errorMessage = 'Timeout: File is too large or complex. Try a smaller file.';
        } else if (error.response) {
          const serverError = error.response.data?.error || error.response.data?.message;
          errorMessage = `Server error (${error.response.status}): ${serverError || 'Conversion failed'}`;
        } else if (error.request) {
          errorMessage = 'Cannot contact server. Check your internet connection.';
        } else {
          errorMessage = `Error: ${error.message}`;
        }

        throw new Error(errorMessage);
      }
    };

    const WordToPDFConverter = () => {
      const [isConverting, setIsConverting] = useState(false);
      const [progress, setProgress] = useState(0);
      const [statusMessage, setStatusMessage] = useState('');
      const [error, setError] = useState('');

      const handleFileChange = async (event) => {
        const file = event.target.files[0];

        if (!file) return;

        // Check file type
        const validTypes = [
          'application/msword',
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
        ];

        if (!validTypes.includes(file.type)) {
          setError('❌ Invalid format. Use .doc or .docx files only.');
          return;
        }

        // Check file size (50 MB max)
        const maxSize = 50 * 1024 * 1024;
        if (file.size > maxSize) {
          setError('❌ File too large. Maximum 50 MB.');
          return;
        }

        // Reset states
        setIsConverting(true);
        setProgress(0);
        setStatusMessage('Preparing file...');
        setError('');

        // Simulate progress
        const progressInterval = setInterval(() => {
          setProgress(prev => {
            if (prev >= 90) return prev;
            return prev + 5;
          });
        }, 500);

        try {
          setStatusMessage('Converting...');

          // Use the shared conversion function
          const pdfFile = await convertWordToPDF(file);

          clearInterval(progressInterval);
          setProgress(100);
          setStatusMessage('✅ Conversion completed!');

          // Auto-download
          const downloadUrl = window.URL.createObjectURL(pdfFile);
          const link = document.createElement('a');
          link.href = downloadUrl;
          link.download = pdfFile.name;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(downloadUrl);

          console.log('✅ Conversion successful:', pdfFile.name);

          // Reset after 2 seconds
          setTimeout(() => {
            setIsConverting(false);
            setProgress(0);
            setStatusMessage('');
          }, 2000);

        } catch (err) {
          clearInterval(progressInterval);
          setError(err.message);
          setProgress(0);

          // Reset after 5 seconds
          setTimeout(() => {
            setIsConverting(false);
            setError('');
            setStatusMessage('');
          }, 5000);
        }
      };

      return (
        <div className="converter-container">
          <div className="upload-section">
            <label htmlFor="word-file-input" className="upload-label">
              {isConverting ? '🔄 Converting...' : '📄 Convert Word → PDF'}
            </label>

            <input
              id="word-file-input"
              type="file"
              accept=".doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
              onChange={handleFileChange}
              disabled={isConverting}
              className="file-input"
            />

            <p className="text-sm text-gray-600 mt-2">
              Convert your Word documents to PDF before printing
            </p>
          </div>

          {/* Progress bar */}
          {isConverting && (
            <div className="progress-container">
              <div className="progress-bar-wrapper">
                <div
                  className="progress-bar"
                  style={{ width: `${progress}%` }}
                >
                  <span className="progress-text">{progress}%</span>
                </div>
              </div>

              <div className="status-message">
                <div className="spinner"></div>
                <span>{statusMessage}</span>
              </div>
            </div>
          )}

          {/* Error message */}
          {error && (
            <div className="error-message">
              {error}
            </div>
          )}
        </div>
      );
    };






    // Word Document Analysis Functions
    const analyzeWordDocument = async (file) => {
      try {
        if (file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
          return await analyzeDocxWithJSZip(file);
        } else if (file.type === 'application/msword') {
          return await analyzeDocWithMammoth(file);
        } else {
          throw new Error('Unsupported Word format');
        }
      } catch (error) {
        console.error('Word analysis failed:', error);
        return await getFallbackPageCount(file);
      }
    };

    const analyzeDocxWithJSZip = async (file) => {
      try {
        const arrayBuffer = await file.arrayBuffer();
        const JSZip = await import('jszip');
        const zip = await JSZip.loadAsync(arrayBuffer);

        const documentXml = await zip.file('word/document.xml').async('text');
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(documentXml, 'text/xml');

        const paragraphs = xmlDoc.getElementsByTagName('w:p').length;
        const sections = xmlDoc.getElementsByTagName('w:sectPr').length;
        const pageBreaks = xmlDoc.getElementsByTagName('w:br').length +
          xmlDoc.getElementsByTagName('w:lastRenderedPageBreak').length;

        let pageCount = 1;

        if (sections > 0) {
          pageCount = Math.max(pageCount, sections);
        }

        if (pageBreaks > 0) {
          pageCount = Math.max(pageCount, pageBreaks + 1);
        }

        const paragraphsPerPage = 8;
        const paragraphBasedPages = Math.max(1, Math.ceil(paragraphs / paragraphsPerPage));

        pageCount = Math.max(pageCount, paragraphBasedPages);

        console.log(`DOCX analysis: ${paragraphs} paragraphs, ${sections} sections = ${pageCount} pages`);
        return pageCount;

      } catch (error) {
        console.error('DOCX JSZip analysis failed:', error);
        throw error;
      }
    };

    const analyzeDocWithMammoth = async (file) => {
      try {
        const arrayBuffer = await file.arrayBuffer();
        const result = await mammoth.extractRawText({ arrayBuffer });
        const text = result.value;

        if (!text || text.trim().length === 0) {
          return 1;
        }

        const lines = text.split('\n').filter(line => line.trim().length > 0);
        const paragraphs = text.split('\n\n').filter(para => para.trim().length > 0);

        const charsPerPage = 2000;
        const linesPerPage = 40;
        const paragraphsPerPage = 8;

        const charBased = Math.max(1, Math.ceil(text.length / charsPerPage));
        const lineBased = Math.max(1, Math.ceil(lines.length / linesPerPage));
        const paragraphBased = Math.max(1, Math.ceil(paragraphs.length / paragraphsPerPage));

        const pageCount = Math.max(charBased, lineBased, paragraphBased);

        console.log(`DOC analysis: ${text.length} chars, ${lines.length} lines, ${paragraphs.length} paragraphs = ${pageCount} pages`);
        return pageCount;

      } catch (error) {
        console.error('DOC Mammoth analysis failed:', error);
        throw error;
      }
    };

    const getFallbackPageCount = async (file) => {
      const bytesPerPage = 3000;
      const estimatedPages = Math.max(1, Math.ceil(file.size / bytesPerPage));
      console.log(`Using fallback page count: ${estimatedPages} pages`);
      return estimatedPages;
    };


    const createPlaceholderPreview = async (fileName) => {
      const canvas = document.createElement('canvas');
      canvas.width = 200;
      canvas.height = 280;
      const ctx = canvas.getContext('2d');

      ctx.fillStyle = '#f3f4f6';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.strokeStyle = '#d1d5db';
      ctx.lineWidth = 2;
      ctx.strokeRect(5, 5, canvas.width - 10, canvas.height - 10);
      ctx.fillStyle = '#3b82f6';
      ctx.font = 'bold 48px Arial';
      ctx.fillText('📄', canvas.width / 2 - 24, canvas.height / 2 - 30);
      ctx.fillStyle = '#374151';
      ctx.font = '12px Arial';
      ctx.textAlign = 'center';
      const displayName = fileName.length > 20 ? fileName.substring(0, 17) + '...' : fileName;
      ctx.fillText(displayName, canvas.width / 2, canvas.height / 2 + 30);
      ctx.fillStyle = '#6b7280';
      ctx.font = '10px Arial';
      ctx.fillText('Word Document', canvas.width / 2, canvas.height / 2 + 50);

      return canvas.toDataURL('image/png');
    };

    const convertWithGoogleScript = async (file) => {
      const debug = {
        file: { name: file.name, type: file.type, size: file.size },
        steps: {},
        errors: []
      };

      console.group('🚀 convertWithGoogleScript - Start Conversion');
      console.log('📄 File info:', debug.file);

      try {
        // Step 1: Convert file to base64
        console.log('🔄 Step 1: Converting file to base64...');
        debug.steps.step1 = 'Converting to base64';

        const fileContent = await new Promise((resolve, reject) => {
          const reader = new FileReader();

          reader.onload = () => {
            console.log('✅ FileReader loaded successfully');
            resolve(reader.result);
          };

          reader.onerror = (error) => {
            console.error('❌ FileReader error:', error);
            reject(new Error(`File reading failed: ${error}`));
          };

          reader.onabort = () => {
            console.error('❌ FileReader aborted');
            reject(new Error('File reading aborted'));
          };

          console.log('📖 Reading file as Data URL...');
          reader.readAsDataURL(file);
        });

        const base64Data = fileContent.split(',')[1];
        debug.steps.base64Data = {
          fullLength: fileContent.length,
          dataLength: base64Data.length,
          prefix: fileContent.substring(0, 50) + '...'
        };

        console.log('✅ Base64 conversion successful:', {
          fullDataURLLength: fileContent.length,
          base64DataLength: base64Data.length,
          estimatedSize: Math.ceil(base64Data.length * 0.75) + ' bytes approx'
        });

        // Step 2: Send to server
        console.log('🔄 Step 2: Sending to server...');
        debug.steps.step2 = 'Sending to server';

        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 60000);

        const response = await fetch('https://freezepix-database-server-c95d4dd2046d.herokuapp.com/api/convert-doc-to-pdf-google', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            file: base64Data,
            mimeType: file.type
          }),
          signal: controller.signal
        });

        clearTimeout(timeoutId);

        debug.steps.serverResponse = {
          status: response.status,
          statusText: response.statusText,
          ok: response.ok
        };

        console.log('✅ Server response received:', debug.steps.serverResponse);

        if (!response.ok) {
          const errorText = await response.text();
          console.error('❌ Server error response:', errorText);
          throw new Error(`Server returned ${response.status}: ${errorText.substring(0, 200)}`);
        }

        // Step 3: Parse response
        console.log('🔄 Step 3: Parsing server response...');
        debug.steps.step3 = 'Parsing response';

        const result = await response.json();
        debug.steps.serverResult = {
          success: result.success,
          hasPdfBase64: !!result.pdfBase64,
          pdfBase64Length: result.pdfBase64?.length,
          fileName: result.fileName,
          pdfSize: result.pdfSize
        };

        console.log('✅ Server result parsed:', debug.steps.serverResult);

        if (!result.success) {
          console.error('❌ Server reported conversion failure:', result.error);
          throw new Error(result.error || 'Conversion failed on server');
        }

        if (!result.pdfBase64) {
          console.error('❌ No PDF data in response');
          throw new Error('Server returned no PDF data');
        }

        // Step 4: Convert base64 to PDF file
        console.log('🔄 Step 4: Converting base64 to PDF file...');
        debug.steps.step4 = 'Converting base64 to PDF';

        console.log('📊 PDF base64 info:', {
          length: result.pdfBase64.length,
          first100: result.pdfBase64.substring(0, 100),
          isBase64: /^[A-Za-z0-9+/]*={0,2}$/.test(result.pdfBase64.replace(/\s/g, ''))
        });

        const pdfBlob = await base64ToBlob(result.pdfBase64, 'application/pdf');
        debug.steps.pdfBlob = {
          size: pdfBlob.size,
          type: pdfBlob.type
        };

        console.log('✅ PDF blob created:', debug.steps.pdfBlob);

        // ========== STEP 5: COMPREHENSIVE FILE CREATION WITH ALL FALLBACKS ==========
        console.log('🔄 Step 5: Creating final File object...');
        debug.steps.step5 = 'Creating File object';

        const pdfName = file.name.replace(/\.(doc|docx)$/i, '.pdf') || 'converted.pdf';
        console.log('🎯 Target filename:', pdfName);

        // Method 1: Standard File Constructor (Primary)
        try {
          console.log('📝 Attempting Method 1: Standard File constructor');

          const pdfFile = new File([pdfBlob], pdfName, {
            type: 'application/pdf',
            lastModified: new Date().getTime()
          });

          debug.steps.finalFile = {
            method: 'Standard File Constructor',
            name: pdfFile.name,
            type: pdfFile.type,
            size: pdfFile.size,
            isFileInstance: pdfFile instanceof File,
            isBlobInstance: pdfFile instanceof Blob,
            hasName: !!pdfFile.name,
            hasLastModified: !!pdfFile.lastModified
          };

          console.log('✅ Method 1 successful - File created:', debug.steps.finalFile);
          console.log('🎉 Conversion completed successfully!');
          console.groupEnd();

          return pdfFile;
        } catch (error1) {
          console.warn('❌ Method 1 (File constructor) failed:', error1.message);
          debug.errors.push({ method: 'File Constructor', error: error1.message });
        }

        // Method 2: Enhanced Custom File-like object with full Blob compatibility
        try {
          console.log('📝 Attempting Method 2: Enhanced Custom File-like object');

          // Create a proper Blob that we can extend
          const finalBlob = new Blob([pdfBlob], { type: 'application/pdf' });

          // Create enhanced object with proper prototype chain
          const pdfFile = Object.create(finalBlob, {
            name: {
              value: pdfName,
              writable: false,
              enumerable: true,
              configurable: true
            },
            lastModified: {
              value: new Date().getTime(),
              writable: false,
              enumerable: true,
              configurable: true
            },
            webkitRelativePath: {
              value: '',
              writable: false,
              enumerable: false,
              configurable: true
            },
            // Ensure it's recognized as a File
            constructor: {
              value: File,
              writable: false,
              enumerable: false,
              configurable: true
            }
          });

          // Add Symbol.toStringTag to make it behave like a File
          if (Symbol && Symbol.toStringTag) {
            Object.defineProperty(pdfFile, Symbol.toStringTag, {
              value: 'File',
              configurable: true
            });
          }

          debug.steps.finalFile = {
            method: 'Enhanced Custom File Object',
            name: pdfFile.name,
            type: pdfFile.type,
            size: pdfFile.size,
            isBlob: pdfFile instanceof Blob,
            hasName: !!pdfFile.name,
            hasLastModified: !!pdfFile.lastModified,
            symbolSupport: !!(Symbol && Symbol.toStringTag)
          };

          console.log('✅ Method 2 successful - Enhanced file object created:', debug.steps.finalFile);
          console.log('🎉 Conversion completed successfully with enhanced custom object!');
          console.groupEnd();

          return pdfFile;
        } catch (error2) {
          console.warn('❌ Method 2 (Enhanced custom object) failed:', error2.message);
          debug.errors.push({ method: 'Enhanced Custom Object', error: error2.message });
        }

        // Method 3: Blob with attached metadata (Simple & Compatible)
        try {
          console.log('📝 Attempting Method 3: Blob with attached metadata');

          // Create final blob
          const finalBlob = new Blob([pdfBlob], {
            type: 'application/pdf'
          });

          // Attach file properties directly to the blob
          finalBlob.name = pdfName;
          finalBlob.lastModified = new Date().getTime();
          finalBlob._isEnhancedBlob = true; // Mark as enhanced for debugging

          debug.steps.finalFile = {
            method: 'Blob with Attached Metadata',
            name: finalBlob.name,
            type: finalBlob.type,
            size: finalBlob.size,
            isBlob: finalBlob instanceof Blob,
            hasName: !!finalBlob.name,
            hasLastModified: !!finalBlob.lastModified,
            isEnhanced: !!finalBlob._isEnhancedBlob
          };

          console.log('✅ Method 3 successful - Blob with metadata created:', debug.steps.finalFile);
          console.log('🎉 Conversion completed successfully with enhanced blob!');
          console.groupEnd();

          return finalBlob;
        } catch (error3) {
          console.warn('❌ Method 3 (Blob with metadata) failed:', error3.message);
          debug.errors.push({ method: 'Blob with Metadata', error: error3.message });
        }

        // Method 4: Object wrapper with blob reference
        try {
          console.log('📝 Attempting Method 4: Object wrapper with blob reference');

          const resultWrapper = {
            // Core file properties
            name: pdfName,
            type: 'application/pdf',
            size: pdfBlob.size,
            lastModified: new Date().getTime(),

            // Reference to the actual blob
            blob: pdfBlob,

            // Blob methods for compatibility
            arrayBuffer: () => pdfBlob.arrayBuffer(),
            slice: (...args) => pdfBlob.slice(...args),
            stream: () => pdfBlob.stream(),
            text: () => pdfBlob.text(),

            // Mark as wrapper for identification
            _isBlobWrapper: true,

            // toString behavior
            toString: () => `[File: ${pdfName}]`
          };

          debug.steps.finalFile = {
            method: 'Object Wrapper with Blob',
            name: resultWrapper.name,
            type: resultWrapper.type,
            size: resultWrapper.size,
            hasBlob: !!resultWrapper.blob,
            isWrapper: !!resultWrapper._isBlobWrapper
          };

          console.log('✅ Method 4 successful - Object wrapper created:', debug.steps.finalFile);
          console.log('🎉 Conversion completed successfully with object wrapper!');
          console.groupEnd();

          return resultWrapper;
        } catch (error4) {
          console.warn('❌ Method 4 (Object wrapper) failed:', error4.message);
          debug.errors.push({ method: 'Object Wrapper', error: error4.message });
        }

        // Method 5: Last resort - return raw blob with minimal metadata
        console.log('📝 Attempting Method 5: Raw blob with minimal metadata');

        // Add basic properties directly to the original blob
        pdfBlob.name = pdfName;
        pdfBlob._isFallbackBlob = true;

        debug.steps.finalFile = {
          method: 'Raw Blob Fallback',
          name: pdfBlob.name,
          type: pdfBlob.type,
          size: pdfBlob.size,
          isBlob: pdfBlob instanceof Blob,
          isFallback: !!pdfBlob._isFallbackBlob
        };

        console.log('✅ Method 5 successful - Raw blob returned:', debug.steps.finalFile);
        console.log('🎉 Conversion completed successfully with raw blob fallback!');
        console.groupEnd();

        return pdfBlob;

      } catch (error) {
        console.error('💥 Conversion failed:', error);
        debug.errors.push({
          step: debug.steps.current,
          error: error.message,
          stack: error.stack
        });

        console.log('📊 Failure debug summary:', {
          stepsCompleted: Object.keys(debug.steps),
          errors: debug.errors,
          finalStep: debug.steps.current
        });

        console.groupEnd();

        // Enhanced error messages
        let userMessage = error.message;
        if (error.name === 'AbortError') {
          userMessage = 'Conversion timeout - please try again';
        } else if (error.message.includes('NetworkError')) {
          userMessage = 'Network connection failed - please check your internet';
        } else if (error.message.includes('CORS')) {
          userMessage = 'Server connection blocked - please refresh and try again';
        } else if (error.message.includes('I is not a constructor')) {
          userMessage = 'Browser compatibility issue - using enhanced conversion method';
        } else if (debug.errors.length > 0) {
          userMessage = `Conversion completed with ${debug.errors.length} fallbacks - file may have limited functionality`;
        }

        throw new Error(userMessage);
      }
    };


    // Helper function to convert base64 to Blob
    const base64ToBlob = async (base64, mimeType = 'application/octet-stream') => {
      const debug = {
        step: '',
        inputLength: base64?.length || 0,
        mimeType,
        errors: []
      };

      console.group('🔧 base64ToBlob Debug - Start');
      console.log('📥 Input:', {
        base64Length: base64?.length,
        mimeType,
        first50Chars: base64?.substring(0, 50),
        last50Chars: base64?.substring(Math.max(0, base64?.length - 50))
      });

      try {
        // Validate input
        if (!base64 || typeof base64 !== 'string') {
          throw new Error('Invalid base64 input: must be a non-empty string');
        }

        // Method 1: Direct Uint8Array approach (fastest)
        debug.step = 'Method 1 - Direct Uint8Array';
        console.log('🔄 Attempting:', debug.step);

        try {
          const cleanBase64 = base64.replace(/[\s\n\r]/g, '');
          console.log('🧹 Cleaned base64 length:', cleanBase64.length);

          const binaryString = atob(cleanBase64);
          console.log('🔤 Binary string length:', binaryString.length);

          const bytes = new Uint8Array(binaryString.length);
          for (let i = 0; i < binaryString.length; i++) {
            bytes[i] = binaryString.charCodeAt(i);
          }

          const blob = new Blob([bytes], { type: mimeType });
          console.log('✅ Method 1 successful - Blob created:', {
            size: blob.size,
            type: blob.type
          });

          console.groupEnd();
          return blob;
        } catch (error1) {
          debug.errors.push({ method: 1, error: error1.message });
          console.warn('❌ Method 1 failed:', error1.message);
        }

        // Method 2: Chunked approach (for large files)
        debug.step = 'Method 2 - Chunked Uint8Array';
        console.log('🔄 Attempting:', debug.step);

        try {
          const cleanBase64 = base64.replace(/[\s\n\r]/g, '');
          const binaryString = atob(cleanBase64);
          const chunkSize = 8192; // 8KB chunks
          const byteArrays = [];

          for (let offset = 0; offset < binaryString.length; offset += chunkSize) {
            const slice = binaryString.slice(offset, offset + chunkSize);
            const byteNumbers = new Array(slice.length);

            for (let i = 0; i < slice.length; i++) {
              byteNumbers[i] = slice.charCodeAt(i);
            }

            byteArrays.push(new Uint8Array(byteNumbers));
          }

          const blob = new Blob(byteArrays, { type: mimeType });
          console.log('✅ Method 2 successful - Blob created:', {
            size: blob.size,
            type: blob.type,
            chunks: byteArrays.length
          });

          console.groupEnd();
          return blob;
        } catch (error2) {
          debug.errors.push({ method: 2, error: error2.message });
          console.warn('❌ Method 2 failed:', error2.message);
        }

        // Method 3: Fetch data URL approach (most compatible)
        debug.step = 'Method 3 - Fetch data URL';
        console.log('🔄 Attempting:', debug.step);

        try {
          const dataUrl = `data:${mimeType};base64,${base64}`;
          console.log('🔗 Data URL length:', dataUrl.length);

          const response = await fetch(dataUrl);
          if (!response.ok) throw new Error(`Fetch failed: ${response.status}`);

          const blob = await response.blob();
          console.log('✅ Method 3 successful - Blob created:', {
            size: blob.size,
            type: blob.type
          });

          console.groupEnd();
          return blob;
        } catch (error3) {
          debug.errors.push({ method: 3, error: error3.message });
          console.warn('❌ Method 3 failed:', error3.message);
        }

        // Method 4: Manual byte construction (fallback)
        debug.step = 'Method 4 - Manual byte construction';
        console.log('🔄 Attempting:', debug.step);

        try {
          const cleanBase64 = base64.replace(/[\s\n\r]/g, '');
          const binaryString = atob(cleanBase64);
          const byteArray = [];

          for (let i = 0; i < binaryString.length; i++) {
            byteArray.push(binaryString.charCodeAt(i));
          }

          const blob = new Blob([new Uint8Array(byteArray)], { type: mimeType });
          console.log('✅ Method 4 successful - Blob created:', {
            size: blob.size,
            type: blob.type
          });

          console.groupEnd();
          return blob;
        } catch (error4) {
          debug.errors.push({ method: 4, error: error4.message });
          console.warn('❌ Method 4 failed:', error4.message);
        }

        // All methods failed
        throw new Error(`All conversion methods failed. Errors: ${JSON.stringify(debug.errors)}`);

      } catch (finalError) {
        console.error('💥 All base64 conversion methods failed:', finalError);
        console.log('📊 Debug summary:', debug);
        console.groupEnd();
        throw finalError;
      }
    };

    const setDefaultFileOptions = (fileId) => {
      setFileOptions(prev => ({
        ...prev,
        [fileId]: {
          pageSelection: 'all', // Default to all pages
          pageRange: '', // Empty for all pages
          sides: 'simplex', // Default to simplex
          color: 'bw', // Default to black and white
          copies: 1, // Default to 1 copy
          paperSize: 'a4' // Default to A4
        }
      }));
    };


    // Update the handleFileUpload function to call this
    const handleFileUpload = async (eventFiles) => {
      const filesToProcess = Array.from(eventFiles);

      for (const file of filesToProcess) {
        if (!file) continue;

        setUploadError('');
        let fileId;

        try {
          const maxFileSize = 50 * 1024 * 1024;
          if (file.size > maxFileSize) {
            throw new Error(getTranslatedText('uploadErrorFileSize', { maxSize: maxFileSize / (1024 * 1024) }));
          }

          const allowedTypes = [
            'application/pdf',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'application/msword'
          ];

          if (!allowedTypes.includes(file.type)) {
            throw new Error('Accepted formats: PDF, DOC, DOCX');
          }

          if (uploadedFiles.some(f => f.name === file.name && f.size === file.size)) {
            throw new Error(getTranslatedText('uploadErrorFileExists'));
          }

          fileId = Date.now() + Math.random();

          // CRITICAL: Set default options immediately when file is added
          setDefaultFileOptions(fileId);

          // Set processing states
          setUploadedFiles(prev => [...prev, {
            id: fileId,
            name: file.name,
            size: file.size,
            type: file.type,
            totalPages: null,
            previewPages: [],
            originalFile: file,
            fileAnalysis: '',
            isGettingPageCount: true,
            isGeneratingPreview: true,
            wasConverted: false,
            processedFile: null
          }]);

          let totalPages = 1;
          let previewPages = [];
          let fileAnalysis = '';
          let processedFile = file;
          let wasConverted = false;

          // Process based on file type
          if (file.type === 'application/pdf') {
            totalPages = await getPageCountFromPDF(file);
            previewPages = await generateFilePreviews(file);
            fileAnalysis = 'PDF';
          }
          else if (file.type.includes('word') || file.type.includes('document')) {
            try {
              setUploadError('Converting Word document to PDF...');
              processedFile = await convertWithGoogleScript(file);
              wasConverted = true;

              console.log('✅ Conversion successful, getting page count for PDF...');

              if (processedFile && processedFile instanceof Blob) {
                totalPages = await getPageCountFromPDF(processedFile);
                console.log(`📄 Converted PDF has ${totalPages} pages`);

                previewPages = await generateFilePreviews(processedFile);
                fileAnalysis = `Word → PDF (${totalPages} pages)`;
              } else {
                throw new Error('Converted file is not a valid PDF');
              }

            } catch (conversionError) {
              console.error('Google Script conversion failed:', conversionError);
              totalPages = await analyzeWordDocument(file);
              previewPages = [await createWordDocumentPreview(file)];
              fileAnalysis = 'Word - Estimated pages';
              processedFile = file;
            }
          }

          // Validate page count
          if (totalPages === 0 || totalPages === null || isNaN(totalPages)) {
            console.warn('Page count is 0, using fallback page count');
            totalPages = 1;
          }

          // Update file with results
          setUploadedFiles(prev => prev.map(f =>
            f.id === fileId ? {
              ...f,
              totalPages: totalPages,
              previewPages: previewPages,
              fileAnalysis: fileAnalysis,
              isGettingPageCount: false,
              isGeneratingPreview: false,
              wasConverted: wasConverted,
              processedFile: processedFile,
              name: wasConverted ? file.name.replace(/\.(doc|docx)$/i, '.pdf') : file.name
            } : f
          ));

          // Store file data
          if (processedFile) {
            fileDataMap.current.set(fileId, {
              base64: await readFileAsBase64(processedFile),
              originalFile: processedFile,
              wasConverted: wasConverted
            });
          }

          setUploadError('');

        } catch (error) {
          console.error('File processing error:', error);
          setUploadError(`Error processing ${file.name}: ${error.message}`);
          if (fileId) {
            setUploadedFiles(prev => prev.filter(f => f.id !== fileId));
            // Also remove the file options if file fails
            setFileOptions(prev => {
              const { [fileId]: removed, ...rest } = prev;
              return rest;
            });
          }
        }
      }
    };

    const createWordDocumentPreview = async (file) => {
      try {
        let documentInfo = '';

        if (file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
          // Try to extract some content from DOCX for preview
          const arrayBuffer = await file.arrayBuffer();
          const JSZip = await import('jszip');
          const zip = await JSZip.loadAsync(arrayBuffer);

          try {
            const documentXml = await zip.file('word/document.xml').async('text');
            const parser = new DOMParser();
            const xmlDoc = parser.parseFromString(documentXml, 'text/xml');

            // Extract first few paragraphs for preview
            const paragraphs = xmlDoc.getElementsByTagName('w:p');
            let previewText = '';
            for (let i = 0; i < Math.min(3, paragraphs.length); i++) {
              const textNodes = paragraphs[i].getElementsByTagName('w:t');
              for (let j = 0; j < textNodes.length; j++) {
                previewText += textNodes[j].textContent + ' ';
              }
              if (previewText.length > 100) break;
            }
            documentInfo = previewText.trim() || 'Word document content';
          } catch (e) {
            documentInfo = 'DOCX document';
          }
        } else {
          // For DOC files, use Mammoth to extract text preview
          try {
            const arrayBuffer = await file.arrayBuffer();
            const result = await mammoth.extractRawText({ arrayBuffer });
            const text = result.value;
            documentInfo = text.substring(0, 150).trim() + (text.length > 150 ? '...' : '') || 'DOC document';
          } catch (e) {
            documentInfo = 'DOC document';
          }
        }

        // Create preview canvas
        const canvas = document.createElement('canvas');
        canvas.width = 200;
        canvas.height = 280;
        const ctx = canvas.getContext('2d');

        // Background
        ctx.fillStyle = '#f8fafc';
        ctx.fillRect(0, 0, canvas.width, canvas.height);

        // Border
        ctx.strokeStyle = '#e2e8f0';
        ctx.lineWidth = 2;
        ctx.strokeRect(5, 5, canvas.width - 10, canvas.height - 10);

        // File icon
        ctx.fillStyle = '#2563eb';
        ctx.font = 'bold 40px Arial';
        ctx.textAlign = 'center';
        ctx.fillText('📄', canvas.width / 2, canvas.height / 2 - 20);

        // File type badge
        const fileType = file.type.includes('openxml') ? 'DOCX' : 'DOC';
        ctx.fillStyle = fileType === 'DOCX' ? '#059669' : '#dc2626';
        ctx.font = 'bold 12px Arial';
        ctx.fillText(fileType, canvas.width / 2, canvas.height / 2 + 10);

        // Document preview text
        ctx.fillStyle = '#475569';
        ctx.font = '10px Arial';

        // Wrap text
        const lines = [];
        const words = documentInfo.split(' ');
        let currentLine = '';

        for (const word of words) {
          const testLine = currentLine ? `${currentLine} ${word}` : word;
          const metrics = ctx.measureText(testLine);

          if (metrics.width > canvas.width - 20) {
            lines.push(currentLine);
            currentLine = word;
          } else {
            currentLine = testLine;
          }

          if (lines.length >= 3) break;
        }

        if (currentLine && lines.length < 3) {
          lines.push(currentLine);
        }

        // Draw lines
        lines.forEach((line, index) => {
          ctx.fillText(line, canvas.width / 2, canvas.height / 2 + 30 + (index * 12));
        });

        return canvas.toDataURL('image/png');

      } catch (error) {
        console.error('Word preview creation failed:', error);
        return await createPlaceholderPreview(file.name);
      }
    };
    const updateFileOption = (fileId, optionKey, value) => {
      setFileOptions(prev => {
        const newOptions = {
          ...prev,
          [fileId]: {
            ...prev[fileId],
            [optionKey]: value
          }
        };

        const fileToUpdate = uploadedFiles.find(f => f.id === fileId);

        if (fileToUpdate && fileToUpdate.originalFile && fileToUpdate.totalPages !== null) {
          if (optionKey === 'pageSelection' || optionKey === 'pageRange') {
            const currentSelection = newOptions[fileId].pageSelection;
            const currentRange = newOptions[fileId].pageRange;

            if (currentSelection === 'range' && currentRange) {
              const parsedPageNumbers = parsePageRange(currentRange, fileToUpdate.totalPages);
              if (parsedPageNumbers.length > 0) {
                regenerateSpecificPreviews(fileId, fileToUpdate.originalFile, parsedPageNumbers, fileToUpdate.totalPages);
              } else {
                setUploadedFiles(prevFiles => prevFiles.map(f =>
                  f.id === fileId ? { ...f, previewPages: [] } : f
                ));
                setCurrentPreviewPageForFile(prev => ({ ...prev, [fileId]: 0 }));
              }
            } else if (currentSelection === 'all') {
              if (fileToUpdate.originalFile.type === 'application/pdf') {
                const pagesToGenerate = Math.min(fileToUpdate.totalPages, 5);
                const allPageNumbers = Array.from({ length: pagesToGenerate }, (_, i) => i + 1);
                regenerateSpecificPreviews(fileId, fileToUpdate.originalFile, allPageNumbers, fileToUpdate.totalPages);
              } else if (fileToUpdate.originalFile.type === 'image/jpeg' || fileToUpdate.originalFile.type === 'image/png') {
                regenerateSpecificPreviews(fileId, fileToUpdate.originalFile, [1], fileToUpdate.totalPages);
              } else {
                const existingFile = uploadedFiles.find(f => f.id === fileId);
                if (existingFile && existingFile.previewPages && existingFile.previewPages.length > 0) {
                  setUploadedFiles(prevFiles => prevFiles.map(f =>
                    f.id === fileId ? { ...f, previewPages: existingFile.previewPages } : f
                  ));
                } else {
                  setUploadedFiles(prevFiles => prevFiles.map(f =>
                    f.id === fileId ? { ...f, previewPages: [] } : f
                  ));
                }
                setCurrentPreviewPageForFile(prev => ({ ...prev, [fileId]: 0 }));
              }
            }
          }
        }
        return newOptions;
      });
    };

    const removeFile = (fileId) => {
      setUploadedFiles(prev => prev.filter(f => f.id !== fileId));
      setFileOptions(prev => {
        const { [fileId]: removed, ...rest } = prev;
        return rest;
      });
      setCurrentPreviewPageForFile(prev => {
        const { [fileId]: removed, ...rest } = prev;
        return rest;
      });
    };

    const calculateFileCost = (file) => {
      const options = fileOptions[file.id] || {};
      const pages = options.pageSelection === "all"
        ? file.totalPages
        : calculateRangePages(options.pageRange, file.totalPages);
      const copies = options.copies || 1;
      const totalPages = pages * copies;
      const colorType = options.color || 'bw';
      const paperSize = (options.paperSize || 'a4').toLowerCase();

      console.log('calculateFileCost:', {
        fileName: file.name,
        pages,
        copies,
        totalPages,
        paperSize,
        colorType
      });

      if (!pricing || !pricing.documents || !pricing.documents[paperSize]) {
        console.error("Pricing structure missing for:", paperSize);
        console.log('Available pricing:', pricing);
        return 0;
      }

      const docPricing = pricing.documents[paperSize];
      const colorKey = colorType === 'color' ? 'color' : 'black_white';
      const colorPricing = docPricing[colorKey];

      if (!colorPricing) {
        console.error(`No pricing for ${paperSize} ${colorKey}`);
        return 0;
      }

      // Use tiered pricing
      let pricePerPage;
      if (totalPages >= 1 && totalPages <= 24) {
        pricePerPage = colorPricing.tiers?.['1-24'] || colorPricing.price_per_page;
      } else if (totalPages >= 25 && totalPages <= 74) {
        pricePerPage = colorPricing.tiers?.['25-74'] || colorPricing.price_per_page;
      } else {
        pricePerPage = colorPricing.tiers?.['75+'] || colorPricing.price_per_page;
      }

      const cost = totalPages * pricePerPage;
      console.log(`File cost: ${totalPages} pages × $${pricePerPage} = $${cost}`);
      return cost;
    };


    const proceedToNextStep = () => {
      if (currentStep === 1 && uploadedFiles.length === 0) {
        setUploadError(getTranslatedText('uploadErrorNoFile'));
        return;
      }
      setUploadError('');
      if (currentStep < 2) {
        setCurrentStep(prev => prev + 1);
      }
    };

    const goToPreviousStep = () => {
      setUploadError('');
      if (currentStep > 1) {
        setCurrentStep(prev => prev - 1);
      }
    };

    const addToCart = () => {
      if (isAnyFileProcessing) {
        return;
      }

      const orderItems = uploadedFiles.map(file => {
        const optionsForFile = fileOptions[file.id] || {
          pageSelection: "all",
          pageRange: "",
          sides: "simplex",
          color: "bw",
          copies: 1
        };
        const pagesToPrint = optionsForFile.pageSelection === "all" ? file.totalPages : calculateRangePages(optionsForFile.pageRange, file.totalPages);

        // CRITICAL: Use the processed PDF file if conversion happened
        const fileToUse = file.processedFile || file.originalFile;
        const finalFileName = file.wasConverted ? file.name.replace(/\.(doc|docx)$/i, '.pdf') : file.name;

        return {
          id: file.id,
          name: finalFileName, // Use the PDF filename
          originalName: file.name, // Keep original name for reference
          pages: pagesToPrint,
          options: optionsForFile,
          cost: calculateFileCost(file),
          previewUrl: file.previewPages.length > 0 ? file.previewPages[0] : null,
          previewPages: file.previewPages,
          originalFile: fileToUse, // This should be the PDF file after conversion
          base64: file.base64,
          fileType: file.wasConverted ? 'application/pdf' : file.type, // Ensure fileType is PDF after conversion
          wasConverted: file.wasConverted || false
        };
      });

      const order = {
        type: "document",
        items: orderItems,
        totalCost: calculateTotalCost()
      };

      onAddToCart(order);
      setIsDocumentModalOpen(false);

      setCurrentStep(1);
      setUploadedFiles([]);
      setFileOptions({});
      setUploadError('');
      setCurrentPreviewPageForFile({});

      if (onDocumentAddToCartSuccess) {
        onDocumentAddToCartSuccess();
      }
    };

    const handleZoomIn = () => {
      setDocumentPreviewZoom(prev => Math.min(prev + 0.2, 3));
    };

    const handleZoomOut = () => {
      setDocumentPreviewZoom(prev => Math.max(prev - 0.2, 0.5));
    };

    return (
      <div className={`fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4 ${!isDocumentModalOpen ? 'hidden' : ''}`}>
        <div className="bg-white rounded-xl w-full max-w-4xl shadow-lg overflow-hidden flex flex-col" style={{ maxHeight: "90vh" }}>

          <div className="border-b border-gray-200 p-6">
            <div className="flex justify-between items-center">
              <h2 className="text-xl font-bold">{getTranslatedText('documentModalTitle')}</h2>
              <button onClick={() => {
                setIsDocumentModalOpen(false);
                setCurrentStep(1);
                setUploadedFiles([]);
                setFileOptions({});
                setUploadError('');
                setCurrentPreviewPageForFile({});
              }} className="text-gray-500 hover:text-gray-700">
                <X className="w-6 h-6" />
              </button>
            </div>

            <div className="mt-4 flex items-center">
              <div className="flex-1 bg-gray-200 rounded-full h-2">
                <div
                  className="bg-blue-600 h-2 rounded-full"
                  style={{ width: `${(currentStep / 2) * 100}%` }}
                />
              </div>
              <span className="ml-3 text-sm text-gray-500">
                {getTranslatedText('step')} {currentStep} {getTranslatedText('on')} 2
              </span>
            </div>
          </div>

          <div className="overflow-y-auto p-6 flex-1">
            {currentStep === 1 && (
              <div>
                <h3 className="text-lg font-semibold mb-4">{getTranslatedText('uploadDocuments')}</h3>



                {/* Single upload area */}
                <div
                  className={`border-2 border-dashed rounded-lg p-8 text-center cursor-pointer mb-4 transition-colors ${isDragOver
                    ? "border-blue-500 bg-blue-50"
                    : "border-gray-300 hover:border-blue-400 hover:bg-blue-25"
                    }`}
                  onClick={() => document.getElementById("fileInput").click()}
                  onDragOver={(e) => { e.preventDefault(); setIsDragOver(true); }}
                  onDragLeave={() => setIsDragOver(false)}
                  onDrop={(e) => {
                    e.preventDefault();
                    setIsDragOver(false);
                    const files = e.dataTransfer.files;

                    // Check for Word files and warn user
                    const wordFiles = Array.from(files).filter(file =>
                      file.type.includes('word') || file.type.includes('document')
                    );

                    if (wordFiles.length > 0) {
                      const shouldProceed = window.confirm(
                        `You're uploading ${wordFiles.length} Word document(s).\n\n` +
                        `We'll try to convert them to PDF automatically, but if conversion fails:\n\n` +
                        `• You can use free tools like SmallPDF.com or Google Docs\n` +
                        `• Or upload as Word files with limited functionality\n\n` +
                        `Continue with upload?`
                      );

                      if (!shouldProceed) return;
                    }

                    handleFileUpload(files);
                  }}
                >
                  <Upload className="w-12 h-12 mx-auto text-gray-400 mb-3" />
                  <p className="text-gray-700 font-medium">Click or drag files to upload</p>
                  <p className="text-sm text-gray-500 mt-1">
                    {getTranslatedText('formatsAccepted')}
                  </p>


                  <input
                    id="fileInput"
                    type="file"
                    onChange={(e) => {
                      const files = e.target.files;
                      if (files && files.length > 0) {
                        handleFileUpload(files);
                      }
                    }}
                    className="hidden"
                    accept=".pdf"
                    multiple
                  />
                </div>

                {/* Status Messages */}
                {isLoading && (
                  <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-4">
                    <div className="flex items-center">
                      <Loader2 className="w-4 h-4 animate-spin text-blue-500 mr-2" />
                      <span className="text-blue-700">Processing your files...</span>
                    </div>
                  </div>
                )}

                {uploadError && (
                  <div className={`rounded-lg p-4 mb-4 ${uploadError.includes('✅')
                    ? 'bg-green-50 border border-green-200 text-green-700'
                    : uploadError.includes('⚠️') || uploadError.includes('Conversion Service Unavailable')
                      ? 'bg-yellow-50 border border-yellow-200 text-yellow-700'
                      : 'bg-red-50 border border-red-200 text-red-700'
                    }`}>
                    <div className="flex items-start">
                      {uploadError.includes('✅') && <CheckCircle className="w-5 h-5 mr-2 mt-0.5 flex-shrink-0" />}
                      {uploadError.includes('⚠️') && <AlertCircle className="w-5 h-5 mr-2 mt-0.5 flex-shrink-0" />}
                      {uploadError.includes('Conversion Service Unavailable') && <AlertCircle className="w-5 h-5 mr-2 mt-0.5 flex-shrink-0" />}
                      {uploadError.includes('Upload cancelled') && <X className="w-5 h-5 mr-2 mt-0.5 flex-shrink-0" />}
                      <div className="flex-1">
                        <p className="text-sm font-medium">{uploadError.split('\n')[0]}</p>
                        {uploadError.includes('Conversion Service Unavailable') && (
                          <div className="mt-2 text-xs">
                            <p className="font-medium">Free conversion tools:</p>
                            <ul className="list-disc list-inside mt-1 space-y-1">
                              <li><a href="https://smallpdf.com/word-to-pdf" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">SmallPDF.com</a> - Easy drag & drop</li>
                              <li><a href="https://www.ilovepdf.com/word_to_pdf" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">ILovePDF.com</a> - Free Word to PDF</li>
                              <li><a href="https://docs.google.com" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">Google Docs</a> - Upload & export as PDF</li>
                            </ul>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}

                {/* Uploaded Files Display */}
                {uploadedFiles.length > 0 && (
                  <div>
                    <h4 className="font-medium mb-3 text-gray-700">{getTranslatedText('uploadedFiles')}</h4>
                    <div className="space-y-3">
                      {uploadedFiles.map(file => (
                        <div key={file.id} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg border">
                          <div className="flex items-center flex-1 min-w-0">
                            {/* Preview Image */}
                            {file.previewPages && file.previewPages.length > 0 ? (
                              <img
                                src={file.previewPages[0]}
                                alt="Preview"
                                className="w-10 h-10 object-contain mr-3 border rounded flex-shrink-0"
                              />
                            ) : file.isGeneratingPreview ? (
                              <div className="w-10 h-10 bg-gray-200 rounded border flex items-center justify-center mr-3 flex-shrink-0">
                                <Loader2 className="w-4 h-4 animate-spin text-gray-400" />
                              </div>
                            ) : (
                              <File className="text-blue-600 mr-3 w-10 h-10 flex-shrink-0" />
                            )}

                            <div className="flex-1 min-w-0">
                              <div className="flex items-center gap-2 mb-1">
                                <p className="font-medium text-gray-800 truncate">{file.name}</p>

                                {/* File Info Badge - Simplified */}
                                {file.totalPages !== null && (
                                  <span className="bg-blue-100 text-blue-800 text-xs px-2 py-0.5 rounded flex-shrink-0">
                                    {file.totalPages} {getTranslatedText('pages')}
                                  </span>
                                )}

                                {/* Loading Indicator */}
                                {file.isGettingPageCount && (
                                  <span className="bg-yellow-100 text-yellow-800 text-xs px-2 py-0.5 rounded flex items-center gap-1 flex-shrink-0">
                                    <Loader2 className="w-3 h-3 animate-spin" />
                                    {getTranslatedText('processing')}
                                  </span>
                                )}
                              </div>

                              <p className="text-xs text-gray-500">
                                {formatFileSize(file.size)}
                                {file.totalPages !== null && ` • ${file.totalPages} ${getTranslatedText('pages')}`}
                              </p>
                            </div>
                          </div>

                          <button
                            onClick={() => removeFile(file.id)}
                            className="text-red-500 hover:text-red-700 p-1 ml-2 flex-shrink-0"
                            disabled={file.isGettingPageCount}
                          >
                            <Trash2 className="w-4 h-4" />
                          </button>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            )}

            {currentStep === 2 && (
              <div>
                <h3 className="text-lg font-semibold mb-4">{getTranslatedText('printOptions')}</h3>

                {isAnyFileProcessing && (
                  <div className="mb-4 p-3 bg-blue-50 border border-blue-200 rounded-lg">
                    <div className="flex items-center">
                      <Loader2 className="w-4 h-4 animate-spin text-blue-500 mr-2" />
                      <span className="text-blue-700 text-sm">
                        {getTranslatedText('processing')}
                      </span>
                    </div>
                  </div>
                )}

                {uploadedFiles.length === 0 && <p className="text-gray-500">{getTranslatedText('uploadErrorNoFile')}</p>}

                {uploadedFiles.map(file => {
                  const options = fileOptions[file.id] || {
                    pageSelection: "all",
                    pageRange: "",
                    sides: "simplex",
                    color: "bw",
                    copies: 1,
                    spiralBinding: false,
                    spiralBindingFee: 0
                  };
                  const currentPageIndex = currentPreviewPageForFile[file.id] || 0;
                  const isImage = file.type === 'image/jpeg' || file.type === 'image/png';

                  return (
                    <div key={file.id} className="mb-6 border rounded-lg p-4">
                      <h4 className="font-medium mb-3">{file.name} ({file.totalPages} {getTranslatedText('pages')})</h4>

                      {isMobilePreviewOpen && (
                        <div className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center p-4 lg:hidden">
                          <div className="bg-white rounded-xl w-full max-w-2xl max-h-[90vh] overflow-hidden">
                            <div className="flex justify-between items-center p-4 border-b">
                              <h3 className="font-semibold">Document Preview</h3>
                              <button
                                onClick={() => setIsMobilePreviewOpen(false)}
                                className="p-2 hover:bg-gray-100 rounded-lg"
                              >
                                <X className="w-5 h-5" />
                              </button>
                            </div>

                            <div className="p-4 flex flex-col items-center">
                              <div className="flex items-center justify-center mb-4">
                                <button
                                  onClick={handleZoomOut}
                                  className="p-2 hover:bg-gray-200 rounded disabled:opacity-50"
                                  disabled={documentPreviewZoom <= 0.5}
                                >
                                  <ZoomOut className="w-5 h-5" />
                                </button>
                                <span className="text-sm px-4 whitespace-nowrap min-w-20 text-center">
                                  {Math.round((documentPreviewZoom || 1) * 100)}%
                                </span>
                                <button
                                  onClick={handleZoomIn}
                                  className="p-2 hover:bg-gray-200 rounded disabled:opacity-50"
                                  disabled={documentPreviewZoom >= 3}
                                >
                                  <ZoomIn className="w-5 h-5" />
                                </button>
                              </div>

                              <div className="relative w-full h-64 flex items-center justify-center overflow-hidden border rounded bg-white mb-4">
                                <img
                                  src={file.previewPages[currentPageIndex]}
                                  alt={`${file.name} ${isImage ? 'Image' : 'Page'} ${currentPageIndex + 1}`}
                                  className="max-w-full max-h-full object-contain transition-transform duration-200 ease-out"
                                  style={{ transform: `scale(${documentPreviewZoom || 1})` }}
                                />
                              </div>

                              {file.previewPages.length > 1 && (
                                <div className="flex items-center justify-between w-full px-2">
                                  <button
                                    onClick={() => setCurrentPreviewPageForFile(prev => ({ ...prev, [file.id]: Math.max(0, currentPageIndex - 1) }))}
                                    disabled={currentPageIndex === 0}
                                    className="p-3 rounded-lg hover:bg-gray-200 disabled:opacity-50 flex items-center gap-2"
                                  >
                                    <ChevronLeft className="w-5 h-5" />
                                    <span className="text-sm">Previous</span>
                                  </button>
                                  <span className="text-sm text-gray-600 font-medium px-4">
                                    {isImage ? 'Image' : 'Page'} {currentPageIndex + 1} of {file.previewPages.length}
                                  </span>
                                  <button
                                    onClick={() => setCurrentPreviewPageForFile(prev => ({ ...prev, [file.id]: Math.min(file.previewPages.length - 1, currentPageIndex + 1) }))}
                                    disabled={currentPageIndex === file.previewPages.length - 1}
                                    className="p-3 rounded-lg hover:bg-gray-200 disabled:opacity-50 flex items-center gap-2"
                                  >
                                    <span className="text-sm">Next</span>
                                    <ChevronRight className="w-5 h-5" />
                                  </button>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      )}

                      <div className="flex flex-col lg:flex-row gap-4">
                        <div className="lg:w-1/2">
                          {isGeneratingPreview[file.id] ? (
                            <div className="p-4 border rounded-lg bg-gray-50 flex flex-col items-center justify-center h-48 lg:h-64">
                              <Loader2 className="w-8 h-8 animate-spin text-blue-500 mb-2" />
                              <p className="text-gray-600">{getTranslatedText('processing')}...</p>
                            </div>
                          ) : file.previewPages && file.previewPages.length > 0 ? (
                            <div className="border rounded-lg bg-gray-50 overflow-hidden">
                              <div className="lg:hidden flex items-center justify-between p-3 border-b bg-white">
                                <span className="text-sm font-medium">Document Preview</span>
                                <button
                                  onClick={() => setIsMobilePreviewOpen(true)}
                                  className="flex items-center gap-1 text-blue-600 hover:text-blue-700 text-sm font-medium"
                                >
                                  <Expand className="w-4 h-4" />
                                  Expand
                                </button>
                              </div>

                              <div className="p-3 lg:p-4 flex flex-col items-center">
                                <div className="hidden lg:flex items-center justify-center mb-4">
                                  <button
                                    onClick={handleZoomOut}
                                    className="p-1.5 hover:bg-gray-200 rounded disabled:opacity-50"
                                    disabled={documentPreviewZoom <= 0.5}
                                  >
                                    <ZoomOut className="w-4 h-4" />
                                  </button>
                                  <span className="text-sm px-2 whitespace-nowrap min-w-16 text-center">
                                    {Math.round((documentPreviewZoom || 1) * 100)}%
                                  </span>
                                  <button
                                    onClick={handleZoomIn}
                                    className="p-1.5 hover:bg-gray-200 rounded disabled:opacity-50"
                                    disabled={documentPreviewZoom >= 3}
                                  >
                                    <ZoomIn className="w-4 h-4" />
                                  </button>
                                </div>

                                <div className="relative w-full h-32 lg:h-48 flex items-center justify-center overflow-hidden">
                                  <img
                                    src={file.previewPages[currentPageIndex]}
                                    alt={`${file.name} ${isImage ? 'Image' : 'Page'} ${currentPageIndex + 1}`}
                                    className="max-w-full max-h-full object-contain transition-transform duration-200 ease-out"
                                    style={{ transform: `scale(${documentPreviewZoom || 1})` }}
                                  />
                                </div>

                                {file.previewPages.length > 1 && (
                                  <div className="flex items-center justify-between w-full mt-3 px-1">
                                    <button
                                      onClick={() => setCurrentPreviewPageForFile(prev => ({ ...prev, [file.id]: Math.max(0, currentPageIndex - 1) }))}
                                      disabled={currentPageIndex === 0}
                                      className="p-1.5 rounded hover:bg-gray-200 disabled:opacity-50 lg:p-2"
                                    >
                                      <ChevronLeft className="w-4 h-4 lg:w-5 lg:h-5" />
                                    </button>
                                    <span className="text-xs lg:text-sm text-gray-600 font-medium px-2 text-center">
                                      {isImage ? 'Image' : 'Page'} {currentPageIndex + 1}<span className="hidden lg:inline"> of {file.previewPages.length}</span>
                                    </span>
                                    <button
                                      onClick={() => setCurrentPreviewPageForFile(prev => ({ ...prev, [file.id]: Math.min(file.previewPages.length - 1, currentPageIndex + 1) }))}
                                      disabled={currentPageIndex === file.previewPages.length - 1}
                                      className="p-1.5 rounded hover:bg-gray-200 disabled:opacity-50 lg:p-2"
                                    >
                                      <ChevronRight className="w-4 h-4 lg:w-5 lg:h-5" />
                                    </button>
                                  </div>
                                )}

                                <div className="lg:hidden flex gap-2 mt-3 w-full">
                                  <button
                                    onClick={handleZoomOut}
                                    disabled={documentPreviewZoom <= 0.5}
                                    className="flex-1 p-2 text-xs border rounded hover:bg-gray-50 disabled:opacity-50 flex items-center justify-center gap-1"
                                  >
                                    <ZoomOut className="w-3 h-3" />
                                    Zoom Out
                                  </button>
                                  <button
                                    onClick={handleZoomIn}
                                    disabled={documentPreviewZoom >= 3}
                                    className="flex-1 p-2 text-xs border rounded hover:bg-gray-50 disabled:opacity-50 flex items-center justify-center gap-1"
                                  >
                                    <ZoomIn className="w-3 h-3" />
                                    Zoom In
                                  </button>
                                </div>
                              </div>
                            </div>
                          ) : (
                            <div className="p-4 border rounded-lg bg-gray-50 text-center text-gray-500 h-48 flex items-center justify-center">
                              {getTranslatedText('previewNotAvailable')}
                            </div>
                          )}
                        </div>

                        <div className="lg:w-1/2">
                          <div className="space-y-4">
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">


                              <div className={isImage ? 'sm:col-span-2' : ''}>
                                <label className="block text-sm font-medium mb-2">{getTranslatedText('numberOfCopies')}</label>
                                <input
                                  type="number"
                                  min="1"
                                  value={options.copies || 1}
                                  onChange={(e) => updateFileOption(file.id, 'copies', parseInt(e.target.value) || 1)}
                                  className="w-full p-3 border rounded-lg"
                                />
                              </div>
                            </div>

                            {!isImage && options.pageSelection === "range" && (
                              <div>
                                <label className="block text-sm font-medium mb-2">{getTranslatedText('pageRange')}</label>
                                <input
                                  type="text"
                                  placeholder={getTranslatedText('examplePageRange')}
                                  value={options.pageRange || ""}
                                  onChange={(e) => updateFileOption(file.id, 'pageRange', e.target.value)}
                                  className="w-full p-3 border rounded-lg"
                                />
                              </div>
                            )}

                            <div>
                              <label className="block text-sm font-medium mb-3">{getTranslatedText('color')}</label>
                              <div className="flex gap-4">
                                <label className="flex items-center gap-2 cursor-pointer">
                                  <input
                                    type="radio"
                                    name={`color-${file.id}`}
                                    value="bw"
                                    checked={options.color === 'bw'}
                                    onChange={() => updateFileOption(file.id, 'color', 'bw')}
                                    className="w-4 h-4"
                                  />
                                  <span>{getTranslatedText('blackAndWhite')}</span>
                                </label>

                                <label className="flex items-center gap-2 cursor-pointer">
                                  <input
                                    type="radio"
                                    name={`color-${file.id}`}
                                    value="color"
                                    checked={options.color === 'color'}
                                    onChange={() => updateFileOption(file.id, 'color', 'color')}
                                    className="w-4 h-4"
                                  />
                                  <span>{getTranslatedText('colorPrint')}</span>
                                </label>
                              </div>
                            </div>

                            <div className="mb-4">
                              <label className="block text-sm font-medium mb-2">{getTranslatedText('papersize')}</label>
                              <div className="flex gap-4">
                                <label className="flex items-center">
                                  <input
                                    type="radio"
                                    name={`paperSize-${file.id}`}
                                    value="a4"
                                    checked={options.paperSize === 'a4'}
                                    onChange={() => updateFileOption(file.id, 'paperSize', 'a4')}
                                    className="mr-2"
                                  />
                                  {getTranslatedText('a4')}
                                </label>


                                <label className="flex items-center">
                                  <input
                                    type="radio"
                                    name={`paperSize-${file.id}`}
                                    value="a3"
                                    checked={options.paperSize === 'a3'}
                                    onChange={() => updateFileOption(file.id, 'paperSize', 'a3')}
                                    className="mr-2"
                                  />
                                  {getTranslatedText('a3')}
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>

          <div className="border-t p-4 bg-gray-50">
            <div className="flex justify-between">
              <button
                onClick={goToPreviousStep}
                className="px-6 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
                disabled={isLoading || currentStep === 1}
              >
                {getTranslatedText('back')}
              </button>
              <button
                onClick={currentStep === 2 ? addToCart : proceedToNextStep}
                className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed transition-colors"
                disabled={
                  isLoading ||
                  isFetchingPageCount ||
                  (currentStep === 1 && uploadedFiles.length === 0) ||
                  (currentStep === 2 && isAnyFileProcessing) ||
                  // Add this new condition to check if any file is still processing
                  (currentStep === 1 && isAnyFileProcessing)
                }
              >
                {currentStep === 2 ? (
                  isAnyFileProcessing ? (
                    <div className="flex items-center">
                      <Loader2 className="w-4 h-4 animate-spin mr-2" />
                      {getTranslatedText('processing')}
                    </div>
                  ) : (
                    getTranslatedText('addToCart')
                  )
                ) : (
                  isAnyFileProcessing ? (
                    <div className="flex items-center">
                      <Loader2 className="w-4 h-4 animate-spin mr-2" />
                      {getTranslatedText('processing')}
                    </div>
                  ) : (
                    getTranslatedText('continue')
                  )
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };



  const PhotoModal = ({ isPhotoModalOpen, setIsPhotoModalOpen, onAddToCart, pricing }) => {
    const [currentStep, setCurrentStep] = useState(1);
    const [uploadedPhotos, setUploadedPhotos] = useState([]);
    const [photoOptions, setPhotoOptions] = useState({});
    const [uploadError, setUploadError] = useState('');

    const getPhotoPrice = (size, quantity) => {
      const sizePricing = pricing.photos[size];
      if (!sizePricing) return 0;

      if (quantity >= 1 && quantity <= 24) {
        return sizePricing['1-24'];
      } else if (quantity >= 25 && quantity <= 74) {
        return sizePricing['25-74'];
      } else if (quantity >= 75) {
        return sizePricing['75+'];
      }
      return 0;
    };

    const handlePhotoDrop = (files) => {
      const fileList = Array.from(files);
      fileList.forEach(file => handlePhotoUpload(file));
    };

    const handlePhotoUpload = async (file) => {
      if (!file) return;

      setUploadError('');
      let photoId;
      let photoDisplayUrl;
      let photoBase64 = null;

      try {
        const maxFileSize = 10 * 1024 * 1024;
        if (file.size > maxFileSize) {
          throw new Error(getTranslatedText('photoTooLarge', { maxSize: maxFileSize / (1024 * 1024) }));
        }

        const allowedTypes = ['image/jpeg', 'image/png'];
        if (!allowedTypes.includes(file.type)) {
          throw new Error(getTranslatedText('acceptedPhotoFormats'));
        }

        if (uploadedPhotos.some(p => p.name === file.name && p.size === file.size)) {
          throw new Error(getTranslatedText('photoAlreadyUploaded'));
        }

        photoId = Date.now() + Math.random();
        photoDisplayUrl = URL.createObjectURL(file);

        const reader = new FileReader();
        reader.readAsDataURL(file);
        await new Promise((resolve, reject) => {
          reader.onloadend = () => {
            photoBase64 = reader.result;
            resolve();
          };
          reader.onerror = reject;
        });

        const img = new window.Image();
        img.src = photoDisplayUrl;
        await new Promise((resolve, reject) => {
          img.onload = resolve;
          img.onerror = reject;
        });

        setUploadedPhotos(prev => [...prev, {
          id: photoId,
          name: file.name,
          url: photoDisplayUrl,
          base64: photoBase64,
          width: img.width,
          height: img.height,
          size: file.size
        }]);

        setPhotoOptions(prev => ({
          ...prev,
          [photoId]: {
            size: '10x15',
            quantity: 1
          }
        }));

      } catch (error) {
        setUploadError(error.message);
        if (photoId) {
          setUploadedPhotos(prev => prev.filter(p => p.id !== photoId));
          if (photoDisplayUrl) URL.revokeObjectURL(photoDisplayUrl);
        }
      }
    };

    const removePhoto = (photoId) => {
      const photoToRemove = uploadedPhotos.find(p => p.id === photoId);
      if (photoToRemove && photoToRemove.url) {
        URL.revokeObjectURL(photoToRemove.url);
      }
      setUploadedPhotos(prev => prev.filter(p => p.id !== photoId));
      setPhotoOptions(prev => {
        const { [photoId]: removed, ...rest } = prev;
        return rest;
      });
    };

    const updatePhotoOption = (photoId, optionKey, value) => {
      setPhotoOptions(prev => ({
        ...prev,
        [photoId]: {
          ...prev[photoId],
          [optionKey]: value
        }
      }));
    };

    const calculatePhotoCost = (photoId) => {
      const options = photoOptions[photoId];
      if (!options) return 0;
      return getPhotoPrice(options.size, options.quantity) * options.quantity;
    };

    const getTotalPhotosCost = () => {
      return uploadedPhotos.reduce((sum, photo) => sum + calculatePhotoCost(photo.id), 0);
    };

    const calculateGrandTotal = () => {
      return getTotalPhotosCost();
    };

    const proceedToNextStep = () => {
      if (currentStep === 1 && uploadedPhotos.length === 0) {
        setUploadError(getTranslatedText('uploadErrorNoFile'));
        return;
      }
      if (currentStep < 3) {
        setCurrentStep(prev => prev + 1);
        setUploadError('');
      }
    };

    const goToPreviousStep = () => {
      if (currentStep > 1) {
        setCurrentStep(prev => prev - 1);
        setUploadError('');
      }
    };

    const addToCart = () => {
      const orderDetails = {
        type: "photo",
        items: uploadedPhotos.map(photo => ({
          name: photo.name,
          url: photo.base64,
          options: photoOptions[photo.id],
          cost: calculatePhotoCost(photo.id)
        })),
        totalCost: getTotalPhotosCost()
      };

      onAddToCart(orderDetails);

      setCurrentStep(1);
      setUploadedPhotos([]);
      setPhotoOptions({});
      setIsPhotoModalOpen(false);
    };

    return (
      <div className={`fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4 ${!isPhotoModalOpen ? 'hidden' : ''}`}>
        <div className="bg-white rounded-2xl max-w-6xl w-full shadow-2xl flex flex-col" style={{ height: '90vh' }}>
          <div className="flex-shrink-0 p-6 border-b border-gray-200">
            <div className="flex justify-between items-center">
              <h2 className="text-2xl font-bold text-gray-800">{getTranslatedText('photoModalTitle')}</h2>
              <button onClick={() => setIsPhotoModalOpen(false)} className="text-gray-500 hover:text-gray-700 transition-colors">
                <X className="w-6 h-6" />
              </button>
            </div>
            <div className="mt-4">
              <div className="flex items-center justify-between text-sm text-gray-500 mb-2">
                <span>{getTranslatedText('step')} {currentStep} {getTranslatedText('on')} 3</span>
                <span>{Math.round((currentStep / 3) * 100)}%</span>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-2">
                <div className="bg-yellow-400 h-2 rounded-full" style={{ width: `${(currentStep / 4) * 100}%` }} />
              </div>
            </div>
          </div>

          <div className="flex-1 overflow-y-auto p-6">
            {/* Step 1: Upload Photos */}
            <div className={`${currentStep === 1 ? 'block' : 'hidden'}`}>
              <h3 className="text-xl font-semibold mb-6">1. {getTranslatedText('uploadPhotos')}</h3>
              <div className="border-2 border-dashed rounded-lg p-8 text-center mb-6">
                <Upload className="w-12 h-12 text-gray-400 mb-4 mx-auto" />
                <p className="text-lg mb-2">{getTranslatedText('clickOrDrag')}</p>
                <input
                  type="file"
                  onChange={(e) => handlePhotoDrop(e.target.files)}
                  className="hidden"
                  accept="image/jpeg,image/png"
                  multiple
                  id="photoInput"
                />
                <label htmlFor="photoInput" className="cursor-pointer inline-block mt-4 px-4 py-2 bg-yellow-400 text-black rounded-lg hover:bg-yellow-500">
                  {getTranslatedText('choosePhotos')}
                </label>
              </div>
              {uploadError && <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-4">{uploadError}</div>}
              {uploadedPhotos.length > 0 && (
                <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                  {uploadedPhotos.map(photo => (
                    <div key={photo.id} className="relative">
                      <img src={photo.url} alt={photo.name} className="w-full h-32 object-cover rounded-lg" />
                      <button
                        onClick={() => removePhoto(photo.id)}
                        className="absolute top-2 right-2 bg-red-500 text-white p-1 rounded-full"
                      >
                        <Trash2 className="w-4 h-4" />
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* Step 2: Print Options */}
            <div className={`${currentStep === 2 ? 'block' : 'hidden'}`}>
              <h3 className="text-xl font-semibold mb-6">2. {getTranslatedText('printOptions')}</h3>
              {uploadedPhotos.map(photo => (
                <div key={photo.id} className="mb-6 p-4 border border-gray-200 rounded-lg">
                  <div className="flex items-center mb-4">
                    <img src={photo.url} alt={photo.name} className="w-16 h-16 object-cover rounded-lg mr-4" />
                    <h4 className="font-medium">{photo.name}</h4>
                  </div>
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium mb-2">{getTranslatedText('format')}</label>
                      <select
                        value={photoOptions[photo.id]?.size || '10x15'}
                        onChange={(e) => updatePhotoOption(photo.id, 'size', e.target.value)}
                        className="w-full p-2 border border-gray-300 rounded"
                      >
                        <option value="10x15">10x15 cm</option>
                        <option value="15x23">15x23 cm</option>
                      </select>
                    </div>
                    <div>
                      <label className="block text-sm font-medium mb-2">{getTranslatedText('quantity')}</label>
                      <input
                        type="number"
                        min="1"
                        value={photoOptions[photo.id]?.quantity || 1}
                        onChange={(e) => updatePhotoOption(photo.id, 'quantity', Math.max(1, parseInt(e.target.value) || 1))}
                        className="w-full p-2 border border-gray-300 rounded"
                      />
                    </div>
                  </div>
                  <div className="mt-2">
                    <span className="font-semibold">{getTranslatedText('price')}: {calculatePhotoCost(photo.id).toFixed(2)} {currency}</span>
                  </div>
                </div>
              ))}
            </div>

            {/* Step 4: Order Summary */}
            <div className={`${currentStep === 3 ? 'block' : 'hidden'}`}>
              <h3 className="text-xl font-semibold mb-6">4. {getTranslatedText('orderSummary')}</h3>
              <div className="space-y-4">
                {uploadedPhotos.map(photo => (
                  <div key={photo.id} className="flex justify-between items-center border-b border-gray-200 pb-2">
                    <div>
                      <p>{photo.name}</p>
                      <p className="text-sm text-gray-600">
                        {photoOptions[photo.id]?.size}, {photoOptions[photo.id]?.quantity}x
                      </p>
                    </div>
                    <p>{calculatePhotoCost(photo.id).toFixed(2)} {currency}</p>
                  </div>
                ))}

                <div className="flex justify-between font-bold text-lg">
                  <p>{getTranslatedText('total')}:</p>
                  <p>{calculateGrandTotal().toFixed(2)} {currency}</p>
                </div>
              </div>
            </div>
          </div>

          <div className="flex-shrink-0 p-4 border-t border-gray-200">
            <div className="flex justify-between">
              <button
                onClick={goToPreviousStep}
                className={`px-4 py-2 rounded ${currentStep === 1 ? 'bg-gray-200 text-gray-500' : 'bg-gray-500 text-white'}`}
                disabled={currentStep === 1}
              >
                {getTranslatedText('back')}
              </button>
              <button
                onClick={currentStep === 3 ? addToCart : proceedToNextStep}
                className={`px-4 py-2 rounded ${currentStep === 3 ? 'bg-yellow-400 text-black' : 'bg-blue-500 text-white'}`}
              >
                {currentStep === 3 ? getTranslatedText('addPhotosToCart') : getTranslatedText('next')}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };


  const handleSuccessScreenClose = () => {
    // Clear cart and reset everything when success screen is closed
    setCartItems([]);
    localStorage.removeItem(CART_STORAGE_KEY);
    setDeliveryMethod('express'); // Revert to express
    setCustomerInfo({
      name: '', phone: '', email: '', notes: '',
      shippingAddress: { firstName: '', lastName: '', address: '', city: '', postalCode: '', country: 'Canada', province: 'Ontario', state: '' },
      paymentMethod: 'credit_card'
    });
    setOrderSuccess(false);
    setIsCartModalOpen(false); // Close the cart modal
    setDiscountCode(''); // Clear discount code
    setAppliedDiscount(null); // Clear applied discount
    setDiscountError(''); // Clear discount error
    setCartItems([]); // ✅ Add this line to clear the cart
    setSelectedStudio(null); // Clear selected studio
    fileDataMap.current.clear(); // Clear the in-memory map

  };


  const CartModal = ({ isCartModalOpen, setIsCartModalOpen, cartItems, removeFromCart, pricing, setCartItems, selectedCountryFromLanding, openPreview, discountCode, setDiscountCode, discountError, setDiscountError, appliedDiscount, setAppliedDiscount, handleDiscountCode, isLoading: appIsLoading, selectedStudio, setSelectedStudio }) => {
    const [deliveryMethod, setDeliveryMethod] = useState('express'); // Default to 'express' (pickup)
    const [calculatedTax, setCalculatedTax] = useState(0);
    const [localDiscountCode, setLocalDiscountCode] = useState(discountCode || '');

    const SERVICE_FEE = 1.99;

    // Helper function to compute pages to print for a document item
    const computePagesToPrint = (item) => {
      if (item.type === 'document') {
        if (item.options.pageSelection === 'all') {
          return item.file.totalPages || item.file.pagesSelected;
        } else if (item.options.pageSelection === 'range') {
          // Ensure parsePageRange is accessible (defined globally or passed down)
          return parsePageRange(item.options.pageRange, item.file.totalPages || item.file.pagesSelected).length;
        }
      }
      return 0;
    };

    const calculateTieredCost = (quantity, pricingTiers) => {
      if (!pricingTiers) return 0; // Add null check

      let remainingQuantity = quantity;
      let totalCost = 0;

      const sortedTiers = Object.keys(pricingTiers)
        .map(tierKey => {
          if (tierKey.includes('+')) {
            const min = parseInt(tierKey.replace('+', ''));
            return { key: tierKey, min: min, max: Infinity, price: pricingTiers[tierKey] };
          } else {
            const [min, max] = tierKey.split('-').map(Number);
            return { key: tierKey, min: min, max: max, price: pricingTiers[tierKey] };
          }
        })
        .sort((a, b) => a.min - b.min);

      for (const tier of sortedTiers) {
        if (remainingQuantity <= 0) break;

        let quantityInThisTier = 0;

        if (tier.max === Infinity) {
          quantityInThisTier = remainingQuantity;
        } else {
          const tierStart = tier.min;
          const tierEnd = tier.max;
          const quantityStart = Math.max(0, quantity - remainingQuantity + 1);
          const quantityEnd = quantity - remainingQuantity + remainingQuantity;
          const overlapStart = Math.max(tierStart, quantityStart);
          const overlapEnd = Math.min(tierEnd, quantityEnd);

          if (overlapStart <= overlapEnd) {
            quantityInThisTier = Math.min(remainingQuantity, overlapEnd - overlapStart + 1);
          }
        }

        if (quantityInThisTier > 0) {
          const costForThisTier = quantityInThisTier * tier.price;
          totalCost += costForThisTier;
          remainingQuantity -= quantityInThisTier;
        }
      }

      return totalCost;
    };

    // Inside CartModal component, after state declarations
    const {
      totalDocumentPagesBW,
      totalDocumentPagesColor,
      totalDocumentPagesA3BW,
      totalDocumentPagesA3Color,
      totalPhotos10x15,
      totalPhotos15x23,
      averagePriceBW,
      averagePriceColor,
      averagePriceA3BW,
      averagePriceA3Color,
      averagePrice10x15,
      averagePrice15x23
    } = useMemo(() => {
      // Return zeros if pricing is not loaded yet
      if (!pricing) {
        return {
          totalDocumentPagesBW: 0,
          totalDocumentPagesColor: 0,
          totalDocumentPagesA3BW: 0,
          totalDocumentPagesA3Color: 0,
          totalPhotos10x15: 0,
          totalPhotos15x23: 0,
          averagePriceBW: 0,
          averagePriceColor: 0,
          averagePriceA3BW: 0,
          averagePriceA3Color: 0,
          averagePrice10x15: 0,
          averagePrice15x23: 0
        };
      }

      let totalDocBW = 0;
      let totalDocColor = 0;
      let totalDocA3BW = 0;
      let totalDocA3Color = 0;
      let totalPhoto10x15 = 0;
      let totalPhoto15x23 = 0;

      cartItems.forEach(item => {
        if (item.type === 'document') {
          const pagesToPrint = computePagesToPrint(item);
          const copies = item.options.copies || 1;
          const itemTotalPages = pagesToPrint * copies;
          const paperSize = item.options.paperSize || 'a4';
          const colorType = item.options.color || 'bw';

          if (paperSize === 'a3') {
            if (colorType === 'bw') {
              totalDocA3BW += itemTotalPages;
            } else {
              totalDocA3Color += itemTotalPages;
            }
          } else {
            if (colorType === 'bw') {
              totalDocBW += itemTotalPages;
            } else {
              totalDocColor += itemTotalPages;
            }
          }
        } else if (item.type === 'photo') {
          const quantity = item.options?.quantity || item.quantity || 0;
          const size = item.options?.size || item.photo?.size || item.size || '10x15';

          if (size === '10x15') {
            totalPhoto10x15 += quantity;
          } else if (size === '15x23') {
            totalPhoto15x23 += quantity;
          }
        }
      });

      // Use the new pricing structure with null checks
      const totalCostBW = calculateTieredCost(totalDocBW, pricing.documents?.a4?.black_white?.tiers);
      const totalCostColor = calculateTieredCost(totalDocColor, pricing.documents?.a4?.color?.tiers);
      const totalCostA3BW = calculateTieredCost(totalDocA3BW, pricing.documents?.a3?.black_white?.tiers);
      const totalCostA3Color = calculateTieredCost(totalDocA3Color, pricing.documents?.a3?.color?.tiers);
      const totalCost10x15 = calculateTieredCost(totalPhoto10x15, pricing.photos?.['10x15']?.tiers);
      const totalCost15x23 = calculateTieredCost(totalPhoto15x23, pricing.photos?.['15x23']?.tiers);

      const avgBW = totalDocBW > 0 ? totalCostBW / totalDocBW : 0;
      const avgColor = totalDocColor > 0 ? totalCostColor / totalDocColor : 0;
      const avgA3BW = totalDocA3BW > 0 ? totalCostA3BW / totalDocA3BW : 0;
      const avgA3Color = totalDocA3Color > 0 ? totalCostA3Color / totalDocA3Color : 0;
      const avg10x15 = totalPhoto10x15 > 0 ? totalCost10x15 / totalPhoto10x15 : 0;
      const avg15x23 = totalPhoto15x23 > 0 ? totalCost15x23 / totalPhoto15x23 : 0;

      return {
        totalDocumentPagesBW: totalDocBW,
        totalDocumentPagesColor: totalDocColor,
        totalDocumentPagesA3BW: totalDocA3BW,
        totalDocumentPagesA3Color: totalDocA3Color,
        totalPhotos10x15: totalPhoto10x15,
        totalPhotos15x23: totalPhoto15x23,
        averagePriceBW: avgBW,
        averagePriceColor: avgColor,
        averagePriceA3BW: avgA3BW,
        averagePriceA3Color: avgA3Color,
        averagePrice10x15: avg10x15,
        averagePrice15x23: avg15x23
      };
    }, [cartItems, pricing]); // Add pricing as dependency


    const [currentStep, setCurrentStep] = useState(() => {
      if (typeof window !== 'undefined') {
        const saved = sessionStorage.getItem('cartModalCurrentStep');
        return saved ? parseInt(saved, 10) : 1;
      }
      return 1;
    });
    const [customerInfo, setCustomerInfo] = useState(() => {
      if (typeof window !== 'undefined') {
        const saved = sessionStorage.getItem('cartModalCustomerInfo');
        if (saved) {
          try {
            return JSON.parse(saved);
          } catch (e) {
            console.error('Error parsing saved customer info:', e);
          }
        }
      }
      return {
        name: '',
        phone: '',
        email: '',
        notes: '',
        shippingAddress: {
          firstName: '',
          lastName: '',
          address: '',
          city: '',
          postalCode: '',
          country: 'Canada', // Default to Canada
          province: 'Ontario', // Default to Ontario
          state: ''
        },
        paymentMethod: 'credit_card'
      };
    });

    const stepRef = useRef(currentStep);

    const [isLoading, setIsLoading] = useState(false);
    const [orderError, setOrderError] = useState('');
    const [orderSuccess, setOrderSuccess] = useState(false);
    const [orderNumber, setOrderNumber] = useState(null);
    const [availableCities, setAvailableCities] = useState([]);
    const [availablePostalCodes, setAvailablePostalCodes] = useState([]);

    useEffect(() => {
      const country = customerInfo.shippingAddress?.country?.toLowerCase();
      const province = customerInfo.shippingAddress?.province?.toLowerCase(); // This will be 'sousse' for Tunisia

      if (country && province && LOCATION_DATA[country] && LOCATION_DATA[country][province]) {
        const cityData = LOCATION_DATA[country][province].cities;
        setAvailableCities(Object.keys(cityData)); // Get all city names
        // Postal codes will be derived from the selected city, so no need for a separate list here
      } else {
        setAvailableCities([]);
        setAvailablePostalCodes([]);
      }
    }, [customerInfo.shippingAddress?.country, customerInfo.shippingAddress?.province]);

    useEffect(() => {
      sessionStorage.setItem('cartModalCurrentStep', currentStep.toString());
      stepRef.current = currentStep;
    }, [currentStep]);

    useEffect(() => {
      sessionStorage.setItem('cartModalCustomerInfo', JSON.stringify(customerInfo));
    }, [customerInfo]);

    // Sync local discount code with parent state
    useEffect(() => {
      setLocalDiscountCode(discountCode);
    }, [discountCode]);

    const getTranslatedText = (key, replacements = {}) => {
      let text = appTranslations[currentLanguage]?.[key] || appTranslations['en'][key] || key;
      for (const placeholder in replacements) {
        text = text.replace(`{${placeholder}}`, replacements[placeholder]);
      }
      return text;
    };

    // Handle discount code application with debouncing
    const handleApplyDiscount = async () => {
      if (!localDiscountCode || localDiscountCode.length < 3) {
        setDiscountError('Please enter a valid discount code');
        return;
      }

      try {
        await handleDiscountCode(localDiscountCode);
      } catch (error) {
        console.error('Error applying discount:', error);
      }
    };

    // Handle discount input change (only update local state)
    const handleDiscountInputChange = (value) => {
      setLocalDiscountCode(value.toUpperCase());
      // Clear errors when user starts typing
      if (discountError) {
        setDiscountError('');
      }
    };

    // Inside CartModal component

    const getTotalDocumentPages = () => {
      return cartItems.reduce((total, item) => {
        if (item.type === 'document') {
          // Get pages to print for this document
          const pagesToPrint = item.options.pageSelection === "all"
            ? item.file.totalPages || item.file.pagesSelected
            : parsePageRange(item.options.pageRange, item.file.totalPages || item.file.pagesSelected).length;

          // MULTIPLY by number of copies for this document
          const copies = item.options.copies || 1;
          const totalPagesForThisItem = pagesToPrint * copies;

          console.log(`Document ${item.file.name}: ${pagesToPrint} pages × ${copies} copies = ${totalPagesForThisItem} total pages`);

          return total + totalPagesForThisItem;
        }
        return total;
      }, 0);
    };

    // CRITICAL: This function calculates TOTAL photo quantities across ALL photos
    const getTotalPhotoQuantities = () => {
      return cartItems.reduce((total, item) => {
        if (item.type === 'photo') {
          const quantity = item.options.quantity || 0;
          console.log(`Photo ${item.photo.name}: ${quantity} copies`);
          return total + quantity;
        }
        return total;
      }, 0);
    };

    // Helper to get the correct pricing tier based on total quantity
    const getTierPrice = (pricingCategory, totalQuantity) => {
      if (!pricingCategory) return 0;

      console.log(`Getting tier price for total quantity: ${totalQuantity}`);

      if (totalQuantity >= 1 && totalQuantity <= 24) {
        console.log(`Using 1-24 tier: ${pricingCategory['1-24']}`);
        return pricingCategory['1-24'] || 0;
      } else if (totalQuantity >= 25 && totalQuantity <= 74) {
        console.log(`Using 25-74 tier: ${pricingCategory['25-74']}`);
        return pricingCategory['25-74'] || 0;
      } else if (totalQuantity >= 75) {
        console.log(`Using 75+ tier: ${pricingCategory['75+']}`);
        return pricingCategory['75+'] || 0;
      }
      return 0;
    };



    // Helper to get the correct pricing tier based on total quantity
    const getPricingTiers = (category, type) => {
      if (!pricing || !pricing[type] || !pricing[type][category]) return {};
      return pricing[type][category];
    };




    // Inside CartModal component

    const calculateItemTotal = (item) => {
      if (!item || !pricing) {
        console.error('Missing item or pricing data');
        return 0;
      }

      if (item.type === 'document') {
        const pagesToPrint = computePagesToPrint(item);
        const copies = item.options.copies || 1;
        const totalPages = pagesToPrint * copies;
        const paperSize = (item.options.paperSize || 'a4').toLowerCase();
        const colorType = item.options.color || 'bw';

        console.log('Document calculation:', {
          pagesToPrint,
          copies,
          totalPages,
          paperSize,
          colorType
        });

        // Access pricing structure
        const docPricing = pricing.documents?.[paperSize];
        if (!docPricing) {
          console.error(`No pricing found for paper size: ${paperSize}`);
          console.log('Available pricing:', pricing.documents);
          return 0;
        }

        const colorKey = colorType === 'color' ? 'color' : 'black_white';
        const colorPricing = docPricing[colorKey];

        if (!colorPricing) {
          console.error(`No pricing found for color type: ${colorKey}`);
          return 0;
        }

        // Use tiered pricing based on total pages
        let pricePerPage;
        if (totalPages >= 1 && totalPages <= 24) {
          pricePerPage = colorPricing.tiers?.['1-24'] || colorPricing.price_per_page;
        } else if (totalPages >= 25 && totalPages <= 74) {
          pricePerPage = colorPricing.tiers?.['25-74'] || colorPricing.price_per_page;
        } else {
          pricePerPage = colorPricing.tiers?.['75+'] || colorPricing.price_per_page;
        }

        const cost = totalPages * pricePerPage;
        console.log(`Document cost: ${totalPages} pages × $${pricePerPage} = $${cost}`);
        return cost;

      } else if (item.type === 'photo') {
        const itemQuantity = item.options?.quantity || item.quantity || 0;
        const size = item.options?.size || item.photo?.size || item.size || '10x15';

        console.log('Photo calculation:', {
          itemQuantity,
          size
        });

        const photoPricing = pricing.photos?.[size];
        if (!photoPricing) {
          console.error(`No pricing found for photo size: ${size}`);
          console.log('Available photo pricing:', pricing.photos);
          return 0;
        }

        // Use tiered pricing based on quantity
        let pricePerPhoto;
        if (itemQuantity >= 1 && itemQuantity <= 24) {
          pricePerPhoto = photoPricing.tiers?.['1-24'] || photoPricing.price_per_photo;
        } else if (itemQuantity >= 25 && itemQuantity <= 74) {
          pricePerPhoto = photoPricing.tiers?.['25-74'] || photoPricing.price_per_photo;
        } else {
          pricePerPhoto = photoPricing.tiers?.['75+'] || photoPricing.price_per_photo;
        }

        const cost = itemQuantity * pricePerPhoto;
        console.log(`Photo cost: ${itemQuantity} photos × $${pricePerPhoto} = $${cost}`);
        return cost;
      }

      return 0;
    };





    const calculateDeliveryCost = () => {
      // Since deliveryMethod is always 'express' (pickup), cost is 0
      return 0;
    };

    // Inside CartModal component, locate the calculateTax function

    const calculateTax = (subtotal, deliveryCost, selectedStudio) => {
      // If no studio is selected, or if the country is not Canada, no tax applies.
      if (!selectedStudio || (selectedStudio.country !== 'CA' && selectedStudio.country !== 'ca' && selectedStudio.country !== 'Canada' && selectedStudio.country !== 'canada')) {
        return 0;
      }

      // Map studio city to province for tax purposes
      let provinceForTax = '';
      const cityLower = selectedStudio.city?.toLowerCase() || '';

      // --- START MODIFICATION ---
      // Comprehensive city-to-province mapping for Canadian cities
      const cityToProvinceMap = {
        // Quebec
        'montreal': 'Quebec', 'quebec city': 'Quebec', 'quebec': 'Quebec', 'laval': 'Quebec', 'gatineau': 'Quebec',
        'longueuil': 'Quebec', 'sherbrooke': 'Quebec', 'saguenay': 'Quebec', 'levis': 'Quebec', 'trois-rivieres': 'Quebec',
        'trois rivieres': 'Quebec', 'terrebonne': 'Quebec', 'saint-jean-sur-richelieu': 'Quebec',
        'repentigny': 'Quebec', 'brossard': 'Quebec', 'drummondville': 'Quebec', 'saint-jerome': 'Quebec',
        'granby': 'Quebec', 'blainville': 'Quebec', 'saint-hyacinthe': 'Quebec', 'shawinigan': 'Quebec',
        'dollard-des-ormeaux': 'Quebec', 'rimouski': 'Quebec', 'chateauguay': 'Quebec', 'mascouche': 'Quebec',
        'rouyn-noranda': 'Quebec', 'boucherville': 'Quebec', 'mirabel': 'Quebec', 'vaudreuil-dorion': 'Quebec',
        'saint-eustache': 'Quebec', 'chambly': 'Quebec', 'sainte-julie': 'Quebec', 'varennes': 'Quebec',
        'candiac': 'Quebec', 'beloeil': 'Quebec', 'baie-comeau': 'Quebec', 'val-d\'or': 'Quebec', 'val d\'or': 'Quebec',
        'alma': 'Quebec', 'sainte-therese': 'Quebec', 'sept-iles': 'Quebec', 'saint-bruno-de-montarville': 'Quebec',
        'sainte-catherine': 'Quebec', 'magog': 'Quebec', 'rouyn': 'Quebec', 'amos': 'Quebec', 'la prairie': 'Quebec',
        'mont-laurier': 'Quebec', 'matane': 'Quebec', 'sainte-marie': 'Quebec', 'joliette': 'Quebec',
        'victoriaville': 'Quebec', 'salaberry-de-valleyfield': 'Quebec', 'côte-saint-luc': 'Quebec',
        'cote-saint-luc': 'Quebec', 'cote saint luc': 'Quebec', 'côte saint luc': 'Quebec',
        'mont-royal': 'Quebec', 'mount royal': 'Quebec', 'mont royal': 'Quebec', 'pointe-claire': 'Quebec',
        'kirkland': 'Quebec', 'westmount': 'Quebec', 'beaconsfield': 'Quebec', 'dorval': 'Quebec',
        'pierrefonds': 'Quebec', 'roxboro': 'Quebec', 'lachine': 'Quebec', 'lasalle': 'Quebec', 'verdun': 'Quebec',
        'anjou': 'Quebec', 'saint-laurent': 'Quebec', 'saint laurent': 'Quebec', 'outremont': 'Quebec',
        'hampstead': 'Quebec', 'montreal-west': 'Quebec', 'montreal west': 'Quebec', 'sainte-foy': 'Quebec',
        'chicoutimi': 'Quebec', 'jonquiere': 'Quebec', 'beauport': 'Quebec', 'charlesbourg': 'Quebec',
        'hull': 'Quebec', 'aylmer': 'Quebec', 'buckingham': 'Quebec', 'masson-angers': 'Quebec',
        'saint-leonard': 'Quebec', 'saint leonard': 'Quebec', 'montreal-nord': 'Quebec', 'montreal nord': 'Quebec',

        // Ontario
        'toronto': 'Ontario', 'ottawa': 'Ontario', 'mississauga': 'Ontario', 'brampton': 'Ontario', 'hamilton': 'Ontario',
        'london': 'Ontario', 'markham': 'Ontario', 'vaughan': 'Ontario', 'kitchener': 'Ontario', 'windsor': 'Ontario',
        'richmond hill': 'Ontario', 'oakville': 'Ontario', 'burlington': 'Ontario', 'oshawa': 'Ontario', 'barrie': 'Ontario',
        'guelph': 'Ontario', 'cambridge': 'Ontario', 'whitby': 'Ontario', 'ajax': 'Ontario', 'pickering': 'Ontario',
        'newmarket': 'Ontario', 'waterloo': 'Ontario', 'sudbury': 'Ontario', 'brantford': 'Ontario', 'thunder bay': 'Ontario',
        'peterborough': 'Ontario', 'sarnia': 'Ontario', 'kingston': 'Ontario', 'sault ste marie': 'Ontario',
        'north bay': 'Ontario', 'welland': 'Ontario', 'belleville': 'Ontario', 'cornwall': 'Ontario',

        // British Columbia
        'vancouver': 'British Columbia', 'surrey': 'British Columbia', 'burnaby': 'British Columbia', 'richmond': 'British Columbia', 'coquitlam': 'British Columbia',
        'langley': 'British Columbia', 'saanich': 'British Columbia', 'delta': 'British Columbia', 'kelowna': 'British Columbia', 'kamloops': 'British Columbia',
        'nanaimo': 'British Columbia', 'victoria': 'British Columbia', 'chilliwack': 'British Columbia', 'prince george': 'British Columbia', 'vernon': 'British Columbia',
        'penticton': 'British Columbia', 'campbell river': 'British Columbia', 'courtenay': 'British Columbia', 'cranbrook': 'British Columbia',
        'fort st john': 'British Columbia', 'port coquitlam': 'British Columbia', 'north vancouver': 'British Columbia', 'west vancouver': 'British Columbia',
        'new westminster': 'British Columbia', 'port moody': 'British Columbia', 'maple ridge': 'British Columbia',

        // Alberta
        'calgary': 'Alberta', 'edmonton': 'Alberta', 'red deer': 'Alberta', 'lethbridge': 'Alberta', 'medicine hat': 'Alberta',
        'grande prairie': 'Alberta', 'airdrie': 'Alberta', 'spruce grove': 'Alberta', 'leduc': 'Alberta', 'lloydminster': 'Alberta',
        'camrose': 'Alberta', 'wetaskiwin': 'Alberta', 'cold lake': 'Alberta', 'lacombe': 'Alberta', 'fort mcmurray': 'Alberta',
        'brooks': 'Alberta', 'high river': 'Alberta', 'okotoks': 'Alberta', 'cochrane': 'Alberta', 'beaumont': 'Alberta',

        // Manitoba
        'winnipeg': 'Manitoba', 'brandon': 'Manitoba', 'steinbach': 'Manitoba', 'thompson': 'Manitoba', 'portage la prairie': 'Manitoba',
        'winkler': 'Manitoba', 'selkirk': 'Manitoba', 'morden': 'Manitoba', 'dauphin': 'Manitoba', 'the pas': 'Manitoba',

        // Saskatchewan
        'saskatoon': 'Saskatchewan', 'regina': 'Saskatchewan', 'prince albert': 'Saskatchewan', 'moose jaw': 'Saskatchewan', 'swift current': 'Saskatchewan',
        'yorkton': 'Saskatchewan', 'north battleford': 'Saskatchewan', 'estevan': 'Saskatchewan', 'weyburn': 'Saskatchewan', 'lloydminster': 'Saskatchewan',

        // Nova Scotia
        'halifax': 'Nova Scotia', 'cape breton': 'Nova Scotia', 'truro': 'Nova Scotia', 'new glasgow': 'Nova Scotia', 'glace bay': 'Nova Scotia',
        'sydney': 'Nova Scotia', 'yarmouth': 'Nova Scotia', 'kentville': 'Nova Scotia', 'amherst': 'Nova Scotia', 'bridgewater': 'Nova Scotia',

        // New Brunswick
        'moncton': 'New Brunswick', 'saint john': 'New Brunswick', 'fredericton': 'New Brunswick', 'dieppe': 'New Brunswick', 'riverview': 'New Brunswick',
        'campbellton': 'New Brunswick', 'edmundston': 'New Brunswick', 'miramichi': 'New Brunswick', 'bathurst': 'New Brunswick', 'sackville': 'New Brunswick',

        // Newfoundland and Labrador
        'st johns': 'Newfoundland and Labrador', 'mount pearl': 'Newfoundland and Labrador', 'corner brook': 'Newfoundland and Labrador', 'conception bay south': 'Newfoundland and Labrador',
        'paradise': 'Newfoundland and Labrador', 'grand falls-windsor': 'Newfoundland and Labrador', 'happy valley-goose bay': 'Newfoundland and Labrador', 'gander': 'Newfoundland and Labrador',

        // Prince Edward Island
        'charlottetown': 'Prince Edward Island', 'summerside': 'Prince Edward Island', 'stratford': 'Prince Edward Island', 'cornwall': 'Prince Edward Island', 'montague': 'Prince Edward Island',

        // Territories
        'yellowknife': 'Northwest Territories', 'hay river': 'Northwest Territories', 'inuvik': 'Northwest Territories', 'fort smith': 'Northwest Territories',
        'iqaluit': 'Nunavut', 'rankin inlet': 'Nunavut', 'arviat': 'Nunavut', 'baker lake': 'Nunavut',
        'whitehorse': 'Yukon', 'dawson city': 'Yukon', 'watson lake': 'Yukon', 'haines junction': 'Yukon'
      };

      // Try to find province by city name
      provinceForTax = cityToProvinceMap[cityLower] || '';

      // If not found by city, try to extract from address (more robust check)
      if (!provinceForTax && selectedStudio.address) {
        const addressLower = selectedStudio.address.toLowerCase();
        const provincePatterns = {
          'Quebec': ['quebec', 'québec', 'qc', 'que.'],
          'Ontario': ['ontario', 'on', 'ont.'],
          'British Columbia': ['british columbia', 'bc', 'b.c.'],
          'Alberta': ['alberta', 'ab', 'alta.'],
          'Manitoba': ['manitoba', 'mb', 'man.'],
          'Saskatchewan': ['saskatchewan', 'sk', 'sask.'],
          'Nova Scotia': ['nova scotia', 'ns', 'n.s.'],
          'New Brunswick': ['new brunswick', 'nb', 'n.b.'],
          'Newfoundland and Labrador': ['newfoundland', 'labrador', 'nl', 'n.l.', 'nfld.'],
          'Prince Edward Island': ['prince edward island', 'pei', 'p.e.i.', 'pe'],
          'Northwest Territories': ['northwest territories', 'nt', 'n.w.t.', 'nwt'],
          'Nunavut': ['nunavut', 'nu', 'nvt'],
          'Yukon': ['yukon', 'yt', 'yuk.']
        };

        for (const [province, patterns] of Object.entries(provincePatterns)) {
          if (patterns.some(pattern => addressLower.includes(pattern))) {
            provinceForTax = province;
            break;
          }
        }
      }

      // Fallback to Ontario if province still not determined
      if (!provinceForTax) {
        console.warn(`Could not determine province for hub in ${selectedStudio.city}. Defaulting to Ontario tax rates.`);
        provinceForTax = 'Ontario';
      }
      // --- END MODIFICATION ---

      // Check if we have tax rates for this province
      if (!canadianTaxRates[provinceForTax]) {
        console.warn(`No tax rate found for province: ${provinceForTax}. Defaulting to Ontario tax rates.`);
        provinceForTax = 'Ontario';
      }

      const rates = canadianTaxRates[provinceForTax];
      const taxableAmount = subtotal + deliveryCost + 1.99;
      let taxAmount = 0;

      if (rates.type === 'hst') {
        taxAmount = taxableAmount * rates.gst;
      } else {
        taxAmount = taxableAmount * (rates.gst + rates.pst);
      }

      return taxAmount;
    };


    const calculateItemsSubtotal = () => {
      const subtotal = cartItems.reduce((total, item) => {
        const itemTotal = calculateItemTotal(item);
        return total + itemTotal;
      }, 0);
      return subtotal;
    };

    const calculateDiscountAmount = (subtotal) => {
      if (!appliedDiscount) return 0;
      const value = parseFloat(appliedDiscount.value);
      if (appliedDiscount.valueType === 'percentage') {
        return subtotal * (Math.abs(value) / 100);
      } else if (appliedDiscount.valueType === 'fixed_amount') {
        return Math.min(Math.abs(value), subtotal);
      }
      return 0;
    };

    useEffect(() => {
      const itemsSubtotal = calculateItemsSubtotal();
      const deliveryCost = calculateDeliveryCost();
      // Pass selectedStudio directly to calculateTax
      const tax = calculateTax(itemsSubtotal, deliveryCost, selectedStudio);
      setCalculatedTax(tax);
    }, [cartItems, deliveryMethod, selectedStudio, selectedCountryFromLanding]); // Add selectedStudio to dependencies

    const calculateGrandTotal = () => {
      const itemsSubtotal = calculateItemsSubtotal();
      const discountAmount = calculateDiscountAmount(itemsSubtotal);
      const subtotalAfterDiscount = itemsSubtotal - discountAmount;
      const deliveryTotal = calculateDeliveryCost();
      // Add calculatedTax and service fee here
      return subtotalAfterDiscount + deliveryTotal + calculatedTax + SERVICE_FEE;
    };


    const updateItemQuantity = (cartItemId, newQuantity) => {
      if (newQuantity <= 0) {
        removeFromCart(cartItemId);
        return;
      }

      setCartItems(prevItems =>
        prevItems.map(item =>
          item.cartItemId === cartItemId
            ? { ...item, options: { ...item.options, quantity: newQuantity } }
            : item
        )
      );
    };

    const proceedToCheckout = () => {
      if (cartItems.length === 0) {
        setOrderError(getTranslatedText('yourCartIsEmpty'));
        return;
      }
      setOrderError('');
      setCurrentStep(2);
    };

    const goBackToCart = () => {
      setOrderError('');
      setOrderSuccess(false);
      setCurrentStep(1);
    };

    const submitCombinedOrder = async (paymentMethod = 'cash_on_delivery', paymentDetails = null) => {
      // Validation
      if (!customerInfo.name || !customerInfo.phone) {
        setOrderError(getTranslatedText('fillAllRequiredFields'));
        return;
      }

      if (deliveryMethod === 'express' && !selectedStudio) {
        setOrderError('Please select a pickup location.');
        return;
      }

      setOrderError('');
      setOrderSuccess(false);
      setIsLoading(true);

      const sourceVisitUrl = sessionStorage.getItem('sourceVisitUrl');
      const selectedCountry = sessionStorage.getItem('selectedCountry');

      // IMPORTANT: Recalculate pricing averages within this function to ensure accurate pricing
      let totalDocBW = 0, totalDocColor = 0, totalDocA3BW = 0, totalDocA3Color = 0;
      let totalPhoto10x15 = 0, totalPhoto15x23 = 0;

      cartItems.forEach(item => {
        if (item.type === 'document') {
          const pagesToPrint = computePagesToPrint(item);
          const copies = item.options.copies || 1;
          const itemTotalPages = pagesToPrint * copies;
          const paperSize = item.options.paperSize || 'a4';
          const colorType = item.options.color || 'bw';

          if (paperSize === 'a3') {
            if (colorType === 'bw') totalDocA3BW += itemTotalPages;
            else totalDocA3Color += itemTotalPages;
          } else {
            if (colorType === 'bw') totalDocBW += itemTotalPages;
            else totalDocColor += itemTotalPages;
          }
        } else if (item.type === 'photo') {
          const quantity = item.options?.quantity || 0;
          const size = item.options?.size || item.photo?.size || '10x15';

          if (size === '10x15') totalPhoto10x15 += quantity;
          else if (size === '15x23') totalPhoto15x23 += quantity;
        }
      });

      // Calculate costs and averages using tiered pricing
      const totalCostBW = calculateTieredCost(totalDocBW, pricing.documents.bw);
      const totalCostColor = calculateTieredCost(totalDocColor, pricing.documents.color);
      const totalCostA3BW = calculateTieredCost(totalDocA3BW, pricing.documents.a3_bw);
      const totalCostA3Color = calculateTieredCost(totalDocA3Color, pricing.documents.a3_color);
      const totalCost10x15 = calculateTieredCost(totalPhoto10x15, pricing.photos['10x15']);
      const totalCost15x23 = calculateTieredCost(totalPhoto15x23, pricing.photos['15x23']);

      const localAveragePriceBW = totalDocBW > 0 ? totalCostBW / totalDocBW : 0;
      const localAveragePriceColor = totalDocColor > 0 ? totalCostColor / totalDocColor : 0;
      const localAveragePriceA3BW = totalDocA3BW > 0 ? totalCostA3BW / totalDocA3BW : 0;
      const localAveragePriceA3Color = totalDocA3Color > 0 ? totalCostA3Color / totalDocA3Color : 0;
      const localAveragePrice10x15 = totalPhoto10x15 > 0 ? totalCost10x15 / totalPhoto10x15 : 0;
      const localAveragePrice15x23 = totalPhoto15x23 > 0 ? totalCost15x23 / totalPhoto15x23 : 0;

      // Create order items using the locally calculated averages
      // Create order items using the locally calculated averages
      const orderItemsForSubmission = cartItems.map(item => {
        const itemOptions = item.options || {};
        const storedFileData = fileDataMap.current.get(item.cartItemId);

        let totalUnitsForThisItem = 0;
        let effectiveUnitPrice = 0;
        let itemCost = 0;

        if (item.type === 'document') {
          const pagesToPrint = computePagesToPrint(item);
          const copies = itemOptions.copies || 1;
          totalUnitsForThisItem = pagesToPrint * copies;
          const colorType = itemOptions.color || 'bw';
          const paperSize = (itemOptions.paperSize || 'a4').toLowerCase();

          // Get the correct pricing from the pricing object
          const docPricing = pricing.documents?.[paperSize];
          if (docPricing) {
            const colorKey = colorType === 'color' ? 'color' : 'black_white';
            const colorPricing = docPricing[colorKey];

            if (colorPricing) {
              // Use tiered pricing based on total pages
              if (totalUnitsForThisItem >= 1 && totalUnitsForThisItem <= 24) {
                effectiveUnitPrice = colorPricing.tiers?.['1-24'] || colorPricing.price_per_page;
              } else if (totalUnitsForThisItem >= 25 && totalUnitsForThisItem <= 74) {
                effectiveUnitPrice = colorPricing.tiers?.['25-74'] || colorPricing.price_per_page;
              } else {
                effectiveUnitPrice = colorPricing.tiers?.['75+'] || colorPricing.price_per_page;
              }
            }
          }

          itemCost = totalUnitsForThisItem * effectiveUnitPrice;

          console.log(`Document ${item.file.name}:`, {
            pagesToPrint,
            copies,
            totalUnitsForThisItem,
            paperSize,
            colorType,
            effectiveUnitPrice,
            itemCost
          });

        } else if (item.type === 'photo') {
          totalUnitsForThisItem = item.options?.quantity || item.quantity || 0;
          const size = item.options?.size || item.photo?.size || '10x15';

          // Get the correct pricing from the pricing object
          const photoPricing = pricing.photos?.[size];
          if (photoPricing) {
            // Use tiered pricing based on quantity
            if (totalUnitsForThisItem >= 1 && totalUnitsForThisItem <= 24) {
              effectiveUnitPrice = photoPricing.tiers?.['1-24'] || photoPricing.price_per_photo;
            } else if (totalUnitsForThisItem >= 25 && totalUnitsForThisItem <= 74) {
              effectiveUnitPrice = photoPricing.tiers?.['25-74'] || photoPricing.price_per_photo;
            } else {
              effectiveUnitPrice = photoPricing.tiers?.['75+'] || photoPricing.price_per_photo;
            }
          }

          itemCost = totalUnitsForThisItem * effectiveUnitPrice;

          console.log(`Photo ${item.photo.name}:`, {
            totalUnitsForThisItem,
            size,
            effectiveUnitPrice,
            itemCost
          });
        }

        const baseItem = {
          type: item.type,
          cartItemId: item.cartItemId,
          itemCost: itemCost,
          unitPrice: effectiveUnitPrice,
          totalUnits: totalUnitsForThisItem
        };

        if (item.type === 'document') {
          baseItem.name = item.file.name;
          baseItem.file = {
            name: item.file.name,
            pagesSelected: item.file.pagesSelected,
            base64: storedFileData?.base64 || item.file.base64 || item.file.url,
            fileType: item.file.fileType || storedFileData?.originalFile?.type || 'application/pdf'
          };
          baseItem.documentOptions = {
            pageSelection: itemOptions.pageSelection || "all",
            pageRange: itemOptions.pageRange || "",
            sides: itemOptions.sides || "simplex",
            color: itemOptions.color || "bw",
            copies: itemOptions.copies || 1,
            paperSize: itemOptions.paperSize || "a4",
            spiralBinding: itemOptions.spiralBinding || false,
            spiralBindingFee: itemOptions.spiralBindingFee || 0
          };
          baseItem.options = baseItem.documentOptions;

        } else if (item.type === 'photo') {
          baseItem.name = item.photo.name;

          // Get the actual base64 data for photos
          let photoBase64 = '';

          if (storedFileData?.base64 && !storedFileData.base64.startsWith('blob:')) {
            photoBase64 = storedFileData.base64;
          } else if (item.base64 && !item.base64.startsWith('blob:')) {
            photoBase64 = item.base64;
          } else if (item.photo?.base64 && !item.photo.base64.startsWith('blob:')) {
            photoBase64 = item.photo.base64;
          }

          baseItem.photo = {
            name: item.photo.name,
            base64: photoBase64,
            size: item.options?.size || item.photo?.size || '10x15',
          };
          baseItem.photoOptions = {
            quantity: itemOptions.quantity || item.quantity || 1,
            paperType: itemOptions.paperType || 'standard',
          };
          baseItem.options = baseItem.photoOptions;
        }

        return baseItem;
      });


      // Validate that all items have valid base64 data before submitting
      const itemsWithMissingData = orderItemsForSubmission.filter(item => {
        if (item.type === 'document') {
          return !item.file?.base64;
        } else if (item.type === 'photo') {
          const hasValidBase64 = item.photo?.base64 &&
            item.photo.base64.length > 0 &&
            !item.photo.base64.startsWith('blob:');

          if (!hasValidBase64) {
            console.error(`Photo ${item.photo?.name} has invalid base64 data:`, {
              base64Preview: item.photo?.base64?.substring(0, 50),
              base64Length: item.photo?.base64?.length || 0,
              isBlob: item.photo?.base64?.startsWith('blob:')
            });
          }

          return !hasValidBase64;
        }
        return false;
      });

      if (itemsWithMissingData.length > 0) {
        console.error('Items with missing or invalid file data:', itemsWithMissingData.map(item => ({
          name: item.name,
          type: item.type,
          cartItemId: item.cartItemId
        })));
        setOrderError('Some files are missing data or could not be processed. Please try removing and re-adding these items to your cart.');
        setIsLoading(false);
        return;
      }

      // Debugging output
      console.log('=== ORDER SUBMISSION DEBUG ===');
      console.log('Locally calculated pricing averages:', {
        localAveragePriceBW,
        localAveragePriceColor,
        localAveragePriceA3BW,
        localAveragePriceA3Color,
        localAveragePrice10x15,
        localAveragePrice15x23
      });

      orderItemsForSubmission.forEach((item, index) => {
        console.log(`Item ${index}:`, {
          type: item.type,
          name: item.name,
          unitPrice: item.unitPrice,
          itemCost: item.itemCost,
          totalUnits: item.type === 'document' ?
            (computePagesToPrint(cartItems[index]) * (cartItems[index].options.copies || 1)) :
            (cartItems[index].options?.quantity || 0)
        });
      });
      console.log('================================');

      // Initialize orderData
      const orderData = {
        orderNumber: `ORDER-${Date.now()}-${Math.floor(Math.random() * 1000)}`,
        email: customerInfo.email || '',
        phone: customerInfo.phone,
        name: customerInfo.name,
        customerDetails: {
          name: customerInfo.name,
          email: customerInfo.email || '',
          phone: customerInfo.phone,
          country: customerInfo.shippingAddress?.country || selectedCountry || 'canada',
        },
        paymentMethod: paymentMethod,
        paymentDetails: null,
        orderItems: orderItemsForSubmission,
        totalAmount: calculateGrandTotal(),
        subtotal: calculateItemsSubtotal(),
        shippingFee: calculateDeliveryCost(),
        taxAmount: calculatedTax,
        discount: appliedDiscount ? {
          code: appliedDiscount.title,
          value: appliedDiscount.value,
          valueType: appliedDiscount.valueType,
          amount: calculateDiscountAmount(calculateItemsSubtotal())
        } : null,
        currency: (selectedCountryFromLanding === 'canada') ? '$' : 'TND',
        orderNote: customerInfo.notes,
        deliveryMethod: deliveryMethod,
        deliveryFee: 0,
        deliveryTimeframe: '',
        pickupStudio: deliveryMethod === 'express' && selectedStudio ? {
          _id: selectedStudio._id,
          name: selectedStudio.name,
          address: selectedStudio.address,
          city: selectedStudio.city,
          country: selectedStudio.country,
          phone: selectedStudio.phone,
          email: selectedStudio.email,
        } : undefined,
        selectedCountry: customerInfo.shippingAddress?.country || selectedCountry || 'canada',
        sourceVisitUrl,
      };

      if (deliveryMethod === 'shipping' && customerInfo.shippingAddress) {
        orderData.shippingAddress = {
          firstName: customerInfo.shippingAddress.firstName || '',
          lastName: customerInfo.shippingAddress.lastName || '',
          address: customerInfo.shippingAddress.address || '',
          city: customerInfo.shippingAddress.city || '',
          postalCode: customerInfo.shippingAddress.postalCode || '',
          country: customerInfo.shippingAddress.country || selectedCountry || 'canada',
          province: customerInfo.shippingAddress.province || '',
          state: customerInfo.shippingAddress.state || ''
        };
      }

      console.log('Order data being sent:', JSON.stringify(orderData, null, 2));

      try {
        // Step 1: Save order to database
        console.log('Saving order to database...');
        const response = await fetch('https://freezepix-database-server-c95d4dd2046d.herokuapp.com/api/orders/chunk', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(orderData),
        });

        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.details || getTranslatedText('errorPlacingOrder'));
        }

        const result = await response.json();
        console.log('Order placed successfully:', result);
        setOrderNumber(result.orderNumber);
        setOrderSuccess(true);

        // Step 2: Send email notifications
        console.log('Sending email notifications...');
        try {
          const emailResponse = await fetch('https://freezepix-database-server-c95d4dd2046d.herokuapp.com/send-order-confirmation', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(orderData),
          });

          if (emailResponse.ok) {
            const emailResult = await emailResponse.json();
            console.log('Email notifications sent successfully:', emailResult);
          } else {
            const emailError = await emailResponse.json();
            console.error('Failed to send email notifications:', emailError);
          }
        } catch (emailError) {
          console.error('Error sending email notifications:', emailError);
        }

        // Step 3: Clear the cart and file data after successful order
        setCartItems([]);
        localStorage.removeItem(CART_STORAGE_KEY);
        fileDataMap.current.clear();

      } catch (error) {
        console.error('Error submitting order:', error);
        setOrderError(error.message);
      } finally {
        setIsLoading(false);
      }
    };



    // Add validation function for required fields
    const areRequiredFieldsFilled = () => {
      return (
        customerInfo.name?.trim() !== '' &&
        customerInfo.phone?.trim() !== '' &&
        customerInfo.email?.trim() !== '' // Email is marked as required in your translations
      );
    };

    const onHelcimPaymentSuccess = async (paymentDetails) => {
      console.log("Helcim Payment Success Callback:", paymentDetails);
      // Pass 'credit_card' as the payment method
      await submitCombinedOrder('credit_card', paymentDetails);
    };

    useEffect(() => {
      const country = sessionStorage.getItem('selectedCountry');
      const region = sessionStorage.getItem('selectedRegion');
      const city = sessionStorage.getItem('selectedCity');

      if (country || region || city) {
        setCustomerInfo(prev => ({
          ...prev,
          shippingAddress: {
            ...prev.shippingAddress,
            country: country || 'Canada',
            province: region || 'Ontario',
            city: city || ''
          },
          paymentMethod: 'cash_on_delivery' // Changed from 'credit_card'
        }));
      } else {
        setCustomerInfo(prev => ({
          ...prev,
          shippingAddress: {
            ...prev.shippingAddress,
            country: 'Canada',
            province: 'Ontario',
            city: ''
          },
          paymentMethod: 'cash_on_delivery' // Changed from 'credit_card'
        }));
      }
    }, []);

    const closeModalAndReset = () => {
      setIsCartModalOpen(false);
      setCurrentStep(1);
      setOrderError('');
      setOrderSuccess(false);
      setIsLoading(false);
      setOrderNumber(null);
      setDeliveryMethod('express');
      setCustomerInfo({
        name: '', phone: '', email: '', notes: '',
        shippingAddress: { firstName: '', lastName: '', address: '', city: '', postalCode: '', country: 'Canada', province: 'Ontario', state: '' },
        // Changed back to 'cash_on_delivery'
        paymentMethod: 'cash_on_delivery'
      });
      setLocalDiscountCode('');
      setDiscountCode('');
      setAppliedDiscount(null);
      setDiscountError('');
      setSelectedStudio(null);

      sessionStorage.removeItem('cartModalCurrentStep');
      sessionStorage.removeItem('cartModalCustomerInfo');
      fileDataMap.current.clear();
    };

    if (!isCartModalOpen) return null;

    // Determine if the selected studio is unavailable
    const isStudioUnavailable = selectedStudio && (selectedStudio.vacationStatus?.onVacation || !selectedStudio.openStatus?.isOpen);

    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-40 p-2 sm:p-4">
        <div className="bg-white rounded-lg w-full max-w-4xl max-h-[95vh] sm:max-h-[90vh] overflow-hidden mx-2 sm:mx-0">
          {/* Header */}
          <div className="flex items-center justify-between p-3 sm:p-6 border-b">
            <h2 className="text-lg sm:text-2xl font-bold text-gray-800 truncate pr-2">
              {getTranslatedText('myCart')}
            </h2>
            <button
              onClick={closeModalAndReset}
              className="text-gray-500 hover:text-gray-700 flex-shrink-0 p-1"
            >
              <X className="w-5 h-5 sm:w-6 sm:h-6" />
            </button>
          </div>

          <div className="p-3 sm:p-6 max-h-[70vh] sm:max-h-[60vh] overflow-y-auto">
            {/* Order Success Screen */}
            {orderSuccess ? (
              <div className="text-center py-8">
                <CheckCircle className="w-16 h-16 text-green-500 mx-auto mb-4" />
                <h3 className="text-xl sm:text-2xl font-bold mb-3">{getTranslatedText('orderPlacedSuccessfully')}</h3>
                <p className="text-gray-700 mb-2">{getTranslatedText('thankYou')}</p>
                <p className="text-gray-700 mb-4">
                  <strong>{getTranslatedText('orderNumber')}:</strong> {orderNumber}
                </p>
                {appliedDiscount && appliedDiscount.valueType === 'fixed_amount' && parseFloat(appliedDiscount.value) > calculateDiscountAmount(calculateItemsSubtotal()) && (
                  <p className="text-gray-700 mb-4">
                    <strong>{getTranslatedText('remainingCouponBalance')}:</strong> {(parseFloat(appliedDiscount.value) - calculateDiscountAmount(calculateItemsSubtotal())).toFixed(2)} {currency}
                  </p>
                )}
                <p className="text-gray-600 mb-6">{getTranslatedText('weWillContactYou')}</p>
                <button
                  onClick={closeModalAndReset}
                  className="bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors"
                >
                  {getTranslatedText('backToHome')}
                </button>
              </div>
            ) : (
              <>
                {/* Step 1: Cart Items Display */}
                {currentStep === 1 && (
                  <div>
                    {cartItems.length === 0 ? (
                      <p className="text-gray-500 text-center py-8">{getTranslatedText('yourCartIsEmpty')}</p>
                    ) : (
                      <div className="space-y-4">
                        {cartItems.map((item) => (
                          <div key={item.cartItemId} className="border border-gray-200 rounded-lg p-3 sm:p-4">
                            <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start gap-3">
                              <div className="flex-1">
                                <div className="flex items-center gap-2 sm:gap-3 mb-3">
                                  <div className="relative group flex-shrink-0">
                                    {item.type === 'document' && (
                                      item.file.previewPages && item.file.previewPages.length > 0 ? (
                                        <div className="relative">
                                          <img
                                            src={item.file.previewPages[0]}
                                            alt={getTranslatedText('documentPreview')}
                                            className="w-16 h-16 sm:w-20 sm:h-20 object-contain border rounded cursor-pointer hover:opacity-75 transition-opacity"
                                            onClick={() => openPreview(item)}
                                          />
                                          <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity bg-black bg-opacity-30 rounded">
                                            <Eye className="w-4 h-4 sm:w-6 sm:h-6 text-white" />
                                          </div>
                                        </div>
                                      ) : (
                                        <div
                                          className="w-16 h-16 sm:w-20 sm:h-20 flex items-center justify-center border rounded cursor-pointer hover:bg-gray-50"
                                          onClick={() => openPreview(item)}
                                        >
                                          <File className="text-blue-600 w-8 h-8 sm:w-10 sm:h-10" />
                                        </div>
                                      )
                                    )}

                                    {item.type === 'photo' && (
                                      item.photo.url ? (
                                        <div className="relative">
                                          <img
                                            src={item.photo.url}
                                            alt={getTranslatedText('photoPreview')}
                                            className="w-16 h-16 sm:w-20 sm:h-20 object-cover border rounded cursor-pointer hover:opacity-75 transition-opacity"
                                            onClick={() => openPreview(item)}
                                          />
                                          <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity bg-black bg-opacity-30 rounded">
                                            <Eye className="w-4 h-4 sm:w-6 sm:h-6 text-white" />
                                          </div>
                                        </div>
                                      ) : (
                                        <div
                                          className="w-16 h-16 sm:w-20 sm:h-20 flex items-center justify-center border rounded cursor-pointer hover:bg-gray-50"
                                          onClick={() => openPreview(item)}
                                        >
                                          <Image className="text-green-600 w-8 h-8 sm:w-10 sm:h-10" />
                                        </div>
                                      )
                                    )}
                                    <div className="absolute -bottom-1 -right-1 bg-blue-500 text-white rounded-full p-1 opacity-0 group-hover:opacity-100 transition-opacity">
                                      <Eye className="w-3 h-3" />
                                    </div>
                                  </div>

                                  <div className="flex-1 min-w-0">
                                    <span className={`px-2 py-1 rounded text-xs font-medium ${item.type === 'document' ? 'bg-blue-100 text-blue-800' : 'bg-green-100 text-green-800'}`}>
                                      {item.type === 'document' ? getTranslatedText('document') : getTranslatedText('photo')}
                                    </span>

                                    <h4 className="font-medium text-gray-800 mt-1 text-sm sm:text-base truncate">
                                      {item.type === 'document' ? item.file.name : item.photo.name}
                                    </h4>

                                    <button
                                      onClick={() => openPreview(item)}
                                      className="text-blue-600 hover:text-blue-800 text-xs sm:text-sm mt-1 flex items-center gap-1"
                                    >
                                      <Eye className="w-3 h-3 sm:w-4 sm:h-4" />
                                      {getTranslatedText('viewPreview')}
                                    </button>
                                  </div>
                                </div>

                                {/* Document Details */}
                                {item.type === 'document' && (
                                  <div className="text-xs sm:text-sm text-gray-600 space-y-1 bg-gray-50 p-2 rounded">
                                    <div className="grid grid-cols-2 gap-2">
                                      <p className="col-span-full">
                                        {item.options.pageSelection === 'all'
                                          ? getTranslatedText('allPages')
                                          : `${getTranslatedText('specificPages')} (${item.options.pageRange})`
                                        }
                                      </p>
                                      <p>{getTranslatedText('pages')}: {item.file.pagesSelected}</p>
                                      <p>{getTranslatedText('copies')}: {item.options.copies}</p>
                                      <p>
                                        {getTranslatedText('papersize')}: {
                                          item.options.paperSize?.toLowerCase() === 'a4' ? 'Letter format' :
                                            item.options.paperSize?.toLowerCase() === 'a3' ? 'Legal format' :
                                              item.options.paperSize?.toUpperCase() || 'Letter format'
                                        }
                                      </p>
                                      <p className="col-span-2">{getTranslatedText('type')}: {item.options.color === 'color' ? getTranslatedText('colorPrint') : getTranslatedText('blackAndWhitePrint')}</p>
                                    </div>
                                  </div>
                                )}

                                {/* Photo Details */}
                                {item.type === 'photo' && (
                                  <div className="text-xs sm:text-sm text-gray-600 space-y-1 bg-gray-50 p-2 rounded">
                                    <div className="grid grid-cols-2 gap-2">
                                      <p>{getTranslatedText('size')}: {item.photo.size}</p>
                                      <p>{getTranslatedText('quantity')}: {item.options.quantity}</p>
                                      {item.options.paperType && <p className="col-span-2">{getTranslatedText('paper')}: {item.options.paperType}</p>}
                                    </div>
                                  </div>
                                )}
                              </div>

                              {/* Price and Remove Button */}
                              <div className="flex sm:flex-col justify-between sm:justify-start items-center sm:items-end gap-2 sm:gap-0 sm:text-right border-t sm:border-t-0 pt-3 sm:pt-0">

                                <button
                                  onClick={() => removeFromCart(item.cartItemId)}
                                  className="text-red-500 hover:text-red-700 text-xs sm:text-sm flex items-center gap-1 order-2 sm:order-none sm:mt-2"
                                >
                                  <Trash2 className="w-3 h-3 sm:w-4 sm:h-4" />
                                  {getTranslatedText('remove')}
                                </button>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                    {cartItems.length > 0 && (
                      <div className="flex justify-end mt-6">
                        <button
                          onClick={proceedToCheckout}
                          className="w-full sm:w-auto bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition-colors"
                          disabled={isLoading}
                        >
                          {getTranslatedText('continue')}
                        </button>
                      </div>
                    )}
                  </div>
                )}

                {/* Step 2: Combined Checkout */}
                {currentStep === 2 && (
                  <div className="space-y-6">
                    {/* Order Summary Section */}
                    <div className="space-y-4 border-b pb-4"> {/* Added border-b and pb-4 for separation */}
                      <h3 className="text-lg sm:text-xl font-semibold mb-4">{getTranslatedText('itemsOrdered')}</h3> {/* New header */}

                      {/* List of Items Ordered */}
                      {cartItems.length > 0 ? (
                        <div className="space-y-3">
                          {cartItems.map((item) => (
                            <div key={item.cartItemId} className="flex justify-between items-start text-sm sm:text-base">
                              <div className="flex-1 pr-2">
                                <p className="font-medium text-gray-800">
                                  {item.type === 'document' ? item.file.name : item.photo.name}
                                </p>
                                {item.type === 'document' && (
                                  <p className="text-xs text-gray-600">
                                    {getTranslatedText('pages')}: {computePagesToPrint(item)} | {getTranslatedText('copies')}: {item.options.copies} | {getTranslatedText('type')}: {item.options.color === 'color' ? getTranslatedText('colorPrint') : getTranslatedText('blackAndWhitePrint')} | {getTranslatedText('papersize')}: {item.options.paperSize?.toLowerCase() === 'a4' ? getTranslatedText('a4') : item.options.paperSize?.toLowerCase() === 'a3' ? getTranslatedText('a3') : item.options.paperSize?.toUpperCase() || getTranslatedText('a4')}
                                    {item.options.spiralBinding && ` | ${getTranslatedText('spiralBinding')} ${getTranslatedText('added')}`}
                                  </p>
                                )}
                                {item.type === 'photo' && (
                                  <p className="text-xs text-gray-600">
                                    {getTranslatedText('size')}: {item.photo.size} | {getTranslatedText('quantity')}: {item.options.quantity}
                                  </p>
                                )}
                              </div>
                              <div className="font-medium text-gray-800 flex-shrink-0">
                                {calculateItemTotal(item).toFixed(2)} {currency}
                              </div>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <p className="text-gray-500">{getTranslatedText('yourCartIsEmpty')}</p>
                      )}
                    </div>

                    {/* Subtotal, Discount, Tax, Grand Total */}
                    <div className="space-y-2 pt-4 text-xs sm:text-sm"> {/* Removed border-t, added pt-4 */}

                      {/* Items Subtotal */}
                      <div className="flex justify-between text-sm sm:text-base font-medium mb-2">
                        <span>{getTranslatedText('itemsSubtotal')}:</span>
                        <span>{calculateItemsSubtotal().toFixed(2)} {currency}</span>
                      </div>

                      {/* Discount Display (if applicable) */}
                      {appliedDiscount && (
                        <div className="flex justify-between text-green-600">
                          <span>{getTranslatedText('discount')} ({appliedDiscount.code}):</span>
                          <span>-{calculateDiscountAmount(calculateItemsSubtotal()).toFixed(2)} {currency}</span>
                        </div>
                      )}

                      {/* Subtotal After Discount (if discount applied) */}
                      {appliedDiscount && (
                        <div className="flex justify-between text-gray-700">
                          <span>{getTranslatedText('subtotalAfterDiscount')}:</span>
                          <span>{(calculateItemsSubtotal() - calculateDiscountAmount(calculateItemsSubtotal())).toFixed(2)} {currency}</span>
                        </div>
                      )}

                      {/* Service and Handling Fee - ADD THIS */}
                      <div className="flex justify-between text-gray-700">
                        <span>{getTranslatedText('handling')}:</span>
                        <span>{SERVICE_FEE.toFixed(2)} {currency}</span>
                      </div>

                      {/* Delivery Cost
    <div className="flex justify-between">
        <span>{getTranslatedText('delivery')}:</span>
        <span>{calculateDeliveryCost().toFixed(2)} {currency}</span>
    </div> */}

                      {/* TAX DISPLAY - Only for Canada with calculated tax */}

                      <div className="tax-breakdown space-y-1 text-xs sm:text-sm border-t pt-2">
                        {/* Tax Display - Fixed Version */}
                        {calculatedTax > 0 && selectedStudio && (
                          <div className="tax-breakdown space-y-1 text-xs sm:text-sm border-t pt-2">
                            {(() => {
                              // Simplified province detection
                              const getProvinceCode = (studio) => {
                                if (!studio) return 'ON'; // Default to Ontario

                                const cityUpper = (studio.city || '').toUpperCase().trim();

                                // Simple city-to-province mapping
                                const cityToProvince = {
                                  // Quebec cities
                                  'MONTREAL': 'QC', 'MOUNT ROYAL': 'QC', 'QUEBEC': 'QC', 'QUEBEC CITY': 'QC', 'LAVAL': 'QC',
                                  'GATINEAU': 'QC', 'LONGUEUIL': 'QC', 'SHERBROOKE': 'QC', 'SAGUENAY': 'QC',

                                  // Ontario cities
                                  'TORONTO': 'ON', 'OTTAWA': 'ON', 'MISSISSAUGA': 'ON', 'HAMILTON': 'ON',
                                  'BRAMPTON': 'ON', 'LONDON': 'ON', 'MARKHAM': 'ON', 'VAUGHAN': 'ON',

                                  // BC cities
                                  'VANCOUVER': 'BC', 'SURREY': 'BC', 'BURNABY': 'BC', 'RICHMOND': 'BC',
                                  'COQUITLAM': 'BC', 'LANGLEY': 'BC', 'VICTORIA': 'BC', 'KELOWNA': 'BC',

                                  // Alberta cities
                                  'CALGARY': 'AB', 'EDMONTON': 'AB', 'RED DEER': 'AB', 'LETHBRIDGE': 'AB'
                                };

                                return cityToProvince[cityUpper] || 'ON'; // Default to Ontario
                              };

                              const provinceCode = getProvinceCode(selectedStudio);
                              const subtotalForTax = calculateItemsSubtotal() - calculateDiscountAmount(calculateItemsSubtotal()) + 1.99;

                              // Tax rates by province
                              const taxRates = {
                                'QC': { gst: 0.05, qst: 0.09975, type: 'gst_qst' },
                                'ON': { hst: 0.13, type: 'hst' },
                                'BC': { gst: 0.05, pst: 0.07, type: 'gst_pst' },
                                'AB': { gst: 0.05, type: 'gst_only' },
                                'MB': { gst: 0.05, pst: 0.07, type: 'gst_pst' },
                                'SK': { gst: 0.05, pst: 0.06, type: 'gst_pst' },
                                'NS': { hst: 0.15, type: 'hst' },
                                'NB': { hst: 0.15, type: 'hst' },
                                'NL': { hst: 0.15, type: 'hst' },
                                'PE': { hst: 0.15, type: 'hst' },
                                'NT': { gst: 0.05, type: 'gst_only' },
                                'NU': { gst: 0.05, type: 'gst_only' },
                                'YT': { gst: 0.05, type: 'gst_only' }
                              };

                              const rates = taxRates[provinceCode] || taxRates['ON']; // Default to Ontario

                              // Calculate and display taxes based on province
                              if (rates.type === 'hst') {
                                const hstAmount = subtotalForTax * rates.hst;
                                return (
                                  <div className="flex justify-between">
                                    <span>HST ({(rates.hst * 100).toFixed(1)}%):</span>
                                    <span>{hstAmount.toFixed(2)} {currency}</span>
                                  </div>
                                );
                              } else if (rates.type === 'gst_qst') {
                                const gstAmount = subtotalForTax * rates.gst;
                                const qstAmount = subtotalForTax * rates.qst;
                                return (
                                  <>
                                    <div className="flex justify-between">
                                      <span>GST ({(rates.gst * 100).toFixed(1)}%):</span>
                                      <span>{gstAmount.toFixed(2)} {currency}</span>
                                    </div>
                                    <div className="flex justify-between">
                                      <span>QST ({(rates.qst * 100).toFixed(3)}%):</span>
                                      <span>{qstAmount.toFixed(2)} {currency}</span>
                                    </div>
                                  </>
                                );
                              } else if (rates.type === 'gst_pst') {
                                const gstAmount = subtotalForTax * rates.gst;
                                const pstAmount = subtotalForTax * rates.pst;
                                return (
                                  <>
                                    <div className="flex justify-between">
                                      <span>GST ({(rates.gst * 100).toFixed(1)}%):</span>
                                      <span>{gstAmount.toFixed(2)} {currency}</span>
                                    </div>
                                    <div className="flex justify-between">
                                      <span>PST ({(rates.pst * 100).toFixed(1)}%):</span>
                                      <span>{pstAmount.toFixed(2)} {currency}</span>
                                    </div>
                                  </>
                                );
                              } else {
                                // GST only
                                const gstAmount = subtotalForTax * rates.gst;
                                return (
                                  <div className="flex justify-between">
                                    <span>GST ({(rates.gst * 100).toFixed(1)}%):</span>
                                    <span>{gstAmount.toFixed(2)} {currency}</span>
                                  </div>
                                );
                              }
                            })()}
                          </div>
                        )}
                      </div>

                      {/* GRAND TOTAL - Including Tax */}
                      <div className="flex justify-between font-bold text-sm sm:text-lg border-t pt-2 mt-2">
                        <span>{getTranslatedText('total')}:</span>
                        <span>{calculateGrandTotal().toFixed(2)} {currency}</span>
                      </div>
                    </div>


                    {/* Delivery Method Selection - Only Pickup (Express) */}
                    <div>
                      <h4 className="font-medium mb-3 text-sm sm:text-base">{getTranslatedText('deliveryMethod')}</h4>
                      <div className="space-y-3">
                        <label className="flex items-center space-x-3 cursor-pointer">
                          <input
                            type="radio"
                            name="deliveryMethod"
                            value="express"
                            checked={deliveryMethod === 'express'}
                            onChange={() => setDeliveryMethod('express')}
                            className="text-blue-600"
                          />
                          <span className="text-sm">{getTranslatedText('studioPickup')}</span>
                        </label>
                      </div>
                    </div>

                    {/* Studio Location Selection (only for pickup) */}
                    {deliveryMethod === 'express' && (
                      <div> {/* Disable if studio is unavailable */}
                        {selectedStudio && (() => {
                          const today = new Date().getDay();
                          const todayHours = selectedStudio.operatingHours?.find(h => h.day === today);
                          const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

                          // Function to subtract 1 hour from time
                          const subtractOneHour = (timeStr) => {
                            const [hours, minutes] = timeStr.split(':').map(Number);
                            const newHours = hours - 1;
                            return `${String(newHours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
                          };

                          return (
                            <div className="mt-4 p-3 bg-gray-50 rounded-lg border border-gray-200">
                              <p className="font-semibold text-sm sm:text-base">{selectedStudio.name}</p>
                              <p className="text-xs sm:text-sm text-gray-700">
                                {selectedStudio.address}, {selectedStudio.city}, {selectedStudio.country}
                              </p>
                              {selectedStudio.phone && (
                                <p className="text-xs sm:text-sm text-gray-700">Phone: {selectedStudio.phone}</p>
                              )}
                              {selectedStudio.operatingHours && selectedStudio.operatingHours.length > 0 && (
                                <p className="text-xs sm:text-sm text-gray-700">
                                  Hours ({daysOfWeek[today]}): {
                                    !todayHours
                                      ? 'Not available'
                                      : todayHours.isClosed
                                        ? 'Closed today'
                                        : `${todayHours.openTime} - ${subtractOneHour(todayHours.closeTime)}`
                                  }
                                </p>
                              )}
                            </div>
                          );
                        })()}
                      </div>
                    )}

                    {/* Customer Information */}
                    <div > {/* Disable if studio is unavailable */}
                      <h4 className="font-medium mb-3 text-sm sm:text-base">{getTranslatedText('customerInformation')}</h4>
                      <div className="grid grid-cols-1 gap-4">
                        <div>
                          <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
                            {getTranslatedText('fullNameRequired')}
                          </label>
                          <input
                            type="text"
                            required
                            value={customerInfo.name}
                            onChange={(e) => setCustomerInfo({ ...customerInfo, name: e.target.value })}
                            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                          />
                        </div>

                        <div>
                          <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
                            {getTranslatedText('phoneNumberRequired')}
                          </label>
                          <input
                            type="tel"
                            required
                            value={customerInfo.phone}
                            onChange={(e) => setCustomerInfo({ ...customerInfo, phone: e.target.value })}
                            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                          />
                        </div>

                        <div>
                          <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
                            {getTranslatedText('emailOptional')}
                          </label>
                          <input
                            type="email"
                            value={customerInfo.email}
                            onChange={(e) => setCustomerInfo({ ...customerInfo, email: e.target.value })}
                            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                          />
                        </div>
                      </div>
                    </div>

                    {/* Shipping Address - Removed as delivery is always pickup */}
                    {/* Order Notes */}
                    <div > {/* Disable if studio is unavailable */}
                      <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
                        {getTranslatedText('orderNoteOptional')}
                      </label>
                      <textarea
                        value={customerInfo.notes}
                        onChange={(e) => setCustomerInfo({ ...customerInfo, notes: e.target.value })}
                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                        rows="2"
                      />
                    </div>

                    {/* Payment Method Selection - Only Prepaid Card (Helcim) */}
                    <div > {/* Disable if studio is unavailable */}
                      <h4 className="font-medium mb-3 text-sm sm:text-base">{getTranslatedText('payment')}</h4>
                      <div className="space-y-3">
                        {/* Remove Helcim option and keep only cash on delivery */}
                        <label className="flex items-center space-x-3 cursor-pointer">
                          <input
                            type="radio"
                            name="paymentMethod"
                            value="cash_on_delivery"
                            checked={customerInfo.paymentMethod === 'cash_on_delivery'}
                            onChange={() => setCustomerInfo(prev => ({ ...prev, paymentMethod: 'cash_on_delivery' }))}
                            className="text-blue-600"
                          />
                          <span className="text-sm">{getTranslatedText('cashOnDelivery')}</span>
                        </label>
                      </div>
                    </div>



                    {/* Error Message Display */}
                    {orderError && (
                      <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative text-sm" role="alert">
                        <strong className="font-bold">Error!</strong>
                        <span className="block sm:inline"> {orderError}</span>
                      </div>
                    )}

                    {/* Helcim Pay Button (for credit card) */}
                    {customerInfo.paymentMethod === 'credit_card' && ( // Only show if credit_card is selected
                      <div className="mb-4">
                        <HelcimPayButton
                          onPaymentSuccess={onHelcimPaymentSuccess}
                          isProcessing={appIsLoading}
                          disabled={appIsLoading || !selectedStudio ||
                            !areRequiredFieldsFilled()} // Disable if loading, no studio, or studio unavailable
                          selectedCountry={selectedCountryFromLanding}
                          total={calculateGrandTotal()}
                          setOrderSuccess={setOrderSuccess}
                          setError={setOrderError}
                          setIsProcessingOrder={setIsLoading} // Pass the main isLoading state
                        />
                      </div>
                    )}
                    <button
                      onClick={() => submitCombinedOrder('cash_on_delivery')}
                      className="w-full bg-green-600 text-white px-8 py-3 rounded-lg hover:bg-green-700 transition-colors font-medium disabled:bg-gray-400 disabled:cursor-not-allowed order-1 sm:order-2 text-sm"
                      disabled={isLoading || !selectedStudio || !areRequiredFieldsFilled()}
                    >
                      {isLoading ? (
                        <span className="flex items-center justify-center">
                          <Loader2 className="w-4 h-4 mr-2 animate-spin" /> {getTranslatedText('sending')}
                        </span>
                      ) : (
                        getTranslatedText('placeOrder')
                      )}
                    </button>
                    {/* Action Buttons */}
                    <div className="flex flex-col sm:flex-row justify-between gap-3 sm:gap-0 pt-4 border-t">
                      <button
                        onClick={goBackToCart}
                        className="w-full sm:w-auto px-6 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors order-2 sm:order-1 text-sm"
                        disabled={isLoading}
                      >
                        {getTranslatedText('back')}
                      </button>

                      {/* Place Order button - Conditional rendering based on payment method */}
                      {customerInfo.paymentMethod === 'prepaid_card' && (
                        <button
                          onClick={() => submitCombinedOrder('prepaid_card')}
                          className="w-full sm:w-auto bg-green-600 text-white px-8 py-2 rounded-lg hover:bg-green-700 transition-colors font-medium disabled:bg-gray-400 disabled:cursor-not-allowed order-1 sm:order-2 text-sm"
                          disabled={isLoading || !appliedDiscount} // Disabled if no prepaid card discount applied or studio unavailable
                        >
                          {isLoading ? (
                            <span className="flex items-center justify-center">
                              <Loader2 className="w-4 h-4 mr-2 animate-spin" /> {getTranslatedText('sending')}
                            </span>
                          ) : (
                            getTranslatedText('placeOrder')
                          )}
                        </button>
                      )}
                      {/* The HelcimPayButton itself acts as the "Place Order" button for credit card payments */}
                    </div>

                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    );


  }; // End of CartModal component




  if (showLandingPage) {
    return <LandingPage onStartPrinting={() => setShowLandingPage(false)} onCountryChange={setSelectedCountryFromLanding}
      onRegionChange={setSelectedRegion} />;
  }

  return (
    <Router>

      <Routes>
        {/* Main route - current content */}
        <Route
          path="/"
          element={
            <div className="min-h-screen bg-white pt-[80px] ">
              <Header />
              <HeroSection selectedCountryFromLanding={selectedCountryFromLanding} selectedRegion={selectedRegion} currency={currency} selectedStudio={selectedStudio} onStudioSelect={setSelectedStudio} />

              <DocumentModal
                isDocumentModalOpen={isDocumentModalOpen}
                setIsDocumentModalOpen={setIsDocumentModalOpen}
                onAddToCart={addToCart}
                pricing={pricing}
                onDocumentAddToCartSuccess={() => setIsCartModalOpen(true)}
              />
              <PhotoModal
                isPhotoModalOpen={isPhotoModalOpen}
                setIsPhotoModalOpen={setIsPhotoModalOpen}
                onAddToCart={addToCart}
                pricing={pricing}
              />

              <CartModal
                isCartModalOpen={isCartModalOpen}
                setIsCartModalOpen={setIsCartModalOpen}
                cartItems={cartItems}
                removeFromCart={removeFromCart}
                setCartItems={setCartItems}
                pricing={pricing}
                clearCart={clearCart}
                isProcessingOrder={isProcessingOrder}
                setIsProcessingOrder={setIsProcessingOrder}
                selectedCountryFromLanding={selectedCountryFromLanding}
                openPreview={openPreview}
                canadianTaxRates={canadianTaxRates}
                discountCode={discountCode}
                setDiscountCode={setDiscountCode}
                discountError={discountError}
                setDiscountError={setDiscountError}
                appliedDiscount={appliedDiscount}
                setAppliedDiscount={setAppliedDiscount}
                handleDiscountCode={handleDiscountCode}
                isLoading={isLoading}
                selectedStudio={selectedStudio}
                setSelectedStudio={setSelectedStudio}
              />
              <PreviewModal />

              {/* Render the PricingTable component */}
              <PricingTable
                isPricingModalOpen={isPricingModalOpen}
                setIsPricingModalOpen={setIsPricingModalOpen}
                currentLanguage={currentLanguage}
                setCurrentLanguage={setCurrentLanguage}
                getTranslatedText={getTranslatedText}
              />
            </div>
          }
        />




        {/* Blog routes — must be before the wildcard catch-all */}
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:postId" element={<BlogPost />} />
        {/* Redirect all other unknown routes to home */}
        <Route path="*" element={<Navigate to="/" replace />} />
        
        {/* Hidden SEO Landing Pages */}
        <Route path="/print-shipping-labels-etsy-ebay-canada" element={<SEOLandingPage slug="print-shipping-labels-etsy-ebay-canada" />} />
        <Route path="/digital-nomad-printing-solutions" element={<SEOLandingPage slug="digital-nomad-printing-solutions" />} />
        <Route path="/print-near-uoft-scarborough" element={<SEOLandingPage slug="print-near-uoft-scarborough" />} />
        <Route path="/impression-rapide-sousse-centre-ville" element={<SEOLandingPage slug="impression-rapide-sousse-centre-ville" />} />
        <Route path="/print-documents-sousse-ar" element={<SEOLandingPage slug="print-documents-sousse-ar" />} />


        {/* You can add more routes here as needed */}
        {/* <Route path="/about" element={<About />} /> */}
        {/* <Route path="/contact" element={<Contact />} /> */}
      </Routes>


    </Router>

  );
}
export default App;
